import { Record } from "../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, string_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";

export class Translation extends Record {
    constructor(enGB, fiFI, nbNO, svSE) {
        super();
        this.enGB = enGB;
        this.fiFI = fiFI;
        this.nbNO = nbNO;
        this.svSE = svSE;
    }
}

export function Translation$reflection() {
    return record_type("Utilities.Translations.Translation", [], Translation, () => [["enGB", string_type], ["fiFI", string_type], ["nbNO", string_type], ["svSE", string_type]]);
}

export const AcceptedCreditCheckIsMissing = new Translation("Missing approved credit check", "", "Mangler godkjent kredittsjekk", "Godkänd kreditkontroll saknas");

export const AccountingVAT = new Translation("VAT accounting", "", "mva-regnskap", "Momsredovisning");

export const ActivationPending = new Translation("Pending ", "", "Avventer aktivering", "Inväntar aktivering");

export const Active = new Translation("Active ", "", "Aktiv", "Aktiv");

export const ActiveSince = new Translation("Active since", "", "Aktiv siden", "Aktivt sedan");

export const Address_Value = new Translation("Address", "", "Adresse", "Adress");

export const Address_CareOf = new Translation("c/o", "", "c/o", "c/o");

export const Address_Street = new Translation("Street", "", "Postadresse", "Postadress");

export const Address_ZipAndCity = new Translation("City", "", "Postnr/ Poststed", "Postnr/-ort");

export const Admin = new Translation("Admin", "", "Admin", "Admin");

export const AgreementConfirmedViaFenixBy = new Translation("Confirmed via Fenix by", "", "Bekreftet via Fenix av", "Bekräftat via Fenix av");

export const Agreements = new Translation("Agreements", "", "Avtale", "Avtal");

export const AllowedAge = new Translation("Allowed age", "", "Alder tillatt", "Tillåten ålder");

export const Amount = new Translation("Amount", "", "Beløp", "Belopp");

export const ApproveContract = new Translation("Approve mortgage manually", "", "Godkjenn belåning manuelt", "Godkänn belåning manuellt");

export const AreYouSure = new Translation("Are you sure?", "", "Er du sikker?", "Är du säker?");

export const AvailableCount = new Translation("Available Count", "", "Tilgjengelig antall", "Tillgängligt antal");

export const BackTo = new Translation("Back to", "", "Tilbake til", "Tillbaka till");

export const BearerType = new Translation("Call type", "", "Anropstype", "Samtalstyp");

export const Billing_Actions = new Translation("Actions", "", "Handlinger", "Åtgärder");

export const Billing_AggregrateFees = new Translation("Aggregate Fees regardless of fee text", "", "Samlede avgifter uavhengig av gebyrtekst", "Aggregera avgifter oberoende av avgiftstext");

export const Billing_Approved = new Translation("Approval in progress", "", "Godkjenning pågår", "Godkännande pågår");

export const Billing_ApprovedBy = new Translation("Approved by", "", "Godkjent av", "Godkändes av");

export const Billing_Autogiro = new Translation("Direct debit", "", "Avtalegiro", "Autogiro");

export const Billing_BackToBilling = new Translation("Back to billing", "", "Tilbake til fakturering", "Tillbaka till fakturering");

export const Billing_Batch = new Translation("Invoice group", "", "Fakturagruppe", "Fakturagrupp");

export const Billing_BillingFileContents_Value = new Translation("Billing file contents", "", "Faktureringsfilens innhold", "Faktureringsfilens innehåll");

export const Billing_BillingFileContents_Fees = new Translation("Fees", "", "Gebyr", "Avgifter");

export const Billing_BillingFileContents_InvoiceFee = new Translation("Invoice fee", "", "Fakturagebyr", "Fakturaavgift");

export const Billing_BillingFileContents_NextInvoice = new Translation("Next invoice", "", "Neste faktura", "Nästa faktura");

export const Billing_BillingFileContents_NoSearchResult = new Translation("No search results.\\\\n\\\\n Note that the search starts from the current invoice onwards, go to the first invoice to do a full search.", "", "Ingen søkeresultater.\\\\n\\\\n Merk at søket starter fra gjeldende faktura og utover. Gå til den første fakturaen for å gjøre et fullstendig søk.", "Inget sökresultat.\\\\n\\\\n Notera att söket letar från och med den nuvarande fakturan och framåt, gå till första fakturan för att göra en fullständig sökning.");

export const Billing_BillingFileContents_PreviousInvoice = new Translation("Previous invoice", "", "Forrige faktura", "Föregående faktura");

export const Billing_BillingFileContents_Specification = new Translation("Specification", "", "Spesifikasjon", "Specifikation");

export const Billing_Confirmation_InnvoiceApprove = new Translation("Are you sure you want to approve the invoicing, this cannot be regretted.", "", "Er du sikker på at du vil godkjenne faktureringen, kan dette ikke beklages.", "Är du säker på att du vill godkänna fakturering, detta kan inte ångras");

export const Billing_Confirmation_InnvoiceDays = new Translation("Invoice date is:", "", "Fakturadato er är:", "Fakturadatum är:");

export const Billing_Confirmation_InnvoiceHeader = new Translation("Skarp invoice", "", "Skarp fakturering", "Skarp fakturering");

export const Billing_Confirmation_InnvoiceMessage = new Translation("Are you sure you want to do skarp invoicing?", "", "Er du sikker på at du vil kjøre skarp fakturering?", "Är du säker på att du vill köra skarp fakturering?");

export const Billing_Confirmation_InnvoiceNote1 = new Translation("Note that invoice date is", "", "Merk at fakturadato er", "Notera att fakturadatum är");

export const Billing_Confirmation_InnvoiceNote2 = new Translation("days from today!", "", "dager fra i dag!", "dagar från idag!");

export const Billing_Confirmation_InnvoiceNote3 = new Translation("Note that an invoice already is done thig month:", "", "Merk at en fakturing allerede er ferdig denne måneden:", "Notera att en fakturering redan har gjorts denna månad:");

export const Billing_Contracts = new Translation("Number of Contracts", "", "Antall kontrakter", "Antal kontrakt");

export const Billing_DiagramTotal = new Translation("Total", "", "Totalt", "Totalt");

export const Billing_Digipost = new Translation("Digipost", "", "Digipost", "Digipost");

export const Billing_DirectInvoice_Value = new Translation("Create direct invoice", "", "Opprett direktefaktura", "Skapa direktfaktura");

export const Billing_DirectInvoice_AllFeesAreInvoiced = new Translation("All fees are invoiced", "", "Alle gebyrer faktureres", "Alla avgifter faktureras");

export const Billing_DirectInvoice_AllFeesAreInvoicedInfo = new Translation("This means that all charges ready for invoicing will be invoiced.", "", "Dette betyr at alle gebyrer klare for fakturering vil bli fakturert.", "Det betyder att alla avgifter redo för fakturering kommer faktureras.");

export const Billing_DirectInvoice_CampaignCode = new Translation("Information on the invoice", "", "Informasjon på fakturaen", "Information på fakturan");

export const Billing_DirectInvoice_CampaignCodeInfo = new Translation("You can a predefined information that appears on the invoice. Note that this information replaces the standard information (banner) on the invoice.", "", "Du kan en forhåndsdefinert informasjon som vises på fakturaen. Merk at denne informasjonen erstatter standardinformasjonen (banneret) på fakturaen.", "Du kan en fördefinierad information som visas på fakturan. Notera att denna information ersätter standard informationen (bannern) på fakturan.");

export const Billing_DirectInvoice_CampignCodeStandard = new Translation("Default", "", "Standard", "Standard");

export const Billing_DirectInvoice_Created = new Translation("Direct invoice created", "", "Direktefaktura opprettet", "Direktfaktura skapad");

export const Billing_DirectInvoice_CreateInvoice = new Translation("Create Invoice", "", "Opprett faktura", "Skapa faktura");

export const Billing_DirectInvoice_DirectDebitDistributed = new Translation("The customer has chosen direct debit without distribution of the invoice. Should this invoice be distributed anyway?", "", "Kunden har valgt avtalegiro uten distribusjon av faktura. Skal denne fakturaen distribueres likevel?", "Kunden har valt autogiro utan distribution av fakturan. Ska denna faktura distribueras ändå?");

export const Billing_DirectInvoice_InfoText = new Translation("A direct invoice means that the customer is invoiced today, i.e. not with standard invoicing which is normally monthly. \\\\n\\\\nA direct invoice can be both a regular invoice and a credit invoice. \\\\n\\\\nThe direct invoice is created at 17:00 (Swedish time). \\\\n\\\\nIf it is created after 17:00, the invoice will be sent the next day.", "", "Direktefaktura betyr at kunden faktureres i dag, det vil si ikke med standardfakturering som normalt er månedlig. \\\\n\\\\nEn direktefaktura kan være både en vanlig faktura og en kredittfaktura. \\\\n\\\\nDirektefakturaen opprettes kl. 17:00 (svensk tid). \\\\n\\\\nHvis den opprettes etter kl. 17:00, sendes fakturaen dagen etter.", "En direktfaktura betyder att kunden faktureras idag, dvs inte med standardfakturering som normalt är månadsvis. \\\\n\\\\nEn direktfaktura kan vara både en vanlig faktura och en kreditfaktura. \\\\n\\\\nDirektfakturan skapas kl 17:00 (Svensk tid). \\\\n\\\\nSkapas den efter kl 17:00 kommer fakturan skickas nästkommande dag.");

export const Billing_DirectInvoice_InvoiceAmount = new Translation("Amount (incl VAT)", "", "Beløp (inkl. mva)", "Belopp (inkl. moms)");

export const Billing_DirectInvoice_InvoiceDate = new Translation("Invoice Date", "", "Fakturadato", "Fakturadatum");

export const Billing_DirectInvoice_InvoiceFee = new Translation("Invoice fee", "", "Fakturagebyr", "Fakturaavgift");

export const Billing_DirectInvoice_MinimumAmountWarning1 = new Translation("The amount is lower than the minimum amount for an invoice", "", "Beløpet er lavere enn minimumsbeløpet for en faktura", "Beloppet är lägre än minimibeloppet för en faktura");

export const Billing_DirectInvoice_MinimumAmountWarning2 = new Translation("kr. Do you want to invoice anyway?", "", "kr. Vil du fakturere likevel?", "kr. Vill du fakturera ändå?");

export const Billing_DirectInvoice_Remove_Value = new Translation("Remove direct invoice", "", "Fjern direktefaktura", "Ta bort direktfaktura");

export const Billing_DirectInvoice_Remove_Information = new Translation("Are you sure you want to remove the direct invoicing?", "", "Er du sikker på at du vil fjerne direktefaktureringen?", "Är du säker på att du vill ta bort direktfaktureringen?");

export const Billing_DirectInvoice_SelectFeesToInvoiced = new Translation("Select the fees to be invoiced", "", "Velg gebyrene som skal faktureres", "Välj de avgifter som ska faktureras");

export const Billing_DirectInvoice_SelectFeesToInvoicedInfo = new Translation("Here you can specifically select one or more charges to be included in the direct invoice.", "", "Her kan du spesifikt velge en eller flere avgifter som skal inkluderes i direktefakturaen.", "Här kan du specifikt välja en eller flera avgifter som ska vara med på direktfakturan.");

export const Billing_DistributionCodeText = new Translation("Distribution code", "", "Distribusjonskode", "Distributionskod");

export const Billing_DuplicateText = new Translation("Found duplicate invoicenumbers", "", "Duplikat av fakturanummer funnet", "Duplicerad fakturanummerserie hittades");

export const Billing_Duration = new Translation("Duration", "", "Tid", "Tid");

export const Billing_EHF = new Translation("EHF", "", "EHF", "EHF");

export const Billing_Einvoice = new Translation("E-Invoice", "", "eFaktura", "E-faktura");

export const Billing_Email = new Translation("E-mail", "", "E-post", "E-post");

export const Billing_ExclVAT = new Translation("Excl VAT", "", "Ekskl. mva", "Exkl moms");

export const Billing_ExpDate_Value = new Translation("Expiration Date", "", "Forfallsdato", "Förfallodatum");

export const Billing_ExpDate_DebtCollection1 = new Translation("The collection request is sent", "", "Inkassoforespørsel sendes", "Inkassokravet skickas");

export const Billing_ExpDate_Reminder1 = new Translation("Reminder sent", "", "Påminnelse sendt", "Påminnelse skickas ut");

export const Billing_ExpDate_Reminder2 = new Translation("days after the due date", "", "dager etter forfall", "dagar efter förfallodagen");

export const Billing_Finished = new Translation("Done", "", "Ferdig", "Slutförd");

export const Billing_FixItText = new Translation("Fix them before invoicing", "", "Løs problemer før fakturering", "Se till att dessa är åtgärdade innan fakturering");

export const Billing_FoundProblem = new Translation("Found Problems", "", "Problem oppstått", "Hittade problem");

export const Billing_GenerateRealInvoice = new Translation("Start Real Invoice", "", "Start skarp faktura", "Starta skarp faktura");

export const Billing_GenerateTestInvoice = new Translation("Start Test Invoice", "", "Start testfaktura", "Starta testfaktura");

export const Billing_GoToOldBilling = new Translation("Go to old billing page", "", "Gå til den gamle faktureringssiden", "Gå till gamla Faktureringssidan");

export const Billing_GoToReceiptS1 = new Translation("Go to Receipt S1", "", "Gå til Kvittering S1", "Gå till Kvittens S1");

export const Billing_ImportedOmnichannel = new Translation("import distribution code from Omnichannel completed", "", "import distribusjonskode fra Omnichannel fullført", "Importera distributionskod från Omnichannel slutförd");

export const Billing_InclVAT = new Translation("In total", "", "Totalt", "Totalt");

export const Billing_Inconsistent = new Translation("Inconsistent status", "", "Inkonsistent status", "Inkonsistent status");

export const Billing_InternError = new Translation("Internal system error during approval", "", "Intern system feil ved godkjennelse", "Internt systemfel vid godkännandet");

export const Billing_Invoice_Value = new Translation("Invoice", "", "Faktura", "Faktura");

export const Billing_Invoice_Approve = new Translation("Approve", "", "Godkjenn", "Godkänn");

export const Billing_Invoice_Approving = new Translation("Approving", "", "Godkjenner", "Godkänner");

export const Billing_Invoice_BackToFirstInvoice = new Translation("Back to the first invoice", "", "Tilbake til første faktura", "Tillbaka till första fakturan");

export const Billing_Invoice_FileNotExist = new Translation("The file does not exist!", "", "Filen eksisterer ikke!", "Filen finns inte!");

export const Billing_Invoice_GetInfoAllInvoices = new Translation("Get info about all invoices", "", "Få informasjon om alle fakturaer", "Hämta info om alla fakturor");

export const Billing_Invoice_GetInfoWholesaleFeeOverview = new Translation("Get information about wholesale fee overview", "", "Få informasjon om grossistavgiftsoversikt", "Få information om grossistavgiftsöversikt");

export const Billing_Invoice_GetInvoiceXmlFile = new Translation("Get invoice xml file", "", "Få faktura xml-fil", "Få faktura xml-fil");

export const Billing_Invoice_Next = new Translation("Next", "", "Neste", "Nästa");

export const Billing_Invoice_NoFilesFound = new Translation("No files found.", "", "Ingen filer funnet.", "Hittade inga filer.");

export const Billing_Invoice_NoValidFilesFound = new Translation("Found meta data about files, but these files no longer exist (may be archived).", "", "Fant metadata om filer, men disse filene eksisterer ikke lenger (kan ha blitt arkivert).", "Hittade metadata om filer, men dessa filer finns inte längre (kan vara arkiverade).");

export const Billing_Invoice_Restore = new Translation("Restore", "", "Gjenopprett", "Återställ");

export const Billing_Invoice_Restoring = new Translation("Restoring", "", "Gjenopprette", "Återställer");

export const Billing_Invoice_Show = new Translation("Show", "", "Vis", "Visa");

export const Billing_Invoice_ToInvocing = new Translation("To Invoicing", "", "Til fakturering", "Till fakturering");

export const Billing_InvoiceAmountOverTime = new Translation("Invoice amount over time", "", "Fakturabeløp over tid", "Fakturabelopp över tid");

export const Billing_InvoiceAmountToPay = new Translation("Invoice amount to pay", "", "Fakturabeløp å betale", "Fakturabelopp att betala");

export const Billing_InvoiceDate = new Translation("Invoice Date", "", "Fakturadato", "Fakturadatum");

export const Billing_InvoiceEnd = new Translation("Invoice Period End", "", "Fakturaperioden avsluttes", "Fakturaperioden slutar");

export const Billing_InvoiceGeneration = new Translation("Invoice generation", "", "Generering av faktura", "Fakturakörningar");

export const Billing_Invoices = new Translation("Invoices", "", "Fakturaer", "Fakturor");

export const Billing_InvoiceSettings = new Translation("Invoice Settings", "", "Fakturainnstillinger", "Fakturainställningar");

export const Billing_Invoicing = new Translation("Invoicing", "", "Fakturering", "Fakturering");

export const Billing_NetDays = new Translation("Net Days", "", "Nettodager", "Nettodagar");

export const Billing_NetDaysInfo = new Translation("Net days is the number of days that need to have passed between the end of the billing period and when you invoice.", "", "Netto dager er antall dager som må ha gått mellom slutten av faktureringsperioden og når du fakturerer.", "Nettodagar är det antal dagar som behöver ha gått mellan fakturaperiodens slut och när man fakturerar.");

export const Billing_noDistribution = new Translation("No distribution", "", "Ingen distribusjon", "Ingen distribution");

export const Billing_OngoingRatings = new Translation("ongoing ratings", "", "løpende ratings", "pågående ratings");

export const Billing_Paper = new Translation("Paper", "", "Papir", "Papper");

export const Billing_Peppol = new Translation("Peppol", "", "EHF", "Peppol");

export const Billing_PhoneNumbers = new Translation("Phone Numbers", "", "Telefonnummer", "Telefonnummer");

export const Billing_ProblemText = new Translation("Found some problems", "", "Problem oppstått", "Hittade några problem");

export const Billing_processRegretted = new Translation("The process is undone", "", "Process ferdig", "Processen ångras");

export const Billing_Queued = new Translation("Placed in a queue", "", "Plassert i kø", "Placerad i kö");

export const Billing_RawData = new Translation("Raw data", "", "Rådata", "Rådata");

export const Billing_ReadData = new Translation("Read Data ...", "", "Leser data", "Läser data...");

export const Billing_Ready = new Translation("Marked Ready", "", "Klar", "Klarmarkerades");

export const Billing_ReceiptS1_CompanyDetails = new Translation("Company Details", "", "Bedriftsinformasjon", "Företagsinformation");

export const Billing_ReceiptS1_ErroneousOrgNr = new Translation("Erroneous OrgNr", "", "Feil OrgNr", "Felaktiga OrgNr");

export const Billing_ReceiptS1_FileContent = new Translation("File contents", "", "Filinnhold", "Filinnehåll");

export const Billing_ReceiptS1_HandlerInfo = new Translation("Administrator", "", "Saksbehandler", "Handläggare");

export const Billing_ReceiptS1_ReceiptFiles = new Translation("Receipt files", "", "Kvitteringsfiler", "Kvittensfiler");

export const Billing_ReceiptS1_Reference = new Translation("Reference", "", "Referanse", "Referens");

export const Billing_ReceiptS1_SelectFile = new Translation("Please select a file to view its content", "", "Velg en fil for å se innholdet", "Välj en fil för att se dess innehåll");

export const Billing_ReceiptS1_ServiceEInvoice = new Translation("E-Invoices", "", "E-fakturor", "E-fakturor");

export const Billing_ReceiptS1_ServiceEmail = new Translation("Via Email", "", "Via e-post", "Via e-post");

export const Billing_ReceiptS1_ServiceInvoice = new Translation("Invoice Service", "", "Fakturaservice", "Fakturaservice");

export const Billing_ReceiptS1_ServiceLedger = new Translation("Ledger service", "", "Reskontroservice", "Reskontraservice");

export const Billing_ReceiptS1_ServicePeppol = new Translation("Via peppol", "", "Via peppol", "Via peppol");

export const Billing_Regretted = new Translation("Undoed", "", "Angret", "Ångrades");

export const Billing_ReminderFeeSent = new Translation("Sent", "", "Sendt", "Skickad");

export const Billing_ReminderFeesImpose = new Translation("Reminder fees are imposed on the next invoice", "", "Påminnelsesgebyr pålegges neste faktura", "Påminnelseavgifter påförs nästkommande faktura");

export const Billing_Reset = new Translation("Reset by", "", "Tilbakestilt av", "Återställdes av");

export const Billing_Run = new Translation("Go", "", "Kjør", "Kör");

export const Billing_Save = new Translation("Save", "", "Lagre", "Spara");

export const Billing_SaveBtn2 = new Translation("Save", "", "Lagre", "Spara");

export const Billing_SeeError = new Translation("See error message", "", "Se feilmelding", "Se felmeddelande");

export const Billing_Sharp = new Translation("Sharp", "", "Skarp", "Skarp");

export const Billing_Start = new Translation("Started", "", "Startet", "Startade");

export const Billing_StartBy = new Translation("Started By", "", "Startet av", "Startades av");

export const Billing_Started = new Translation("Ongoing", "", "Pågående", "Pågående");

export const Billing_Statistics_Value = new Translation("Statistics", "", "Statistikk", "Statistik");

export const Billing_Statistics_DigiPost = new Translation("DigiPost Invoices", "", "Digipost-fakturaer", "Digipostfakturor");

export const Billing_Statistics_DirectDebitDistribution = new Translation("Direct debit distribution", "", "Direkte belastningsdistribusjon", "Autogirodistribution");

export const Billing_Statistics_EInvoice = new Translation("E-Invoices", "", "E-fakturaer", "E-fakturor");

export const Billing_Statistics_EInvoiceEHF = new Translation("E-Invoice (EHF)", "", "E-faktura (EHF)", "E-faktura (EHF)");

export const Billing_Statistics_Email = new Translation("Email Invoices", "", "E-postfakturaer", "E-postfakturor");

export const Billing_Statistics_InvoiceOverview = new Translation("Invoice Overview", "", "Fakturaoversikt", "Fakturaöversikt");

export const Billing_Statistics_No = new Translation("No", "", "Nei", "Nej");

export const Billing_Statistics_NoDirectDebit = new Translation("No Direct debit", "", "Ingen avtalegiro", "Ingen autogiro");

export const Billing_Statistics_NoStatisticsData = new Translation("No statistics data", "", "Ingen statistiske data", "Ingen statistikdata");

export const Billing_Statistics_Paper = new Translation("Paper Invoices", "", "Papirfakturaer", "Pappersfakturor");

export const Billing_Statistics_Peppol = new Translation("Peppol Invoices", "", "Peppol-fakturaer", "Peppolfakturor");

export const Billing_Statistics_Total = new Translation("Total", "", "Total", "Totalt");

export const Billing_Statistics_WithDirectDebitNoNotification = new Translation("With direct debit (without notification)", "", "Med avtalegiro (uten varsel)", "Med autogiro (utan avisering)");

export const Billing_Statistics_WithDirectDebitNotification = new Translation("With direct debit (with notification)", "", "Med avtalegiro (med varsel)", "Med autogiro (med avisering)");

export const Billing_Statistics_WithoutDirectDebit = new Translation("Without direct debit", "", "Uten avtalegiro", "Utan autogiro");

export const Billing_Statistics_Yes = new Translation("Yes", "", "Ja", "Ja");

export const Billing_Status = new Translation("Status", "", "Status", "Status");

export const Billing_SystemError = new Translation("Internal system error", "", "Intern systemfeil", "Internt systemfel");

export const Billing_terms = new Translation("Payment Terms", "", "Betalingsvilkår", "Betalningsvillkor");

export const Billing_TermsInfo = new Translation("Payment terms refer to the number of days within which the invoice must be paid.\\\\n\\\\nThis is a standard value for all customers. Payment terms can be set specifically for a customer and then this will be used for the selected customer.\\\\n\\\\nExample: Payment terms 30 days means that the invoice must be paid within 30 days.", "", "Betalingsbetingelser refererer til antall dager som fakturaen må betales innen.\\\\n\\\\nDet er en standardverdi for alle kunder. Betalingsbetingelser kan settes spesifikt for en kunde og så vil dette bli brukt for den valgte kunden.\\\\n\\\\nEksempel: Betalingsbetingelser 30 dager betyr at fakturaen må betales innen 30 dager.", "Betalningsvillkor avser det antal dagar inom vilka fakturan ska betalas.\\\\n\\\\nDet är ett standardvärde för alla kunder. Betalningsvillkor kan sättas specifikt på en kund och då kommer detta användas för vald kund.\\\\n\\\\nExempel: Betalningsvillkor 30 dagar innebär att fakturan ska betalas inom 30 dagar.");

export const Billing_Test = new Translation("Test", "", "Test", "Test");

export const Billing_Time = new Translation("Time", "", "Tid", "Tid");

export const Billing_Trafic = new Translation("Consumption", "", "Forbruk", "Förbrukning");

export const Billing_UnableToParse = new Translation("Could not read the file into structured format", "", "Kunne ikke lese filen i strukturert format", "Kunde inte läsa filen till strukturerat format");

export const Billing_VAT = new Translation("VAT", "", "Mva", "Moms");

export const Billing_ViewBatchContents = new Translation("View Batch Contents", "", "Se batchinnhold", "Visa batchinnehåll");

export const Billing_ViewBatchStatistics = new Translation("View Batch Statistics", "", "Vis batchstatistikk", "Visa batchstatistik");

export const BillingCharge = new Translation("Price (excl VAT)", "", "Pris (ekskl. mva)", "Pris (exkl. moms)");

export const BillingChargeVat = new Translation("Price (incl VAT)", "", "Pris (inkl. mva)", "Pris (inkl. moms)");

export const BNumber = new Translation("B number ", "", "B-nummer", "B-nummer");

export const bool_false = new Translation("No", "", "Ikke", "Nej");

export const bool_true = new Translation("Yes", "", "Ja", "Ja");

export const BoundTo = new Translation("Included in", "", "Bundet til", "Bundet till");

export const ChooseTemplate = new Translation("Choose template", "", "Velg mal...", "Välj mall...");

export const Client_Settings_AccountNo = new Translation("Chart of accounts", "", "kontooversikt", "Kontoplan");

export const Client_Settings_AccountNumber_CostCentre = new Translation("Cost Centre", "", "Kostnadssted", "Kostnadscenter");

export const Client_Settings_AccountNumber_Description = new Translation("Description", "", "Beskrivelse", "Beskrivning");

export const Client_Settings_AdvanceSettings_Create = new Translation("Create", "", "Skape", "Skapa");

export const Client_Settings_CampaignCode_CampaignCode = new Translation("Campaign Code", "", "Kampanjekode", "Kampanjkod");

export const Client_Settings_CampaignCode_CampaignCodeDescription = new Translation("Campaign Code Description", "", "Kampanjekodebeskrivelse", "Kampanjkod Beskrivning");

export const Client_Settings_CustomerGroup_Value = new Translation("Customer Group", "", "Kundegruppe", "Kundgrupp");

export const Client_Settings_CustomerGroup_Name = new Translation("Name", "", "Navn", "Namn");

export const Client_Settings_DefaultValue = new Translation("Default Value", "", "Standardverdi", "Standardvärde");

export const Client_Settings_FrozenMonthFee_Value = new Translation("Frozen Month Fee", "", "Frossen månedsavgift", "Avgift för fryst månad");

export const Client_Settings_FrozenMonthFee_FeeDescription = new Translation("Fee Description", "", "Gebyrbeskrivelse", "Avgiftsbeskrivning");

export const Client_Settings_InvoiceCalendar_Value = new Translation("Invoice Calendar", "", "Fakturakalender", "Fakturakalender");

export const Client_Settings_InvoiceCalendar_InvoiceDate = new Translation("Invoice Date", "", "Fakturadato", "Fakturadatum");

export const Client_Settings_InvoiceCalendar_InvoiceRunDate = new Translation("Invoice run date", "", "Faktura utførelsesdato", "Fakturans körningsdatum");

export const Client_Settings_InvoiceCalendar_Month = new Translation("Month", "", "Måned", "Månad");

export const Client_Settings_InvoiceCalendar_Year = new Translation("Year", "", "År", "År");

export const Client_Settings_InvoiceFee_Value = new Translation("Invoice Fee", "", "Fakturaavgift", "Fakturavgift");

export const Client_Settings_InvoiceFee_Description = new Translation("Description", "", "Beskrivelse", "Beskrivning");

export const Client_Settings_InvoiceFee_Distribution = new Translation("Distribution", "", "Distribusjon", "Distribution");

export const Client_Settings_InvoiceFee_IncludeFeeOnAutogiroVarsel = new Translation("Include on autogiro", "", "Inkluder på autogiro", "Inkludera på autogiro");

export const Client_Settings_InvoiceFee_InvoiceeType = new Translation("Customer type", "", "Kundetype", "Kundtyp");

export const Client_Settings_InvoiceFee_PriceExclVat = new Translation("Price ExclVat", "", "Pris ekskl. mva", "Pris exkl. moms");

export const Client_Settings_InvoiceFee_VatRatePercent = new Translation("Vat %", "", "Mva %", "Moms %");

export const Client_Settings_Notifications = new Translation("Client settings notifications", "", "Innstillinger UG-varsler", "Inställningar UG-meddelanden");

export const Client_Settings_ObjectCode_Value = new Translation("Object code", "", "Objektkode", "Objektkod");

export const Client_Settings_ObjectCode_ClientObjectNr = new Translation("Object Code", "", "Objektkode", "Objektkod");

export const Client_Settings_ObjectCode_ObjectDescription = new Translation("Description", "", "Beskrivelse", "Beskrivning");

export const Client_Settings_Setting = new Translation("Client Settings", "", "Innstillinger UG", "Inställningar UG");

export const Client_Settings_SettingGroup = new Translation("Settings Group", "", "Innstillingsgruppe", "Inställningsgrupp");

export const Client_Settings_UnpaidInvoiceReminderSetting_Value = new Translation("Unpaid invoice reminder setting", "", "Innstilling for ubetalt fakturapåminnelse", "Inställning för obetald fakturapåminnelse");

export const Client_Settings_UnpaidInvoiceReminderSetting_EmailBodyTemplate = new Translation("Mail body", "", "e-posttekst", "e-posttext");

export const Client_Settings_UnpaidInvoiceReminderSetting_EmailSubjectTemplate = new Translation("Email subject", "", "E-post Emne", "E-postämne");

export const Client_Settings_UnpaidInvoiceReminderSetting_IncludeFeeOnAutogiroVarsel = new Translation("Include on autogiro", "", "Inkluder på autogiro", "Inkludera på autogiro");

export const Client_Settings_UnpaidInvoiceReminderSetting_ReminderDaysAfterDueDate = new Translation("Reminder days after the invoice due date", "", "Påminnelse dager etter fakturaforfall", "Påminnelse dagar efter fakturans förfallodatum");

export const Client_Settings_UnpaidInvoiceReminderSetting_SMSTemplate = new Translation("SMS mall", "", "SMS mal", "SMS template");

export const Common_AccountNo = new Translation("Account No", "", "Kontonummer", "Kontonummer");

export const Common_Activate = new Translation("Activate", "", "Aktivere", "Aktivera");

export const Common_Activates = new Translation("Activates", "", "Aktiveres", "Aktiveras");

export const Common_Active = new Translation("Active", "", "Aktiv", "Aktiv");

export const Common_ActiveFrom = new Translation("Active from", "", "Aktiv fra", "Aktiv från");

export const Common_ActiveTo = new Translation("Active to", "", "Aktiv for", "Aktivt till");

export const Common_ActiveWithEndDate = new Translation("Active with end date", "", "Aktiv med sluttdato", "Aktiv med slutdatum");

export const Common_Add = new Translation("Add", "", "Legg til", "Lägg till");

export const Common_Address = new Translation("Address", "", "Adresse", "Adress");

export const Common_After = new Translation("After", "", "Etter", "Efter");

export const Common_All = new Translation("All", "", "Alle", "Alla");

export const Common_AmountExclVat = new Translation("Amount (excl.VAT)", "", "Beløp (ekskl.mva)", "Belopp (exkl.moms)");

export const Common_AmountInclVat = new Translation("Amount (incl.VAT)", "", "Beløp (inkl.mva)", "Belopp (inkl.moms)");

export const Common_Archive = new Translation("Archive", "", "Arkivert", "Arkivera");

export const Common_AreYouSure = new Translation("Are you sure?", "", "Er du sikker?", "Är du säker?");

export const Common_Attribute = new Translation("Attribute", "", "Attributt", "Attribut");

export const Common_Back = new Translation("Back", "", "Tilbake", "Tillbaka");

export const Common_Before = new Translation("Before", "", "Før", "Före");

export const Common_Cancel = new Translation("Cancel", "", "Avbryt", "Avbryt");

export const Common_Cancelled = new Translation("Cancelled", "", "Avsluttet", "Avslutad");

export const Common_Change = new Translation("Change", "", "Endring", "Ändra");

export const Common_Changing = new Translation("Changing", "", "Endrer", "Ändrar");

export const Common_ChangingClient = new Translation("Changing Client", "", "Bytter OG", "Byter UG");

export const Common_Choose = new Translation("Choose", "", "Velge", "Välj");

export const Common_ChooseNumber = new Translation("Choose number", "", "Velg nummer", "Välj nummer");

export const Common_ChooseProductType = new Translation("Choose product type", "", "Velg produkttype", "Välj produkttyp");

export const Common_ChooseSubscription = new Translation("Choose subscription type", "", "Velg abonnementsskjema", "Välj abonnemangsform");

export const Common_City = new Translation("City", "", "Postkontor", "Postort");

export const Common_Close = new Translation("Close", "", "Lukk", "Stäng");

export const Common_Code = new Translation("Code", "", "Kode", "Kod");

export const Common_Confirm = new Translation("Confirm", "", "Bekrefte", "Bekräfta");

export const Common_ContactDetails = new Translation("Contact details", "", "Kontaktinformasjon", "Kontaktuppgifter");

export const Common_Continue = new Translation("Continue", "", "Fortsette", "Fortsätt");

export const Common_Contract = new Translation("Contract", "", "Kontrakt", "Kontrakt");

export const Common_ContractType = new Translation("Contract type", "", "Abonnementsskjema", "Abonnemangsform");

export const Common_Country = new Translation("Country", "", "Land", "Land");

export const Common_Create = new Translation("Create", "", "Skape", "Skapa");

export const Common_CreateNew = new Translation("Create new", "", "Skape ny", "Skapa ny");

export const Common_CreateSubscription = new Translation("Create subscription", "", "Opprett abonnement", "Skapa abonnemang");

export const Common_Creating = new Translation("Creating", "", "Skaper", "Skapar");

export const Common_Customer = new Translation("Customer", "", "Kund", "Kund");

export const Common_Customers = new Translation("Customers", "", "Kunder", "Kunder");

export const Common_Data = new Translation("Data", "", "Data", "Data");

export const Common_Date = new Translation("Date", "", "Dato", "Datum");

export const Common_Day = new Translation("Day", "", "Dag", "Dag");

export const Common_Days = new Translation("Days", "", "Dager", "Dagar");

export const Common_Deactivate = new Translation("Deactivate", "", "Deaktiver", "Deaktivera");

export const Common_DeactivateNumber = new Translation("Deactivate number", "", "Deaktiver nummer", "Deaktivera nummer");

export const Common_Device = new Translation("Device", "", "Enhet", "Enhet");

export const Common_DirectDebit = new Translation("Direct debit", "", "Avtalegiro", "Autogiro");

export const Common_Documents = new Translation("Documents", "Asiakirjat", "Dokument", "Dokument");

export const Common_Download = new Translation("Download", "", "Last ned", "Ladda ner");

export const Common_DownloadTo = new Translation("Download to", "", "Last ned til Excel", "Hämta till");

export const Common_Edit = new Translation("Edit", "", "Endring", "Ändra");

export const Common_Email = new Translation("E-mail", "", "E-post", "E-post");

export const Common_EndDate = new Translation("End date", "", "Sluttdato", "Slutdatum");

export const Common_Ended = new Translation("Ended", "", "Ferdig", "Avslutades");

export const Common_Ends = new Translation("Ends", "", "Avsluttet", "Avslutas");

export const Common_EndUser = new Translation("End User", "", "Sluttbruker", "Slutanvändare");

export const Common_Error = new Translation("Error", "", "Feil", "Fel");

export const Common_ErrorMessage = new Translation("Error message", "", "Feilmelding", "Felmeddelande");

export const Common_ExclVat = new Translation("Excl.VAT", "", "Ekskl.mva", "Exkl.moms");

export const Common_FeeNumber = new Translation("Fee number", "", "Gebyrnummer", "Avgiftsnummer");

export const Common_FeeText = new Translation("Description", "", "Avgiftstekst", "Avgiftstext");

export const Common_Filter = new Translation("Filter", "", "Filter", "Filter");

export const Common_From = new Translation("From", "", "Fra", "Från");

export const Common_Inactive = new Translation("Inactive", "", "Inaktiv", "Inaktiv");

export const Common_InclVat = new Translation("Incl.VAT", "", "Inkl.mva", "Inkl.moms");

export const Common_Inconsistent = new Translation("Inconsistent", "", "Uoverensstemmende", "Inkonsekvent");

export const Common_Inportation = new Translation("Inportation", "", "Inportering", "Inportering");

export const Common_Invoice = new Translation("Invoice", "Lasku", "Faktura", "Faktura");

export const Common_InvoiceeNr = new Translation("Customer number", "", "Kundenummer", "Kundnummer");

export const Common_InvoiceNr = new Translation("Invoice no", "Lasku nro", "Faktura nr", "Faktura nr");

export const Common_Invoices = new Translation("Invoices", "", "Fakturaer", "Fakturor");

export const Common_Language = new Translation("Language", "", "Språk", "Språk");

export const Common_Level = new Translation("Level", "", "Nivå", "Nivå");

export const Common_Message = new Translation("Message", "", "Beskjed", "Meddelande");

export const Common_Minutes = new Translation("minutes", "", "minutter", "minuter");

export const Common_MissingPrivileges = new Translation("You do not have permission to view this page", "", "Du har ikke tillatelse til å se denne siden", "Du saknar behörighet för att visa denna sidan");

export const Common_Month_Value = new Translation("month", "", "måned", "månad");

export const Common_Month_April = new Translation("April", "", "april", "April");

export const Common_Month_August = new Translation("August", "", "august", "Augusti");

export const Common_Month_December = new Translation("December", "", "desember", "December");

export const Common_Month_February = new Translation("February", "", "februar", "Februari");

export const Common_Month_January = new Translation("January", "", "januar", "Januari");

export const Common_Month_July = new Translation("July", "", "juli", "Juli");

export const Common_Month_June = new Translation("June", "", "juni", "Juni");

export const Common_Month_March = new Translation("March", "", "mars", "Mars");

export const Common_Month_May = new Translation("May", "", "mai", "Maj");

export const Common_Month_November = new Translation("November", "", "november", "November");

export const Common_Month_October = new Translation("October", "", "oktober", "Oktober");

export const Common_Month_September = new Translation("September", "", "september", "September");

export const Common_Months = new Translation("months", "", "måneder", "månader");

export const Common_MoreActions = new Translation("More actions", "", "Flere handlinger", "Fler åtgärder");

export const Common_Name = new Translation("Name", "", "Navn", "Namn");

export const Common_No = new Translation("No", "", "Nei", "Nej");

export const Common_NoData = new Translation("No data", "", "Data mangler", "Data saknas");

export const Common_None = new Translation("None", "", "Ingen", "Ingen");

export const Common_Note = new Translation("Note", "", "Note", "Anteckning");

export const Common_Notes = new Translation("Notes", "Huomautuksia", "Notater", "Anteckningar");

export const Common_Nothing = new Translation("Nothing", "", "Ingenting", "Inget");

export const Common_Number = new Translation("Number", "", "Nummer", "Nummer");

export const Common_Off = new Translation("Off", "", "Av", "Av");

export const Common_Ok = new Translation("Ok", "", "Ok", "Ok");

export const Common_On = new Translation("On", "", "På", "På");

export const Common_Optional = new Translation("Optional", "", "Valfritt", "Valfritt");

export const Common_OrgNrLong = new Translation("Organization number", "", "Organisasjonsnummer", "Organisationsnummer");

export const Common_OrgNrShort = new Translation("OrgNr", "", "OrgNr", "OrgNr");

export const Common_Outportation = new Translation("Outportation", "", "Utportering", "Utportering");

export const Common_Overview = new Translation("Overview", "", "Oversikt", "Översikt");

export const Common_Pending = new Translation("Pending", "", "Venter", "Väntande");

export const Common_PendingCancellation = new Translation("Pending cancellation", "", "Kommende deaktivering", "Kommande inaktivering");

export const Common_PerformCreditCheck = new Translation("Perform credit check", "", "Utfør kredittsjekk", "Gör kreditupplysning");

export const Common_Period = new Translation("Period", "", "Periode", "Period");

export const Common_PersonalNr = new Translation("Personal Number", "", "Personnummer", "Personnummer");

export const Common_PhoneNumber = new Translation("Phone number", "", "Telefonnummer", "Telefonnummer");

export const Common_PhoneNumbers = new Translation("Phone Numbers", "", "Telefonnummer", "Telefonnummer");

export const Common_Portations = new Translation("Portations", "", "Porteringer", "Porteringar");

export const Common_PostalCity = new Translation("City", "", "By", "Postort");

export const Common_PostalCode = new Translation("Zip code", "", "Postkode", "Postnr");

export const Common_Price = new Translation("Price", "", "Pris", "Pris");

export const Common_PriceList = new Translation("Price list", "", "Prisliste", "Prislista");

export const Common_Product = new Translation("Product", "", "Produkt", "Produkt");

export const Common_ProductType = new Translation("Product type", "", "Produkttype", "Produkttyp");

export const Common_Remove = new Translation("Remove", "", "Ta vekk", "Ta bort");

export const Common_Rows = new Translation("Rows", "", "Rader", "Rader");

export const Common_Run = new Translation("Run", "", "Kjøre", "Kör");

export const Common_Save = new Translation("Save", "", "Spare", "Spara");

export const Common_Saved = new Translation("Saved", "", "Sparet", "Sparat");

export const Common_Saving = new Translation("Saving", "", "Sparer", "Sparar");

export const Common_Search = new Translation("Search", "", "Søk", "Sök");

export const Common_Send = new Translation("Send", "", "Sende", "Skicka");

export const Common_SendDocumentForSigning = new Translation("Send document for signing", "Lähetä asiakirja allekirjoitettavaksi", "Send dokument for underskrift", "Skicka dokument för signering");

export const Common_SendForSigning = new Translation("Send for signing", "Lähetä allekirjoitettavaksi", "Send for underskrift", "Skicka för signering");

export const Common_SendTo = new Translation("Send to", "Lähetä", "Send til", "Skicka till");

export const Common_Sent = new Translation("Sent", "", "Sendt", "Skickad");

export const Common_ServiceProvider = new Translation("Service Provider", "", "Tilbyder", "Operatör");

export const Common_SignDocument = new Translation("Sign document", "Allekirjoita asiakirjat", "Signer dokument", "Signera dokument");

export const Common_SimCard = new Translation("SIM-card", "", "SIM-kort", "SIM-kort");

export const Common_StartDate = new Translation("Start date", "", "Startdato", "Startdatum");

export const Common_Started = new Translation("Started", "", "Startet", "Startades");

export const Common_State = new Translation("State", "", "State", "State");

export const Common_Status = new Translation("Status", "", "Status", "Status");

export const Common_StreetAddress = new Translation("Street address", "", "Gateadresse", "Gatuadress");

export const Common_Subject = new Translation("Subject", "", "Emne", "Ämne");

export const Common_Subscription = new Translation("Subscription", "", "Abonnement", "Abonnemang");

export const Common_SubscriptionForm = new Translation("Subscription type", "", "Abonnementsskjema", "Abonnemangsform");

export const Common_SubscriptionNr = new Translation("Subscription number", "", "Abonnementsnummer", "Abonnemangsnummer");

export const Common_Terminate = new Translation("Terminate", "", "Slutt", "Avsluta");

export const Common_To = new Translation("To", "", "Til", "Till");

export const Common_Type = new Translation("Type", "", "Type", "Typ");

export const Common_Undo = new Translation("Undo", "", "Angre", "Ångra");

export const Common_Unit = new Translation("Unit", "", "Enhet", "Enhet");

export const Common_Units = new Translation("Units", "", "Antall", "Antal");

export const Common_Unknown = new Translation("Unknown", "", "Ukjent", "Okänd");

export const Common_User = new Translation("User", "", "Bruker", "Användare");

export const Common_UseWhen = new Translation("Area of use", "", "Bruksområde", "Användningsområde");

export const Common_Validate = new Translation("Validate", "", "Validere", "Validera");

export const Common_VAT = new Translation("VAT", "", "MVA", "Moms");

export const Common_ViewDocument = new Translation("View document", "Katso asiakirja", "Se dokument", "Se dokument");

export const Common_WaitingToLoad = new Translation("Waiting to load", "", "Venter på å laste", "Väntar på att ladda");

export const Common_WarningMessage = new Translation("Warning message", "", "Advarselsmelding", "Varningsmeddelande");

export const Common_Week = new Translation("Week", "", "Uke", "Vecka");

export const Common_Year = new Translation("Year", "", "År", "År");

export const Common_Yes = new Translation("Yes", "", "Ja", "Ja");

export const ConfirmAgreement = new Translation("Confirm that agreement exists", "", "Bekrefte at avtale eksisterer", "Bekräfta att avtal finns");

export const ConnectedContracts = new Translation("Connected Contracts", "", "Koblede kontrakter", "Kopplade kontrakt");

export const ConnectedFiles = new Translation("Connected files", "", "Koblede filer", "Kopplade filer");

export const ContactPerson = new Translation("Contact person", "", "Kontakt", "Kontaktperson");

export const ContactPersonPhone = new Translation("Contact person telephone number", "", "Kontakt telefon", "Kontaktperson telefonnummer");

export const Containers_ConsumptionFees_Value = new Translation("Consumption fees", "", "Forbruksavgifter", "Konsumtionsavgifter");

export const Containers_ConsumptionFees_ChargePerUnit = new Translation("Charge per unit", "", "Enhetspris", "Enhetspris");

export const Containers_ConsumptionFees_CopyToFee = new Translation("Copy to fee", "", "Kopier til gebyr", "Kopiera till avgift");

export const Containers_ConsumptionFees_DeleteFee = new Translation("Delete consumption fee", "", "Fjern forbruksavgift", "Ta bort konsumtionsavgift");

export const Containers_ConsumptionFees_InvoicedConsumptionFees = new Translation("Invoiced consumption fees", "", "Fakturert forbruksgebyr", "Fakturerade konsumtionsavgifter");

export const Containers_ConsumptionFees_UnitOfMeasure = new Translation("Unit of measure", "", "Enhet", "Enhet");

export const Containers_ConsumptionFees_Volume = new Translation("Volume", "", "Antall", "Antal");

export const Containers_DownloadPDF_ThereAreNoTemplates = new Translation("There are no templates", "", "Det er ingen maler", "Det finns inga mallar");

export const Containers_FeeForm_AfterSomeTime = new Translation("After some time", "", "Etter en tid", "Efter en tid");

export const Containers_FeeForm_BilledTo = new Translation("Billed to", "", "Fakturert til", "Fakturerad till");

export const Containers_FeeForm_BoundTo = new Translation("Bound to", "", "Bundet til", "Bundet till");

export const Containers_FeeForm_FeeAmount = new Translation("Amount", "", "Beløp", "Belopp");

export const Containers_FeeForm_FeeMaxWarning = new Translation("The fee is high in relation to mortgaging", "", "Gebyret er høyt i forhold til belåning", "Avgiften är hög i förhållande till belåning");

export const Containers_FeeForm_InclVat = new Translation("Incl.VAT", "", "Inkl.mva", "Inkl.moms");

export const Containers_FeeForm_OngoingFee = new Translation("Ongoing fee", "", "Løpende gebyr", "Löpande avgift");

export const Containers_FeeForm_OriginalValue = new Translation("Original value", "", "Opprinnelig verdi", "Ursprungligt värde");

export const Containers_FeeForm_RemainingValue = new Translation("Remaining Value", "", "Gjenstående verdi", "Återstående värde");

export const Containers_FeeForm_TotalAmount = new Translation("Total amount", "", "Totalbeløp", "Totalbelopp");

export const Containers_FeeForm_Value = new Translation("Value", "", "Verdi", "Värde");

export const Containers_FeeForm_VatRateProblem = new Translation("Note! The real value is", "", "Obs! Den virkelige verdien er", "Obs! Det riktiga värdet är");

export const Containers_FeesTable_AnnulFee_Value = new Translation("Terminate immediately", "", "Annullere", "Makulera");

export const Containers_FeesTable_AnnulFee_AnnulFee = new Translation("Terminate fee immediately", "", "Annullere avgift", "Makulera avgift");

export const Containers_FeesTable_AnnulFee_BodyText = new Translation("When the fee is terminated immediately, it will not be invoiced at all in the future.", "", "Når avgiften blir kansellert, blir det sagt opp og ikke fakturert i det hele tatt i fremtiden.", "Då avgiften makuleras kommer den att avslutas och inte faktureras alls framöver.");

export const Containers_FeesTable_AnnulFee_Cancel = new Translation("Cancel", "", "Avbryt", "Avbryt");

export const Containers_FeesTable_BilledTo = new Translation("Billed to", "", "Fakturert til", "Fakturerad till");

export const Containers_FeesTable_BilledToInfo1 = new Translation("Important regarding the billing date", "", "Viktig angående faktureringsdato", "Viktigt angående faktureringsdatumet");

export const Containers_FeesTable_BilledToInfo2 = new Translation("The invoiced fee is valid to the date shown, not including that date.", "", "Det fakturerte gebyret er gyldig til den viste datoen, ikke inkludert denne datoen", "Den fakturerade avgiften gäller fram till det datumet som visas, inte \"till och med\" det datumet.");

export const Containers_FeesTable_BilledToInfo3 = new Translation("Example: If you change the billing date to 2023-05-01, this means that the fee applies until 2023-05-01 00:00:00, i.e. at the beginning of the selected day.", "", "Eksempel: Hvis du endrer faktureringsdatoen til 2023-05-01, betyr dette at gebyret gjelder frem til 2023-05-01 00:00:00, dvs. ved begynnelsen av valgt dag.", "Exempel: Om du ändrar faktureringsdatumet till 2023-05-01, betyder det att avgiften gäller fram till 2023-05-01 00:00:00, alltså vid början av den valda dagen.");

export const Containers_FeesTable_BilledToInfo4 = new Translation("Do you have questions or need more help? Contact our support.", "", "Har du spørsmål eller trenger mer hjelp? Kontakt vår kundestøtte.", "Har du frågor eller behöver du mer hjälp? Kontakta vår support.");

export const Containers_FeesTable_BoundMonths = new Translation("Bound months", "", "Bindingstid", "Bindningstid");

export const Containers_FeesTable_BoundMonthsToGo = new Translation("Bound months remaining (without cancellation period)", "", "Bindingstid igjen (uten oppsigelsestid)", "Bindningstid kvar (utan uppsägningstid)");

export const Containers_FeesTable_BoundMonthsWarning = new Translation("The fee will end before the binding period has expired", "", "Gebyret avsluttes før bindingsperioden er utløpt", "Avgiften kommer att avslutas innan bindningstiden har löpt ut");

export const Containers_FeesTable_BoundTo = new Translation("Bound to", "", "Bundet til", "Bundet till");

export const Containers_FeesTable_Cancel = new Translation("Cancel", "", "Avbryt", "Avbryt");

export const Containers_FeesTable_CancellationDate = new Translation("Termination date", "", "Sluttdato", "Uppsägningsdatum");

export const Containers_FeesTable_CancellationPeriod = new Translation("Cancellation period", "", "Avbestillingsperiode", "Uppsägningstid");

export const Containers_FeesTable_ChangeBilledTo = new Translation("Change billed to", "", "Endre fakturert til", "Ändra fakturerad till");

export const Containers_FeesTable_ChangeInvocing = new Translation("Change invoicing", "", "Endre fakturering", "Ändra fakturering");

export const Containers_FeesTable_Choose = new Translation("Choose", "", "Velge", "Välj");

export const Containers_FeesTable_Created = new Translation("Created", "", "Opprettet", "Skapad");

export const Containers_FeesTable_CreateFee_Value = new Translation("Create fee", "", "Opprett avgift", "Skapa avgift");

export const Containers_FeesTable_CreateFee_Cancel = new Translation("Cancel", "", "Avbryt", "Avbryt");

export const Containers_FeesTable_CreateFee_Create = new Translation("Create", "", "Skape", "Skapa");

export const Containers_FeesTable_CreateFee_EditFee = new Translation("Edit fee", "", "Endre avgift", "Ändra avgift");

export const Containers_FeesTable_CreateFee_Save = new Translation("Save", "", "Lagre", "Spara");

export const Containers_FeesTable_EarliestInvoiceDate = new Translation("Earliest invoice month", "", "Tidligste faktureringsmåned", "Tidigaste faktureringsmånad");

export const Containers_FeesTable_EarliestInvoiceDateInfoText1 = new Translation("If the first invoicing day of the fee is to be later than the start date, it can be specified here", "", "Dersom første faktureringsdag av gebyret skal være senere enn startdato, kan det spesifiseres her", "Om avgiftens första faktureringsdag ska vara senare än startdatum kan det anges här");

export const Containers_FeesTable_EarliestInvoiceDateInfoText2 = new Translation("It is not relevant if monthly invoicing is used, but if the invoice is sent every three months, there may be two charges with different start dates - if you do nothing, there will be two invoices. But if you choose the same start month here, they come on one and the same invoice.", "", "Det er ikke aktuelt om det benyttes månedlig fakturering, men hvis fakturaen sendes hver tredje måned kan det komme to belastninger med ulike startdatoer – gjør du ingenting blir det to fakturaer. Men velger du samme startmåned her, kommer de på en og samme faktura.", "Det är inte relevant om månadsfakturering används, men om fakturan skickas var tredje månad kan det vara två avgifter med olika startdatum - om man inte gör något kommer det bli två fakturor. Men väljer man samma startmånad här kommer de på en och samma faktura.");

export const Containers_FeesTable_EndDate = new Translation("End date", "", "Sluttdato", "Slutdatum");

export const Containers_FeesTable_EstimatedEndDate = new Translation("Estimated end date based on bound months and cancellation period", "", "Estimert sluttdato", "Beräknat slutdatum");

export const Containers_FeesTable_ExclVat = new Translation("Excl.VAT", "", "Ekskl.mva", "Exkl.moms");

export const Containers_FeesTable_FeeForm_AfterSomeTime = new Translation("After some time", "", "Etter en tid", "Efter en tid");

export const Containers_FeesTable_FeeForm_BoundMonths = new Translation("Bound months", "", "Bindende tid (mån)", "Bindningstid (mån)");

export const Containers_FeesTable_FeeForm_ChooseTemplate = new Translation("Choose template", "", "Velg mal", "Välj mall");

export const Containers_FeesTable_FeeForm_DisabledInfo = new Translation("Disabled due to chosen template.", "", "Deaktivert på grunn av valgt mal.", "Inaktiverad på grund av vald mall.");

export const Containers_FeesTable_FeeForm_Month = new Translation("month", "", "måned", "månad");

export const Containers_FeesTable_FeeForm_Months = new Translation("months", "", "måneder", "månader");

export const Containers_FeesTable_FeeForm_MonthsInAdvance = new Translation("Months in advance", "", "Forveien", "Förskott");

export const Containers_FeesTable_FeeForm_MonthsInAdvanceInArrears = new Translation("In arrears", "", "På etterskudd", "I efterskott");

export const Containers_FeesTable_FeeForm_Template = new Translation("Template", "", "Mal", "Mall");

export const Containers_FeesTable_FeeForm_Type = new Translation("Type", "", "Type", "Typ");

export const Containers_FeesTable_FeeInvoicing = new Translation("Change invoicing", "", "Endre fakturering", "Ändra fakturering");

export const Containers_FeesTable_FeeNumber = new Translation("Fee number", "", "Gebyrnummer", "Avgiftsnummer");

export const Containers_FeesTable_FeesMissing = new Translation("There are no fees", "", "Det er ingen gebyrer", "Det finns inga avgifter");

export const Containers_FeesTable_FeeTemplateName = new Translation("Template description", "", "Malbeskrivelse", "Mallbeskrivning");

export const Containers_FeesTable_FeeTemplateNr = new Translation("Template number", "", "Malnummer", "Mallnummer");

export const Containers_FeesTable_FinalInvoiced = new Translation("Final invoiced", "", "Endelig fakturering", "Slutfakturerad");

export const Containers_FeesTable_InvoicePeriod = new Translation("Type", "", "Fakturaperiode", "Faktureras");

export const Containers_FeesTable_MaxBilledToNextTime = new Translation("Max invoicing month at next invoicing", "", "Maks faktureringsmåned ved neste fakturering", "Max faktureringsmånad vid nästa fakturering");

export const Containers_FeesTable_MaxBilledToNextTimeInfoText1 = new Translation("Relevant for monthly fees that are invoiced for several months when the first invoice is to be limited.", "", "Relevant for månedlige gebyrer som faktureres i flere måneder når første faktura skal begrenses.", "Relevant för månadsavgifter som faktureras flera månader då första fakturan ska begränsas.");

export const Containers_FeesTable_MaxBilledToNextTimeInfoText2 = new Translation("Limit the end period at the next invoicing. The fee will not be invoiced beyond this date at the next invoicing, invoicing thereafter takes place normally.", "", "Begrens sluttperioden ved neste fakturering. Gebyret vil ikke bli fakturert utover denne dato ved neste fakturering, fakturering deretter skjer normalt.", "Begränsa slutperioden vid nästa fakturering. Avgiften kommer inte faktureras längre än till detta datum vid nästa fakturering, fakturering därefter sker normalt.");

export const Containers_FeesTable_MonthlyFee = new Translation("Monthly fee", "", "Månedlig avgift", "Månadsavgift");

export const Containers_FeesTable_MonthsInAdvance = new Translation("Months in advance", "", "Måneder i forveien", "Månader i förskott");

export const Containers_FeesTable_NextInvoicePeriod = new Translation("Next invoice period", "", "Neste faktureringsperiode", "Nästa faktureringsperiod");

export const Containers_FeesTable_NotBilled = new Translation("not invoiced", "", "ikke fakturert", "ej fakturerad");

export const Containers_FeesTable_NotSet = new Translation("not set", "", "ikke satt", "ej satt");

export const Containers_FeesTable_OneTimeFee = new Translation("One-time fee", "", "Engangs avgift", "Engångsavgift");

export const Containers_FeesTable_PerInvoice = new Translation("Per invoice", "", "Per faktura", "Per faktura");

export const Containers_FeesTable_Reactivate = new Translation("Reactivate", "", "Aktiver på nytt", "Återaktivera");

export const Containers_FeesTable_ReactivateQuestion = new Translation("Do you want to reactivate the fee?", "", "Ønsker du å reaktivere gebyret?", "Vill du återaktivera avgiften?");

export const Containers_FeesTable_RemainingBoundMonths = new Translation("Bound months remaining", "", "Bundet måneder igjen", "Bindningstid kvar");

export const Containers_FeesTable_RemoveBoundMonths = new Translation("Ignore bound months", "", "Fjern bindingstiden", "Ta bort bindningstid");

export const Containers_FeesTable_RemoveCancellationPeriod = new Translation("Ignore cancellation period", "", "Fjern oppsigelsestiden", "Ta bort uppsägningstid");

export const Containers_FeesTable_SetEarliestInvoiceDate = new Translation("Set earliest invoice month", "", "Angi den tidligste faktureringsmåneden", "Ange tidigaste faktureringsmånad");

export const Containers_FeesTable_SetMaxBilledToNextTime = new Translation("Set Max invoicing month at the next invoicing", "", "Angi Maks faktureringsmåned ved neste fakturering", "Ange Max faktureringsmånad vid nästa fakturering");

export const Containers_FeesTable_Status = new Translation("Status", "", "Status", "Status");

export const Containers_FeesTable_Terminate = new Translation("End fee at a date", "", "Slutt", "Avsluta");

export const Containers_FeesTable_Terminated = new Translation("Terminated", "", "Avsluttet", "Uppsagd");

export const Containers_FeesTable_TerminateFee = new Translation("End fee at a date", "", "Avslutte avgift", "Avsluta avgift");

export const Containers_FeesTable_Unknown = new Translation("Unknown", "", "Ukjent", "Okänd");

export const Containers_FeesTable_Vat = new Translation("Vat", "", "MVA", "Moms");

export const Containers_Portation_PortationTable_AbortPortation = new Translation("Request cancel porting", "", "Be om kansellering av portering", "Begär avbryt portering");

export const Containers_Portation_PortationTable_AbortPortation48HourNotice = new Translation("Can only be done earlier than 48 hours before scheduled porting", "", "Kan bare gjøres tidligere enn 48 timer før planlagt portering", "Kan endast göras tidigare än 48 timmar före planerad portering");

export const Containers_Portation_PortationTable_AbortPortationAreYouSure = new Translation("Are you sure you want to cancel this porting?", "", "Er du sikker på at du vil avbryte denne porteringen?", "Är du säker på att du vill avbryta denna portering?");

export const Containers_Portation_PortationTable_AbortPortationSent = new Translation("Request to cancel porting sent", "", "Forespørsel om å avbryte portering sendt", "Begärna om avbrytande av portering skickad.");

export const Contract = new Translation("Contract", "", "Kontrakt", "Kontrakt");

export const ContractConnected = new Translation("Connected", "", "Koblet", "Kopplat");

export const ContractNr = new Translation("Contract Number", "", "Kontraktsnummer", "Kontraktsnummer");

export const ContractNumber = new Translation("Contract number", "", "Kontrakt nummer", "Kontraktsnummer");

export const ContractNumberShort = new Translation("Contract No", "", "KontraktsNr", "KontraktsNr");

export const Contracts_ContractType_ActivationState_BarringHeader = new Translation("Header", "", "Header", "Header");

export const Contracts_ContractType_ActivationState_BarringInternationalOut = new Translation("International out", "", "International out", "International out");

export const Contracts_ContractType_ActivationState_BarringLocked = new Translation("Locked", "", "Locked", "Locked");

export const Contracts_ContractType_ActivationState_BarringOutgoing = new Translation("Outgoing", "", "Outgoing", "Outgoing");

export const Contracts_ContractType_ActivationState_BarringPremium = new Translation("Premium", "", "Premium", "Premium");

export const Contracts_ContractType_ActivationState_BarringRoaming = new Translation("Roaming", "", "Roaming", "Roaming");

export const Contracts_ContractType_ActivationState_Cancel = new Translation("Cancel", "", "Avbryt", "Avbryt");

export const Contracts_ContractType_ActivationState_CommonData = new Translation("Data", "", "Data", "Data");

export const Contracts_ContractType_ActivationState_CommonDatapackageInMb = new Translation("Datapackage in Mb", "", "Datapackage in Mb", "Datapackage in Mb");

export const Contracts_ContractType_ActivationState_CommonDatapackageRollover = new Translation("Rollover", "", "Rollover", "Rollover");

export const Contracts_ContractType_ActivationState_CommonDatapackageSpeedInKbPerSec = new Translation("Datapackage Kb/Sec", "", "Datapackage Kb/Sec", "Datapackage Kb/Sec");

export const Contracts_ContractType_ActivationState_CommonHeader = new Translation("Common", "", "Common", "Allmän");

export const Contracts_ContractType_ActivationState_CommonMms = new Translation("MMS", "", "MMS", "MMS");

export const Contracts_ContractType_ActivationState_CommonPublicIp = new Translation("Public IP", "", "Public IP", "Public IP");

export const Contracts_ContractType_ActivationState_CommonVoicemail = new Translation("Voicemail", "", "Voicemail", "Voicemail");

export const Contracts_ContractType_ActivationState_CommonVolte = new Translation("Volte", "", "Volte", "Volte");

export const Contracts_ContractType_ActivationState_Edit = new Translation("Edit", "", "Redigere", "Editera");

export const Contracts_ContractType_ActivationState_RoamingEnabled = new Translation("Enabled", "", "Enabled", "Enabled");

export const Contracts_ContractType_ActivationState_RoamingHeader = new Translation("Roaming", "", "Roaming", "Roaming");

export const Contracts_ContractType_ActivationState_RoamingLimit = new Translation("Limit", "", "Limit", "Limit");

export const Contracts_ContractType_ActivationState_Save = new Translation("Save", "", "Lagre", "Spara");

export const Contracts_ContractType_ActivationState_ValidationErrorNotANumber = new Translation("Not a number", "", "Ikke et tall", "Inget number");

export const Contracts_ContractType_ActivationState_ValueFalse = new Translation("Set to Off", "", "Sett til av", "Stäng av");

export const Contracts_ContractType_ActivationState_ValueNotChanged = new Translation("Do not change", "", "Ikke forandre", "Ändra inte");

export const Contracts_ContractType_ActivationState_ValueTrue = new Translation("Set to On", "", "Sett til På", "Sätt på");

export const Contracts_ContractType_ContractTypes = new Translation("Subscription Types", "", "Abonnementsskjemaer", "Abonnemangsformer");

export const Contracts_ContractType_CreateNewContractType = new Translation("New subscription type", "", "Nytt abonnementsskjema", "Ny abonnemangsform");

export const Contracts_ContractType_Subproducts_SortOrder = new Translation("Sort order", "", "Sorteringsrekkefølge", "Sorteringsordning");

export const Contracts_ContractType_Subproducts_Subproduct = new Translation("Subproduct", "", "Delprodukt", "Subprodukt");

export const Contracts_CopyPriceList_check = new Translation("Check the contracts for which data is to be copied", "", "Huk av informasjonen som skal kopieres på avtalene", "Kryssa för de avtal för vilka data skall kopieras");

export const Contracts_CopyPriceList_ChooseFrom = new Translation("Choose pricelist…", "", "Velg prisliste…", "Välj prislista…");

export const Contracts_CopyPriceList_ChooseInterface = new Translation("Choose interface", "", "Velg grensesnitt", "Välj interface");

export const Contracts_CopyPriceList_Contract = new Translation("Contract", "", "Kontrakt", "Avtal");

export const Contracts_CopyPriceList_Copy = new Translation("copy", "", "Kopier", "kopiera");

export const Contracts_CopyPriceList_CopyPriceList = new Translation("Copy Price list", "", "Kopier prisliste", "Kopiera Prislista");

export const Contracts_CopyPriceList_from = new Translation("From PriceList ", "", "Fra", "Från");

export const Contracts_CopyPriceList_Includediscounts = new Translation("Include discounts", "", "Inkluder rabatter", "Inkludera Rabatter i kopieringen");

export const Contracts_CopyPriceList_ProvInterface_Value = new Translation("Provisioning interface", "", "Provisjonseringsinterface", "Provisioneringsinterface");

export const Contracts_CopyPriceList_ProvInterface_Text = new Translation("Choose which provisioning interface should be mapped against which provisioning interface during copying", "", "Velg hvilket provisjoneringsinterface som skal mappes mot hvilket provisjoneringsinterface under kopieringen", "Välj vilket provisioneringsinterface som skall mappas mot vilket provisioneringsinterface under kopieringen");

export const Contracts_CopyPriceList_To = new Translation("To PriceList", "", "Til ", "Till");

export const Contracts_Mortgage2_Age = new Translation("Age", "", "Alder", "Ålder");

export const Contracts_Mortgage2_Amount = new Translation("Amount", "", "Beløp", "Belopp");

export const Contracts_Mortgage2_Approve = new Translation("Approved", "", "Godkjent", "godkänd");

export const Contracts_Mortgage2_approved = new Translation("Approved Mortgage", "", "Godkjent belåning", "Beviljad belåning");

export const Contracts_Mortgage2_Choose = new Translation("Choose Physical contracts to upload", "", "Velg fysisk kontrakt å leste opp", "Välj fysiska kontrakt att ladda upp");

export const Contracts_Mortgage2_ChooseContract = new Translation("Choose Physical contract", "", "Velg fysisk kontrakt", "Välj fysiskt kontrakt ");

export const Contracts_Mortgage2_ChooseFiles = new Translation("Choose files", "", "Velg filer", "Välj filer");

export const Contracts_Mortgage2_Connect = new Translation("link to contract", "", "Koble til kontrakt", "Koppla till kontrakt");

export const Contracts_Mortgage2_ContractInfo = new Translation("Contract info", "", "Kontraktinformasjon", "Kontraktinfo");

export const Contracts_Mortgage2_ContractNr = new Translation("Contract number", "", "Kontraktsnummer", "Kontraktsnummer");

export const Contracts_Mortgage2_ContractNr2 = new Translation("Contract No", "", "Kontraktnr", "Kontraktnr");

export const Contracts_Mortgage2_ContraktType = new Translation("Contrakt type", "", "Kontraktstype", "Kontraktstyp");

export const Contracts_Mortgage2_ContraktTypeCode = new Translation("Contrakt type code", "", "Kontraktstypekode", "KontraktstypKod");

export const Contracts_Mortgage2_Created = new Translation("Created", "", "Opprettet", "Skapad");

export const Contracts_Mortgage2_CreditcheckText = new Translation("Credit Check", "", "Kredittkontroll", "Kreditkontroll");

export const Contracts_Mortgage2_Customer = new Translation("Customer", "", "Kunde", "Kund");

export const Contracts_Mortgage2_Date = new Translation("Date", "", "Dato", "Datum");

export const Contracts_Mortgage2_FindContract = new Translation("Find contract", "", "Søk kontrakt", "Sök kontrakt");

export const Contracts_Mortgage2_FindCustomer = new Translation("Find customer", "", "Søk kunde", "Sök kund");

export const Contracts_Mortgage2_FysicalContracts = new Translation("Physical contracts", "", "Fysisk kontrakt", "Fysiska kontrakt");

export const Contracts_Mortgage2_Invoices = new Translation("Invoices", "", "Fakturaer", "Fakturor");

export const Contracts_Mortgage2_InvoicesText = new Translation("Invoices", "", "Fakturaer", "Om tillräckligt många betalda fakturor finns");

export const Contracts_Mortgage2_Leverage = new Translation("Leverage", "", "Belåning", "Belåning");

export const Contracts_Mortgage2_LoadAndLink = new Translation("Upload and link to contract", "", "Last opp og koble til kontrakt", "Ladda upp och koppla till kontrakt");

export const Contracts_Mortgage2_MissPhysicalContract = new Translation("Physical Contracts are missing", "", "Fysisk kontrakt savnes", "Fysiska kontrakt saknas");

export const Contracts_Mortgage2_Name = new Translation("Name", "", "Navn", "Namn");

export const Contracts_Mortgage2_NoChoosen = new Translation("No file choosen", "", "Ingen fil valgt", "Ingen fil har valts");

export const Contracts_Mortgage2_NotInvoicing = new Translation("Do not Invoice", "", "Faktureres ikke", "Faktureras ej");

export const Contracts_Mortgage2_Or = new Translation("or", "", "eller", "eller");

export const Contracts_Mortgage2_OrgNr = new Translation("Organization number", "", "Organisasjonsnummer", "Organisationsnummer");

export const Contracts_Mortgage2_Param0 = new Translation("…Credit Check", "", "… Kredittkontroll", "… Kreditkontroll");

export const Contracts_Mortgage2_Param1 = new Translation("… Incoming traffic or paid invoice", "", "… Mottatt trafikk eller betalt faktura", "… Inkommen trafik eller betald faktura");

export const Contracts_Mortgage2_Param2 = new Translation("… Credit check AND incoming traffic or paid invoice", "", "… Kredittkontroll og inkommen trafikk eller betalt faktura", "… Kreditkontroll SAMT inkommen trafik eller betald faktura");

export const Contracts_Mortgage2_Param3 = new Translation("… Without conditions", "", "… Ingen vilkår", "… Utan villkor");

export const Contracts_Mortgage2_Phone = new Translation("Phone", "", "Telefon", "Telefon");

export const Contracts_Mortgage2_PhysicalContract = new Translation("PhysicalContract", "", "Fysisk kontrakt", "Fysiskt kontrakt");

export const Contracts_Mortgage2_PhysicalContractNOK = new Translation("Mortgage Status", "", "Fysisk kontrakt kreves", "Fysiska kontrakt krävs");

export const Contracts_Mortgage2_PhysicalContractNOKText = new Translation("Mortgage Status", "", "Fysisk kontrakt", "Fysiskt kontrakt");

export const Contracts_Mortgage2_PhysicalContractOK = new Translation("Mortgage Status", "", "Fysisk kontrakt OK", "Fysiska kontrakt ok");

export const Contracts_Mortgage2_PhysicalContractOKText = new Translation("Mortgage Status", "", "Fysisk kontrakt", "Fysiskt kontrakt");

export const Contracts_Mortgage2_PhysicalContractText = new Translation("PhysicalContract", "", "Fysisk kontrakt godkjent", "Om det fysiska kontraktet är godkänt");

export const Contracts_Mortgage2_Search = new Translation("Search", "", "Søk", "Sök");

export const Contracts_Mortgage2_SearchValues = new Translation("Customer name, telephone number or organization number", "", "Kundenavn, telefonnummer eller organisasjonsnummer", "Kundnamn, telefonnummer eller organisationsnummer");

export const Contracts_Mortgage2_ToApprove = new Translation("Approve", "", "Godkjenn", "Godkänn");

export const Contracts_Mortgage2_Undo = new Translation("Undo", "", "Angre", "Ångra");

export const Contracts_Mortgage2_UndoText = new Translation("It is possible to cancel until payment has been granted", "", "Det er mulig å angre frem til belåning er bevilget", "Det är möjligt att ångra fram till dess belåning beviljats");

export const Contracts_Mortgage2_UnLink = new Translation("UnLink", "", "Ta bort kobling", "Ta bort koppling");

export const Contracts_Mortgage2_UpLoad = new Translation("Upload", "", "Last opp", "Ladda upp");

export const Contracts_Mortgage2_Valuation = new Translation("Valuation", "", "Verdi", "Värdering");

export const Contracts_Mortgage2_Valuation2 = new Translation("Valuation", "", "Verdi", "Värdering");

export const Contracts_Mortgage2_Valuation2Date = new Translation("Date", "", "Dato", "Datum");

export const Contracts_Mortgage2_Valuation2Description = new Translation("Description", "", "Beskrivelse", "Beskrivning");

export const Contracts_Mortgage2_ValuationMethod = new Translation("Valuation", "", "Verdisettingsmetode", "Värderingsmetod");

export const Contracts_MortgageSettings_Value = new Translation("Mortgage Settings", "", "Belåninginnstillinger", "Belåningsinställningar");

export const Contracts_MortgageSettings_AddBoundMonthsInfo = new Translation("AddBoundMonths are extra months in addition to the bound period that is mortgaged.", "", "AddBoundMonths er ekstra måneder i tillegg til bindingstiden som er belånt.", "AddBoundMonths är extra månader utöver bindningstid som belånas.");

export const Contracts_MortgageSettings_AreYouSure = new Translation("Are you sure you want to revalue all contracts linked to this contract type?", "", "Er du sikker på at du vil revurdere alle kontrakter knyttet til denne formen for abonnement?", "Är du säker på att du vill omvärdera samtliga kontrakt kopplat till denna abonnemangsform?");

export const Contracts_MortgageSettings_ContractsQueued = new Translation("contracts queued", "", "kontrakter i kø", "kontrakt köade");

export const Contracts_MortgageSettings_ContractType = new Translation("Contract type", "", "Abonnementsskjema", "Abonnemangsform");

export const Contracts_MortgageSettings_ContractTypeMortgage = new Translation("Mortgage Settings", "", "Belåninginnstillinger", "Belåningsinställningar");

export const Contracts_MortgageSettings_ContractTypeValuationSetting = new Translation("Valuation of subscription forms", "", "Verdivurdering av abonnementsskjemaer", "Värdering på abonnemangsformer");

export const Contracts_MortgageSettings_ContractTypeValuationSettingDescription = new Translation("Settings for each subscription form", "", "Innstillinger for hvert abonnementsskjema", "Inställningar för respektive abonnemangsform");

export const Contracts_MortgageSettings_ContractValuationId = new Translation("Valuation", "", "Verdivurdering", "Värdering");

export const Contracts_MortgageSettings_ContractValuationSetting = new Translation("Valuation setting at client level", "", "Verdisetting på kundenivå", "Värderingsinställning på kundnivå");

export const Contracts_MortgageSettings_ContractValuationSettingDescription = new Translation("Default values for all contracts on this customer. Changes are decided via the credit committee.", "", "Standardverdier for alle kontrakter på denne kunden. Endringer avgjøres via kredittutvalget.", "Standardvärden för alla kontrakt på denna kund. Ändringar beslutas via kreditkommitén.");

export const Contracts_MortgageSettings_Default = new Translation("default", "", "standard", "standard");

export const Contracts_MortgageSettings_DefaultInfoHeading = new Translation("Default values for all clients", "", "Standardverdier for alle kunder", "Standardvärden för alla kunder");

export const Contracts_MortgageSettings_MaxBoundMonthsInfo = new Translation("MaxBoundMonths is the maximum bound period that can be mortgaged.", "", "MaxBoundMonths er den maksimale bindingstiden som kan belånes.", "MaxBoundMonths är den maximala bindningstid som kan belånas.");

export const Contracts_MortgageSettings_MortgageTerms = new Translation("Mortgage terms", "", "Belåningvilkår", "Belåningsvillkor");

export const Contracts_MortgageSettings_MortgageTermsDescription = new Translation("Changes are decided via the credit committee.", "", "Endringer avgjøres via kredittutvalget.", "Ändringar beslutas via kreditkommitén.");

export const Contracts_MortgageSettings_ReEvaluateContracts = new Translation("Re-evaluate contracts", "", "Revurdere kontrakter", "Omvärdera kontrakt");

export const Contracts_MortgageSettings_RemoveValuation = new Translation("Remove valuation", "", "Fjern vurdering", "Ta bort värdering");

export const Contracts_MortgageSettings_Settings = new Translation("Settings", "", "Innstillinger", "Inställningar");

export const Contracts_MortgageSettings_TurnOffMortgage = new Translation("Turn off mortgage", "", "Slå av belåning", "Stäng av belåning");

export const Contracts_MortgageSettings_ValidateContract_Value = new Translation("Validate contracts", "", "Validere kontrakter", "Validera kontrakt");

export const Contracts_MortgageSettings_ValidateContract_AllContracts = new Translation("All contracts", "", "Alle kontrakter", "Alla kontrakt");

export const Contracts_MortgageSettings_ValidateContract_NonApproved = new Translation("Non approved", "", "Ikke godkjente", "Ej godkända");

export const Contracts_MortgageSettings_ValidateContract_TimeUntilValidated = new Translation("Note that this action does not cause the contracts to be validated immediately, it merely causes a set of contracts to be marked as \"need to run validation\" within the above selected areas. The loan engine is ultimately responsible for this being done. It can take up to 15 minutes before the process to validate the contracts begins.", "", "Merk at denne handlingen ikke fører til at kontraktene valideres umiddelbart, den fører bare til at et sett med kontrakter merkes som \"behov for å kjøre validering\" innenfor de valgte områdene ovenfor. Lånemotoren er til syvende og sist ansvarlig for at dette blir gjort. Det kan ta opptil 15 minutter før prosessen med å validere kontraktene starter.", "Observera att denna åtgärd inte gör att kontrakten valideras omedelbart, den gör enbart att en uppsättning kontrakt markeras som \"behöver köra validering\" inom ovan valda områden. Belåningsmotorn är ytterst ansvarig för att detta görs. Det kan ta upp till 15 min innan processen för att validera kontrakten påbörjas.");

export const Contracts_Mprtgage2_By = new Translation("by", "", "av", "av");

export const Contracts_Mprtgage2_Registered = new Translation("Physical contract registered ", "", "Fysisk kontrakt registrert", "Fysiskt kontrakt registrerat ");

export const Contracts_Mprtgage2_RegisteredUpd = new Translation("Physical contract registered (updated)", "", "Fysisk kontrakt registrert (oppdatert)", "Fysikt kontrakt registrerat (uppdaterat) ");

export const Contracts_Mprtgage2_Several = new Translation("several different", "", "flere ulike", "flera olika");

export const Contracts_PriceList_AbstractText = new Translation("This is \\\\\u0027abstrast price list\\\\\u0027 cannot be used alone", "", "Dette er en \\\\\u0027abstrakt prisliste\\\\\u0027 og kan ikke anvendes alene", "Detta är en \\\\\u0027abstrakt basprislista\\\\\u0027 och kan inte användas för sig själv");

export const Contracts_PriceList_Active = new Translation("active", "", "aktive", "aktiva");

export const Contracts_PriceList_AddButton = new Translation("Add", "", "Legg til", "Lägg till");

export const Contracts_PriceList_AddPercent = new Translation("Add Påslag", "", "Påslag", "Påslag");

export const Contracts_PriceList_AddTrafficDescription = new Translation("Add traffic description", "", "Legg til trafikkbeskrivelse", "Addera trafikbeskrivning");

export const Contracts_PriceList_Base = new Translation("Base unit", "", "Basenhet", "Basenhet");

export const Contracts_PriceList_BaseFor = new Translation("This price list forms the basis for", "", "Denne prislisten utgjør basis for", "Denna prislista utgör bas för");

export const Contracts_PriceList_BasePriceLists = new Translation("Base pricelists", "", "Basisprislister", "Basprislistor");

export const Contracts_PriceList_Choose = new Translation("Choose price list…", "", "Velg prisliste", "Välj prislista…");

export const Contracts_PriceList_Contract = new Translation("contract", "", "kontrakt", "kontrakt");

export const Contracts_PriceList_DebInerval = new Translation("Charging interval", "", "Debiteringsintervall", "Debiteringsintervall");

export const Contracts_PriceList_DebUnit = new Translation("Charging unit", "", "Deb.enhet", "Deb.enhet");

export const Contracts_PriceList_Description = new Translation("Replacement destination text", "", "Erstatningsdestinasjonstekst", "Ersättningsdestinationstext");

export const Contracts_PriceList_Discounts = new Translation("Contract Discounts", "", "Kontraktsrabatter", "Kontraktsrabatter");

export const Contracts_PriceList_Following = new Translation("Following", "", "Følgende", "Följande");

export const Contracts_PriceList_FollowingIgnore = new Translation("Following", "", "Følgende", "Följande");

export const Contracts_PriceList_Heading = new Translation("Heading", "", "Overskrift", "Rubrik");

export const Contracts_PriceList_Hide = new Translation("Hide on invoice", "", "Skjul på faktura", "Göm på fakturan");

export const Contracts_PriceList_HideBNumber = new Translation("Hide B-number on invoice", "", "Skjul B-nummer på faktura", "Dölj b-nummer på fakturan");

export const Contracts_PriceList_Ignore = new Translation("Ignore", "", "Ignorer", "Ignorera");

export const Contracts_PriceList_Ignored = new Translation("are ignored", "", "Ignoreres", "ignoreras");

export const Contracts_PriceList_IgnoredNrGroups = new Translation("Ignored number groups", "", "Ingorerende nummergrupper", "Ignorerade nummergrupper");

export const Contracts_PriceList_Miss = new Translation("Price groups are missing in the following price lists", "", "Prisgruppe savnes i følgende prislister", "Prisgrupper saknas i följande prislistor");

export const Contracts_PriceList_Miss2 = new Translation("Price group is missing", "", "Prisgruppe savnes", "Prisgrupp saknas");

export const Contracts_PriceList_MissConnection = new Translation("miss connection", "", "Savner kobling", "saknar koppling");

export const Contracts_PriceList_MissNumberGroup = new Translation("Number groups are missing", "", "Nummergruppe savnes", "Nummergrupper saknas");

export const Contracts_PriceList_Move = new Translation("Move", "", "Flytt", "Flytta");

export const Contracts_PriceList_MoveButton = new Translation("Move", "", "Flytt", "Flytta");

export const Contracts_PriceList_New = new Translation("New Price list", "", "Ny prisliste", "Ny prislista");

export const Contracts_PriceList_NewPriceGroup = new Translation("New Price group", "", "Ny Prisgruppe", "Ny prisgrupp");

export const Contracts_PriceList_NoChoosen = new Translation("No price group choosen", "", "Ingen prisgruppe valgt", "Ingen prisgrupp vald");

export const Contracts_PriceList_None = new Translation("none", "", "Ingen", "ingen");

export const Contracts_PriceList_NumberActive = new Translation("Active Contracts", "", "Aktive kontrakter", "aktiva kontrakt");

export const Contracts_PriceList_NumberGroups = new Translation("Number groups", "", "nummergrupper", "nummergrupper");

export const Contracts_PriceList_NumberGroupsFor = new Translation("Number groups for", "", "nummergrupper for", "nummergrupper för");

export const Contracts_PriceList_NumberGroupsFor2 = new Translation("Number groups", "", "nummergrupper for", "nummergrupper för");

export const Contracts_PriceList_NumberGroupsIgnore = new Translation("Number groups", "", "nummergrupper", "nummergrupper");

export const Contracts_PriceList_Open = new Translation("Opening charge", "", "Oppstartsavgift", "Öppningsavgift");

export const Contracts_PriceList_OpenInclVat = new Translation("Opening charge(incl.Vat)", "", "Oppstartsavgift(inkl.mva)", "Öppningsavgift(inkl.moms)");

export const Contracts_PriceList_PriceLists = new Translation("Price lists", "", "Prisliste", "Prislistor");

export const Contracts_PriceList_PricePerUnit = new Translation("Price Per unit", "", "Pris per enhet", "Pris/enhet");

export const Contracts_PriceList_PricePerUnitInclVat = new Translation("Price(incl.Vat) Per unit", "", "Pris(inkl.mva) per enhet", "Pris(inkl.moms)/enhet");

export const Contracts_PriceList_Save = new Translation("Save", "", "Lagre", "Spara");

export const Contracts_PriceList_Subproducts = new Translation("Subproducts", "", "Delprodukter", "Subprodukter");

export const Contracts_PriceList_ToPricegroup = new Translation("to prise group", "", "til prisgruppe", "till prisgrupp");

export const Contracts_PriceList_UpdatedBy = new Translation("Updated by", "", "Oppdatert av", "Uppdaterad av");

export const Contracts_PriceList_UpdatedDate = new Translation("Updated date", "", "Oppdatert dato", "Uppdaterad datum");

export const Contracts_PriceList_VAT = new Translation("VAT", "", "Momssats", "Momssats");

export const Contracts_PriceList_VolumeIntervall = new Translation("Volume intervall", "", "Volumintervall", "Volymintervall");

export const Contracts_SubproductDefinitions_ClientSubproducts = new Translation("Subproducts for client", "", "Delprodukter for client", "Subprodukter för client");

export const ContractsNew = new Translation("Contracts (new)", "", "Abonnement (ny)", "Abonnemang(Ny)");

export const ContractType_Value = new Translation("Contract Type", "", "Kontraktstype", "Abonnemangsform");

export const ContractType_FeeTemplate_AfterSomeTime = new Translation("After some time", "", "Etter en tid", "Efter en tid");

export const ContractType_FeeTemplate_AreYouSureRemove = new Translation("Are you sure you want to delete/deactivate the fee template?", "", "Er du sikker på at du vil slette/deaktiver gebyrmalen?", "Är du säker på att du vill ta bort/deaktivera avgiftsmallen?");

export const ContractType_FeeTemplate_Attribute = new Translation("Contract attribute", "", "Kontraktsattributt", "Kontraktsattribut");

export const ContractType_FeeTemplate_AttributeValue = new Translation("Attribute value", "", "Attributtverdi", "Attributsvärde");

export const ContractType_FeeTemplate_Cancel = new Translation("Cancel", "", "Avbryt", "Avbryt");

export const ContractType_FeeTemplate_CancellationPeriod = new Translation("Cancellation period", "", "Oppsigelsesperiode", "Uppsägningstid");

export const ContractType_FeeTemplate_ChargeExcludeVat = new Translation("Amount (Excl. VAT)", "", "Beløp (ekskl. mva)", "Belopp (Exkl.moms)");

export const ContractType_FeeTemplate_ChargeIncludeVat = new Translation("Amount (Incl. VAT)", "", "Beløp (inkl. mva)", "Belopp (Inkl.moms)");

export const ContractType_FeeTemplate_ContractTypeConnectedTemplates = new Translation("Templates linked to contract type", "", "Maler knyttet til kontraktstype", "Mallar kopplade till kontraktstyp");

export const ContractType_FeeTemplate_ContractTypes = new Translation("Contract types", "", "Kontrakttyper", "Kontraktstyper");

export const ContractType_FeeTemplate_Create = new Translation("Create", "", "Skape", "Skapa");

export const ContractType_FeeTemplate_CreateFeeTemplate = new Translation("Create template", "", "Lag mal", "Skapa mall");

export const ContractType_FeeTemplate_Edit = new Translation("Edit", "", "Redigere", "Redigera");

export const ContractType_FeeTemplate_EditFeeTemplate = new Translation("Edit fee template", "", "Redigere gebyrmal", "Redigera avgiftsmall");

export const ContractType_FeeTemplate_EndFee = new Translation("End Fee", "", "Avslutte avgift", "Avsluta avgift");

export const ContractType_FeeTemplate_GeneralTemplates = new Translation("General templates", "", "Generelle maler", "Generella mallar");

export const ContractType_FeeTemplate_GoToInactive = new Translation("Go to inactive fee templates", "", "Gå til inaktive gebyrmaler", "Gå till inaktiva avgiftsmallar");

export const ContractType_FeeTemplate_InactiveFeeTemplates = new Translation("Inactive fee templates", "", "Inaktive gebyrmaler", "Inaktiva avgiftsmallar");

export const ContractType_FeeTemplate_MonthInAdvance = new Translation("Months in advance", "", "Forskudd", "Förskott");

export const ContractType_FeeTemplate_Months = new Translation("months", "", "måneder", "månader");

export const ContractType_FeeTemplate_MonthsBound = new Translation("Bound months", "", "Bindingstid", "Bindningstid");

export const ContractType_FeeTemplate_NoContractTypes = new Translation("No active contract types found", "", "Ingen aktive kontraktstyper funnet", "Inga aktiva kontraktyper hittades");

export const ContractType_FeeTemplate_NoProducts = new Translation("No products found", "", "Ingen produkter funnet", "Inga produkter hittades");

export const ContractType_FeeTemplate_NrOfContracts = new Translation("Nr of contracts", "", "Antall kontrakter", "Antal kontrakt");

export const ContractType_FeeTemplate_OngoingFee = new Translation("Ongoing fee", "", "Løpende gebyr", "Löpande avgift");

export const ContractType_FeeTemplate_Products = new Translation("Products", "", "Produkter", "Produkter");

export const ContractType_FeeTemplate_ProductSpecificFeeTemplates = new Translation("Templates linked to any product", "", "Maler knyttet til ethvert produkt", "Mallar kopplade till någon produkt");

export const ContractType_FeeTemplate_Save = new Translation("Save", "", "Lagre", "Spara");

export const ContractType_FeeTemplate_SelectAll = new Translation("Select all", "", "Velg alle", "Välj alla");

export const ContractType_FeeTemplate_SelectNone = new Translation("Select none", "", "Velg ingen", "Välj ingen");

export const ContractType_FeeTemplate_ShowUnbound = new Translation("Show only those without Contract Type and product", "", "Vis kun de uten abonnementsskjema og produkt", "Visa bara de utan abonnemangsform och produkt");

export const ContractType_FeeTemplate_TemplateID = new Translation("ID", "", "ID", "ID");

export const ContractType_FeeTemplate_Type = new Translation("Type", "", "Typ", "Typ");

export const ContractType_FeeTemplate_Until = new Translation("Ongoing", "", "Nåværende", "Löpande");

export const ContractType_FeeTemplate_UntilFurtherNotice = new Translation("Until further notice", "", "Løpende avgift", "Löpande avgift");

export const ContractType_FeeTemplate_UseAt = new Translation("Use At", "", "Bruk ved", "Använd vid");

export const ContractType_FeeTemplate_UseWhen_ChangeImsi = new Translation("Imsi change", "", "Imsi endring", "Imsibyte");

export const ContractType_FeeTemplate_UseWhen_CreatingActivity = new Translation("Activation creation", "", "Aktivering", "Aktiveringsskapande");

export const ContractType_FeeTemplate_UseWhen_CreatingCampaignContract = new Translation("Contract creation with campaign", "", "Opprettelse av kontrakt med kampanje", "Kontraktsskapande med kampanj");

export const ContractType_FeeTemplate_UseWhen_CreatingContract = new Translation("Contract creation", "", "Opprettelse av kontrakt", "Kontraktsskapande");

export const ContractType_FeeTemplate_UseWhen_SignContract = new Translation("Contract signing", "", "Kontrakt signering", "Kontraktssignering");

export const ContractType_FeeTemplate_UseWhen_TemplateInCreateFee = new Translation("Template in create fee", "", "Mal i opprettingsgebyr", "Mall i skapa avgift vyn");

export const ContractType_FeeTemplate_UseWhen_TransferContract = new Translation("Contract transfer", "", "Kontraktsoverføring", "Kontraktsöverlåtelse");

export const ContractType_FeeTemplate_VAT = new Translation("VAT", "", "Moms", "Moms");

export const ContractType_FeeTemplates = new Translation("Fee Templates", "", "Avgiftsmaler", "Avgiftsmallar");

export const ContractType_General_Active = new Translation("Active", "", "Aktiv", "Aktiv");

export const ContractType_General_AreYouSure = new Translation("Are you sure you want to delete the subscription type?", "", "Er du sikker på at du vil slette abonnementsskjemaet?", "Är du säker på att du vill ta bort abbonemangsformen?");

export const ContractType_General_Name = new Translation("Name", "", "Namn", "Namn");

export const ContractType_General_NetworkContractNr = new Translation("Network contract nr", "", "Nettverkskontraktsnummer", "Nätverkets kontraktsnummer");

export const ContractType_General_Product = new Translation("Product", "", "Produkt", "Produkt");

export const ContractType_Mortgage_AddBoundMonths = new Translation("Add bound months", "", "Legg til måneder", "Lägg till månader");

export const ContractType_Mortgage_Age = new Translation("Age", "", "Alder", "Ålder");

export const ContractType_Mortgage_Charge = new Translation("Charge", "", "Avgift", "Avgift");

export const ContractType_Mortgage_CreditCheck = new Translation("Credit check", "", "Kreditkontroll", "Kreditkontroll");

export const ContractType_Mortgage_FileGeneration = new Translation("File generation", "", "Filgenerering", "Filgenerering");

export const ContractType_Mortgage_MaxBoundMonths = new Translation("Max bound months", "", "Max bundne måneder", "Max bundna månader");

export const ContractType_Mortgage_Model = new Translation("Model", "", "Modell", "Modell");

export const ContractType_Mortgage_Name = new Translation("Name", "", "Navn", "Namn");

export const ContractType_Mortgage_NoMortgageInfo = new Translation("No mortgage of the subscription form", "", "Ingen pant i abonnementsskjemaet", "Ingen belåning av abonnenmangsform");

export const ContractType_Mortgage_NotConfigured = new Translation("Not Configured", "", "Ikke konfigurert", "Ej konfigurerad");

export const ContractType_Mortgage_NotValued = new Translation("Not Valued", "", "Ikke verdsatt", "Värderas ej");

export const ContractType_Mortgage_PaidInvoices = new Translation("Number of paid invoices", "", "Antall betalte fakturaer", "Antal betalda fakturor");

export const ContractType_Mortgage_ReceiveVia = new Translation("Receive via FTP", "", "Mottak via FTP", "Ta emot via FTP");

export const ContractType_Mortgage_RequirePhysicalContract = new Translation("Require physical contract", "", "Krev fysisk kontrakt", "Kräver fysiskt kontrakt");

export const ContractType_Mortgage_SentEmailTo = new Translation("Send email to", "", "Send e-post til", "Skicka epost till");

export const ContractType_Mortgage_Settings = new Translation("Settings", "", "Instillinger", "Inställningar");

export const ContractType_Mortgage_TrafficIsAnOption = new Translation("Traffic is an option", "", "Trafikk er et alternativ", "Trafik är alternativ");

export const ContractType_Mortgage_UsedNewMortgage = new Translation("Mortgage surcharge", "", "Pantetillegg", "Belåning påslaget");

export const ContractType_Mortgage_Valuation = new Translation("Valuation", "", "Verdsettelse", "Värdering");

export const ContractType_Mortgage_ValuationModel = new Translation("Valuation model", "", "Verdsettelsesmodell", "Värderingsmodell");

export const ContractType_Mortgage_ValuationOff = new Translation("off", "", "av", "avstängd");

export const ContractType_Mortgage_Year = new Translation("year", "", "år", "år");

export const ContractType_Overview_ActivationState = new Translation("Activation State", "", "Telefoni", "Telefoni");

export const ContractType_Overview_General = new Translation("General", "", "Som regel", "Allmänt");

export const ContractType_Overview_Loading = new Translation("Waiting to load details ...", "", "Venter på å laste inn detaljer ...", "Väntar på att ladda detaljer...");

export const ContractType_Overview_Mortgage = new Translation("Mortgage", "", "Boliglån", "Belåning");

export const ContractType_Overview_NotFound = new Translation("404 - Not found", "", "404 - Ikke funnet", "404 - Ej Hittad");

export const ContractType_Overview_Subproducts = new Translation("Subproducts", "", "Delprodukter", "Subprodukter");

export const ContractType_Overview_Warning = new Translation("Missing Contract Types", "", "Manglende kontraktstyper", "Saknar Kontrakttyper");

export const ContractTypes = new Translation("Contract types", "", "Kontraktstype", "Kontraktstyper");

export const Cost = new Translation("Cost", "", "Kostnad", "Kostnad");

export const Country = new Translation("Country", "", "Land", "Land");

export const CreateAccount = new Translation("Create account ", "", "Lag en konto", "Skapa konto");

export const CreateAccountAndLogin = new Translation("Create account and login", "", "Lag en konto og logg inn", "Skapa konto och logga in");

export const CreateAccountIntroText = new Translation("", "", "", "");

export const CreateAccountIntroText2 = new Translation("You will get an SMS with password", "", "Du vil motta en SMS med et passord", "Du kommer få ett Sms med lösenord");

export const CreateInvoices = new Translation("Create Invoices", "", "Skape fakturaer", "Skapa fakturor");

export const CreateNewInvoicee = new Translation("Create new customer", "", "Opprett ny kunde", "Skapa ny kund");

export const CreditCheck = new Translation("Credit check", "", "Kreditsjekk", "Kreditupplysning");

export const CreditCheckSureRequestNew = new Translation("Credit check already exists, are you sure you want to run a new one? ", "", "Kreditsjekk finnes allerede, Er du sikker på at du vil lage en ny?", "Kreditupplysning finns redan, är du säker på att du vill göra en ny?");

export const Creditworthiness = new Translation("Creditworthiness", "", "Kredittverdighet", "Kreditvärdighet");

export const CurrentFees = new Translation("Fees", "", "Gjeldende kostnader", "Aktuella avgifter");

export const CustomerContract_ChangePassword = new Translation("Change password", "", "Bytt passord", "Ändra lösenord");

export const CustomerContract_CustomersContracts = new Translation("Customers \u0026 Contracts", "", "Kunder \u0026 kontrakt", "Kunder \u0026 kontrakt");

export const CustomerContract_Invoicee_Activation = new Translation("Activation", "", "Aktivering", "Aktivering");

export const CustomerContract_Invoicee_ActiveFrom = new Translation("Active From", "", "Aktiv fra", "Aktiv från");

export const CustomerContract_Invoicee_Agreements_ApproveContract = new Translation("Approve contract", "", "Godkjenne kontrakt", "Godkänn kontrakt");

export const CustomerContract_Invoicee_Agreements_ApproveContractInfo = new Translation("By approving the subscription for borrowing with this function, all current and future values are approved regardless of limits such as amount limits etc. The function should only be used in exceptional cases.", "", "Ved å godkjenne abonnementet for låneopptak med denne funksjonen godkjennes alle nåværende og fremtidige verdier uavhengig av grenser som beløpsgrenser etc. Funksjonen skal kun brukes i unntakstilfeller.", "Genom att godkänna abonnemanget för belåning med den här funktionen, då godkänns alla nuvarande och kommande värden oavsett gränser såsom beloppsgränser mm. Funktionen bör endast användas vid undantagsfall.");

export const CustomerContract_Invoicee_Agreements_ApproveContractReason = new Translation("Reason for approval", "", "Begrunnelse for godkjenning", "Orsak till godkännande");

export const CustomerContract_Invoicee_Agreements_ConfirmAgreementStillValidation = new Translation("Accept that there is an agreement somehow. Other validation applies regardless.", "", "Godta at det er en avtale på en eller annen måte. Annen validering gjelder uansett.", "Godkänn att det finns ett avtal på något sätt. Övrig validering gäller oavsett.");

export const CustomerContract_Invoicee_Agreements_ContractTypeMortgageIdMissing = new Translation("No mortgage terms is set for this contract type.", "", "Ingen betalingsbetingelser er satt for denne abonnementstypen.", "Inget belåningsvillkor är inställt för denna abonnemangsform.");

export const CustomerContract_Invoicee_Agreements_GoToContractTypeMortgage = new Translation("Go to mortgage setting for contract type", "", "Gå til låneinnstillingene for abonnementstypen", "Gå till belåningsinställning för abonnemangsformen");

export const CustomerContract_Invoicee_Agreements_MortgageApproved = new Translation("Mortgage approved", "", "Belåning godkjent", "Belåning godkänd");

export const CustomerContract_Invoicee_Agreements_MortgageControlledFromS1 = new Translation("Mortgage on/off controlled from S1.", "", "Belåningsstopp styres ved å sette kunden i S1 som kravkode 2, ikke belåningsbar.", "Belåningsstopp styrs av att i S1 sätta kunden som kravkod 2, ej belåningsbar.");

export const CustomerContract_Invoicee_Agreements_MortgageInvoice_Value = new Translation("ContractLedger", "", "Kontraktsreskontra", "Kontraktsreskontra");

export const CustomerContract_Invoicee_Agreements_MortgageInvoice_BlockedStatus_Value = new Translation("Status", "", "Status", "Status");

export const CustomerContract_Invoicee_Agreements_MortgageInvoice_BlockedStatus_Blocked = new Translation("Mortgage stoppage", "", "Belåningstoppad", "Belåningsstoppad");

export const CustomerContract_Invoicee_Agreements_MortgageInvoice_MortgageInvoiceAmount = new Translation("Amount", "", "Fakturabelopp", "Fakturabelopp");

export const CustomerContract_Invoicee_Agreements_MortgageInvoice_MortgageInvoiceDueDate = new Translation("Due Date", "", "Forfallsdato", "Förfallodatum");

export const CustomerContract_Invoicee_Agreements_MortgageInvoice_MortgageInvoiceNr = new Translation("Invoice no", "", "Fakturanr", "Fakturanr");

export const CustomerContract_Invoicee_Agreements_MortgageInvoice_MortgageInvoicePaid = new Translation("Paid Amount", "", "Betalt belopp", "Betalt belopp");

export const CustomerContract_Invoicee_Agreements_MortgageInvoice_MortgageInvoiceRemainingAmount = new Translation("Balance", "", "Restbelopp", "Restbelopp");

export const CustomerContract_Invoicee_Agreements_MortgageNotApproved = new Translation("Mortgage not approved", "", "Belåning ikke godkjent", "Belåning ej godkänd");

export const CustomerContract_Invoicee_Agreements_MortgageValue_ChangedDate = new Translation("Changed", "", "Endret", "Ändrat");

export const CustomerContract_Invoicee_Agreements_MortgageValue_CreatedDate = new Translation("Created", "", "Opprettet", "Skapad");

export const CustomerContract_Invoicee_Agreements_MortgageValue_CurrentMortgageValue = new Translation("Value per month", "", "Värde per månad", "Värde per månad");

export const CustomerContract_Invoicee_Agreements_MortgageValue_HistoricalMortgageValue = new Translation("Historical value per month", "", "Historik värde månad", "Historik värde månad");

export const CustomerContract_Invoicee_Agreements_MortgageValue_MortgageInvoiceNr = new Translation("InvoiceNr", "", "FakturaNr", "FakturaNr");

export const CustomerContract_Invoicee_Agreements_MortgageValue_Value = new Translation("Value", "", "Verdi", "Värde");

export const CustomerContract_Invoicee_Agreements_MortgageValue_ValueRange = new Translation("Value range", "", "Verdiområde", "Värdeintervall");

export const CustomerContract_Invoicee_AgreementsAndMortgage = new Translation("Agreements and Mortgage", "", "Avtale", "Avtal \u0026 Belåning");

export const CustomerContract_Invoicee_Approved = new Translation("Approved", "", "Godkjent", "Godkänd");

export const CustomerContract_Invoicee_BilledTo = new Translation("Last invoiced", "", "Sist fakturert", "Senast fakturerad");

export const CustomerContract_Invoicee_Choose = new Translation("Choose", "", "Velge", "Välj");

export const CustomerContract_Invoicee_City = new Translation("City", "", "By", "Postort");

export const CustomerContract_Invoicee_ContactNumber = new Translation("Contact number", "", "Kontaktnummer", "Kontaktnummer");

export const CustomerContract_Invoicee_ContactPerson = new Translation("Contact person", "", "Kontaktperson", "Kontaktperson");

export const CustomerContract_Invoicee_Contract = new Translation("Contract", "", "Kontrakt ", "Kontrakt");

export const CustomerContract_Invoicee_ContractList = new Translation("Subscriptions", "", "Abonnement", "Abonnemang");

export const CustomerContract_Invoicee_ContractNr = new Translation("Contract Number", "", "Kontraktsnummer", "Kontraktnummer");

export const CustomerContract_Invoicee_CostControl = new Translation("Cost Control", "", "Kostnadskontroll", "Kostnadskontroll");

export const CustomerContract_Invoicee_CouldNotLoadInvoicee = new Translation("Could not load customer.", "", "Kunne ikke laste inn kunde.", "Kunde inte ladda kund.");

export const CustomerContract_Invoicee_CouldNotLoadInvoiceeWithNr = new Translation("Could not load customer with number", "", "Kunne ikke laste inn kunden med nummer", "Kunde inte ladda kund med kundnr");

export const CustomerContract_Invoicee_Created = new Translation("Created", "", "Laget", "Skapad");

export const CustomerContract_Invoicee_CreatedChanged = new Translation("Last modified", "", "Sist endret", "Senast ändrad");

export const CustomerContract_Invoicee_CreateSubscription_CreateLinkedFees = new Translation("Create fees from template", "", "Opprett avgifter etter mal", "Skapa avgifter enligt mall");

export const CustomerContract_Invoicee_CreateSubscription_CreatingSubscription = new Translation("Creating subscription", "", "Oppretter abonnement", "Skapar abonnemang");

export const CustomerContract_Invoicee_CreateSubscription_GoToSubscription = new Translation("Go to subscription", "", "Gå til abonnement", "Gå till abonnemang");

export const CustomerContract_Invoicee_CreateSubscription_NrOfContracts = new Translation("Number of contracts", "", "Antall abonnementer", "Antal abonnemang");

export const CustomerContract_Invoicee_CreateSubscription_SubscriptionCreated = new Translation("Subscription created.", "", "Abonnement utformet.", "Abonnemang skapat.");

export const CustomerContract_Invoicee_Credit = new Translation("Creditworthiness", "", "Kredittverdighet", "Kreditvärdighet");

export const CustomerContract_Invoicee_CreditCheckNotMade = new Translation("No credit check made", "", "Ingen kredittsjekk laget", "Ingen kreditupplysning gjord");

export const CustomerContract_Invoicee_Currency = new Translation("Currency Code", "", "Valutakode", "Valutakod");

export const CustomerContract_Invoicee_CustomerData = new Translation("Customer Data", "", "Kundedata", "Kunduppgifter");

export const CustomerContract_Invoicee_CustomerFees_Value = new Translation("Customer Fees", "", "Kundegebyr", "Kundavgifter");

export const CustomerContract_Invoicee_CustomerFees_CreateFee = new Translation("Create fee", "", "Opprett avgift", "Skapa avgift");

export const CustomerContract_Invoicee_CustomerFees_FeesMissing = new Translation("There are no active customer fees", "", "Det er ingen aktive kundeavgifter", "Det finns inga aktiva kundavgifter");

export const CustomerContract_Invoicee_CustomerFees_WaitingToLoad = new Translation("Waiting to load", "", "Venter på å laste", "Väntar på att ladda");

export const CustomerContract_Invoicee_CustomerGroup = new Translation("Customer Group", "", "Kundegruppe", "Kundgrupp");

export const CustomerContract_Invoicee_CustomerNrShort = new Translation("CustomerNr", "", "Kundenr", "Kundnr");

export const CustomerContract_Invoicee_Days = new Translation("days", "", "dager", "dagar");

export const CustomerContract_Invoicee_DebtCollectionWarning_DebtCollection1 = new Translation("The customer has an invoice in debt collection", "", "Kunden har en faktura i inkasso", "Kunden har en faktura på inkasso");

export const CustomerContract_Invoicee_DebtCollectionWarning_DebtCollection2 = new Translation("The customer has two invoices in debt collection", "", "Kunden har to fakturaer i inkasso", "Kunden har två fakturor på inkasso");

export const CustomerContract_Invoicee_DebtCollectionWarning_DebtCollection2Plus = new Translation("The customer has more than two invoices in debt collection", "", "Kunden har mer enn to fakturaer i inkasso", "Kunden har fler än två fakturor på inkasso");

export const CustomerContract_Invoicee_DebtCollectionWarning_DebtCollectionExplanation = new Translation("Unpaid invoices for the last 12 months that are with debt collection.", "", "Ubetalte fakturaer siste 12 måneder som er med inkasso.", "Obetalda fakturor de senaste 12 månaderna som ligger hos inkasso.");

export const CustomerContract_Invoicee_DebtCollectionWarning_Reminder1 = new Translation("The customer has a payment reminder", "", "Kunden har en betalingspåminnelse", "Kunden har en betalningspåminnelse");

export const CustomerContract_Invoicee_DebtCollectionWarning_StoppedForReminder = new Translation("The customer has a claim-stopped invoice", "", "Kunden har en etterspørselsstanset faktura", "Kunden har en kravstoppad faktura");

export const CustomerContract_Invoicee_DeleteInvoicee_Value = new Translation("Delete invoicee", "", "Fjern kund", "Ta bort kund");

export const CustomerContract_Invoicee_DeleteInvoicee_AreYouSure = new Translation("Are you sure you want to delete this invoicee?", "", "Er du sikker på at du vil slette denne kunden?", "Är du säker på att du vill ta bort den här kunden?");

export const CustomerContract_Invoicee_DeleteInvoicee_AttemptForceDelete = new Translation("Attempt force delete", "", "Forsøk å tvinge sletting", "Försök forcera borttagning");

export const CustomerContract_Invoicee_DeleteInvoicee_AttemptForceDeleteInfo = new Translation("(This is only visible to you who are Admin) Clicking this box causes us to ignore certain checks when removing a customer.", "", "(Dette er kun synlig for deg som er Admin) Klikk på denne boksen fører til at vi ignorerer visse kontroller når vi fjerner en kunde.", "(Detta syns endast för dig som är Admin) Att klicka för denna låda gör att vi ignorerar vissa kontroller när vi tar bort en kund.");

export const CustomerContract_Invoicee_DeleteInvoicee_Delete = new Translation("Delete", "", "Fjern", "Ta bort");

export const CustomerContract_Invoicee_DeleteInvoicee_InvoiceeDeleted = new Translation("Invoicee deleted", "", "Kunden fjernet", "Kund borttagen");

export const CustomerContract_Invoicee_DeleteInvoicee_NotInvoiced = new Translation("Invoicee cannot be removed if they have been invoiced or have had activated numbers.", "", "Kunder kan ikke fjernes hvis de har blitt fakturert eller har hatt aktiverte numre.", "Kunder kan inte tas bort om de har fakturerats eller har haft aktiverade nummer.");

export const CustomerContract_Invoicee_DirectDebit = new Translation("Direct debit", "", "Avtalegiro", "Autogiro");

export const CustomerContract_Invoicee_DirectDebitDistribute = new Translation("Distributed", "", "Distribuert", "Distribueras");

export const CustomerContract_Invoicee_Distribution = new Translation("Distribution type", "", "Distribusjonsmetode", "Distributionssätt");

export const CustomerContract_Invoicee_Duration = new Translation("Active Duration", "", "Aktiv i", "Aktiv i");

export const CustomerContract_Invoicee_EInvoiceIdentifier = new Translation("e-Invoice Identifier", "", "e-Fakturaidentifikator", "e-Fakturaidentifierare");

export const CustomerContract_Invoicee_EmailInvoice = new Translation("E-mail (invoice)", "", "E-post (faktura)", "E-post (faktura)");

export const CustomerContract_Invoicee_EmailRequired = new Translation("Email is required", "", "E-postadressen må oppgis", "E-post adress måste vara ifyllt");

export const CustomerContract_Invoicee_Excluded = new Translation("Excluded", "", "Ekskludert", "Exkluderad");

export const CustomerContract_Invoicee_General = new Translation("General", "", "Generelt", "Allmänt");

export const CustomerContract_Invoicee_Guarantor = new Translation("Guarantor", "", "Garantist", "Borgensman");

export const CustomerContract_Invoicee_History_Value = new Translation("History", "", "Historikk", "Historik");

export const CustomerContract_Invoicee_History_AddressChanges = new Translation("Address changes", "Osoitteen muutokset", "Adresseendringer", "Adressändringar");

export const CustomerContract_Invoicee_History_BlockType = new Translation("Block type", "", "Blokktype", "Blocktyp");

export const CustomerContract_Invoicee_History_BlockViaDebtCollection = new Translation("Block via debt collection", "", "Blokker via inkasso", "Block via inkasso");

export const CustomerContract_Invoicee_History_CustomerChanges = new Translation("Customer changes", "", "Kundeendringer", "Kundförändringar");

export const CustomerContract_Invoicee_History_NoHistory = new Translation("No history", "", "Ingen historikk", "Ingen historik");

export const CustomerContract_Invoicee_History_NoSentSms = new Translation("No SMS Sent", "", "Ingen SMS sendt", "Inga SMS skickade");

export const CustomerContract_Invoicee_History_SentEmail_Header = new Translation("Sent emails", "Lähetetyt sähköpostit", "Sendte e-poster", "Skickade e-postmeddelanden");

export const CustomerContract_Invoicee_History_SentEmail_Table_Body = new Translation("Content", "Sisältö", "Innhold", "Innehåll");

export const CustomerContract_Invoicee_History_SentEmail_Table_From = new Translation("From", "Lähettäjä", "Fra", "Från");

export const CustomerContract_Invoicee_History_SentEmail_Table_SentAt = new Translation("Sent at", "Lähetetty", "Sendt", "Skickat");

export const CustomerContract_Invoicee_History_SentEmail_Table_Subject = new Translation("Subject", "Aihe", "Emne", "Ämne");

export const CustomerContract_Invoicee_History_SentEmail_Table_To = new Translation("To", "Vastaanottaja", "Til", "Till");

export const CustomerContract_Invoicee_History_SentSms_Value = new Translation("Sent SMS", "", "Sendt SMS", "Skickade SMS");

export const CustomerContract_Invoicee_History_SentSms_Header_DeliveryStatus = new Translation("Delivery status", "", "Leveringsstatus", "Leveransstatus");

export const CustomerContract_Invoicee_History_SentSms_Header_Phonenumber = new Translation("Phonenumber", "", "Telefonnummer", "Telefonnummer");

export const CustomerContract_Invoicee_History_SentSms_Header_SentAt = new Translation("Send at", "", "Sendt", "Skickat");

export const CustomerContract_Invoicee_History_SentSms_Header_Text = new Translation("Text", "", "Text", "Text");

export const CustomerContract_Invoicee_InvoiceeBatch_Value = new Translation("Invoice Group", "", "Fakturagrupp", "Fakturagrupp");

export const CustomerContract_Invoicee_InvoiceeBatch_DirectInvoice = new Translation("Direct invoice", "", "Direkte faktura", "Direktfaktura");

export const CustomerContract_Invoicee_InvoiceeBatch_PaymentInvoice = new Translation("Payment registration", "Betalningsregistrering", "Betalningsfaktura", "Betalningsregistrering");

export const CustomerContract_Invoicee_InvoiceeBatch_StandardInvoice = new Translation("Standard", "", "Standard", "Standard");

export const CustomerContract_Invoicee_InvoiceeBlock_Hardblock = new Translation("The customer has \"hard block\" via debt collection.", "", "Kunden har \"hard block\" via inkasso.", "Kunden har \"hardblock\" via inkasso.");

export const CustomerContract_Invoicee_InvoiceeBlock_Softblock = new Translation("The customer has \"soft block\" via debt collection.", "", "Kunden har \"soft block\" via inkasso.", "Kunden har \"softblock\" via inkasso.");

export const CustomerContract_Invoicee_InvoiceeMissing = new Translation("Customer missing", "", "Kunde mangler", "Kund saknas");

export const CustomerContract_Invoicee_InvoiceeType = new Translation("Customer type", "", "Kundetype", "Kundtyp");

export const CustomerContract_Invoicee_InvoiceFee = new Translation("Invoice fee", "", "Faktureringsgebyr", "Faktureringsavgift");

export const CustomerContract_Invoicee_InvoiceInterval = new Translation("Invoice interval", "", "Faktureringsintervall", "Faktureringsintervall");

export const CustomerContract_Invoicee_InvoiceReference = new Translation("Your invoice reference", "", "Er faktura referanse", "Er fakturareferens");

export const CustomerContract_Invoicee_Invoices_Value = new Translation("Invoices", "", "Fakturaer", "Fakturor");

export const CustomerContract_Invoicee_Invoices_AccountingDate = new Translation("Accounting date", "", "Regnskapsdato", "Bokföringsdatum");

export const CustomerContract_Invoicee_Invoices_AccountNumber = new Translation("Account Number", "", "Kontonummer", "Bankgiro");

export const CustomerContract_Invoicee_Invoices_AccountNumber2 = new Translation("Account Number2", "", "Kontonummer2", "Plusgiro");

export const CustomerContract_Invoicee_Invoices_AmountInvalid = new Translation("Must not exceed amount", "", "Må ikke overstige beløpet", "Får ej överstiga belopp");

export const CustomerContract_Invoicee_Invoices_AmountToCredit = new Translation("Amount to credit", "", "Beløp til kreditt", "Belopp att kreditera");

export const CustomerContract_Invoicee_Invoices_AmountToCustomerLoss = new Translation("Amount to mark as customer loss", "Beløp som skal merkes som kundetap", "Beløp å slette", "Belopp att markera som kundförlust");

export const CustomerContract_Invoicee_Invoices_AmountToVoid = new Translation("Amount to void", "", "Beløp å slette", "Belopp att makulera");

export const CustomerContract_Invoicee_Invoices_Cancelled = new Translation("Cancelled", "", "Stoppet", "Makulerad");

export const CustomerContract_Invoicee_Invoices_ChangeDueDate = new Translation("Change due date", "", "Endre forfallsdato", "Ändra förfallodatum");

export const CustomerContract_Invoicee_Invoices_CreateDirectInvoice = new Translation("Create direct invoice", "", "Opprett direktefaktura", "Skapa direktfaktura");

export const CustomerContract_Invoicee_Invoices_CreateFeeForInvoice = new Translation("Create a one-time fee for the next invoice", "", "Opprett et engangsgebyr for neste faktura", "Skapa engångsavgift för nästa faktura");

export const CustomerContract_Invoicee_Invoices_CreateInvoiceNote = new Translation("Create invoice notation", "", "Lag fakturanotasjon", "Skapa fakturanotering");

export const CustomerContract_Invoicee_Invoices_CreditButtonHeading = new Translation("Credit invoice", "", "Krediter faktura", "Kreditera faktura");

export const CustomerContract_Invoicee_Invoices_CreditCustomerLoss = new Translation("Book as customer loss", "", "Bestill som kundetap", "Boka som kundförlust");

export const CustomerContract_Invoicee_Invoices_CreditCustomerLossInfoText = new Translation("If you know or suspect that an outstanding claim will not be paid, the invoice can be booked as a customer loss. Booking as a customer loss closes the invoice in the ledger, but if the invoice has gone on to debt collection, the case is continued from there.\\\\n\\\\nBooking as a customer loss can be done in both feared and confirmed customer loss, and is used regardless of whether the end customer is a company or a private person.", "", "Dersom du vet eller har mistanke om at et utestående krav ikke vil bli betalt, kan fakturaen bokføres som kundetap. Booking som kundetap lukker fakturaen i reskontroen, men dersom fakturaen har gått videre til inkasso, videreføres saken derfra.\\\\n\\\\nBooking som kundetap kan gjøres i både fryktet og bekreftet kundetap, og brukes uavhengig av om sluttkunden er et selskap eller en privatperson.", "Om man vet eller misstänker att en utestående fordran inte kommer att bli betald så kan fakturan bokas som kundförlust. Att boka som kundförlust stänger fakturan i reskontran, men om fakturan gått vidare till inkasso så drivs ärendet vidare därifrån.\\\\n\\\\nAtt boka som kundförlust kan göras vid både befarad och konstaterad kundförlust, och används oavsett om slutkunden är ett företag eller en privatperson.");

export const CustomerContract_Invoicee_Invoices_Credited = new Translation("Credited", "", "Kreditert", "Krediterad");

export const CustomerContract_Invoicee_Invoices_CreditFeeText = new Translation("Text on invoice", "", "Tekst på faktura", "Text på faktura");

export const CustomerContract_Invoicee_Invoices_CreditHeading = new Translation("Actions for crediting an invoice", "", "Handlinger for kreditering av en faktura", "Åtgärder för kreditera faktura");

export const CustomerContract_Invoicee_Invoices_CreditingOfInvoice = new Translation("Crediting of invoice", "", "Kreditering av faktura", "Kreditering av faktura");

export const CustomerContract_Invoicee_Invoices_CreditingOfInvoicePartial = new Translation("Partial crediting of invoice", "", "Delvis kreditering av faktura", "Delkreditering av faktura");

export const CustomerContract_Invoicee_Invoices_CreditNextInvoice = new Translation("Credit amount on the next invoice", "", "Kredittbeløp på neste faktura", "Kreditera belopp på nästa faktura");

export const CustomerContract_Invoicee_Invoices_CreditNextInvoiceInfoText = new Translation("The customer will pay this invoice in full, but the amount on the customer\u0027s next invoice will be corrected to a lower amount by adding a line with the credit.\\\\n\\\\nThis may be an appropriate method of adjusting incorrectly billed amounts that are lower than the normal monthly invoice , e.g. an invoice fee.\\\\n\\\\nThe advantage is that it is easy for all parties, all invoices are paid with the correct amount and there are few errors.", "", "Kunden vil betale denne fakturaen i sin helhet, men beløpet på kundens neste faktura vil bli korrigert til et lavere beløp ved å legge til en linje med kreditten.\\\\n\\\\nDette kan være en passende metode for å justere feilfakturerte beløp som er lavere enn den vanlige månedlige fakturaen , f.eks. et fakturagebyr.\\\\n\\\\nFordelen er at det er enkelt for alle parter, alle fakturaer betales med riktig beløp og det er få feil.", "Kunden ska betala denna faktura i sin helhet, men beloppet på kundens nästa faktura korrigeras till en lägre summa genom att en rad med krediteringen tillförs.\\\\n\\\\nDetta kan vara en lämplig metod för att justera felaktigt fakturerade belopp som är lägre än den normala månadsfakturan, t.ex. en fakturaavgift.\\\\n\\\\nFördelen är att det är lätt för alla parter, alla fakturor betalas med rätt belopp och det blir få fel.");

export const CustomerContract_Invoicee_Invoices_CreditRemaining = new Translation("Credit the remaining amount", "", "Krediter det resterende beløpet", "Kreditera resterande belopp");

export const CustomerContract_Invoicee_Invoices_CreditViaDirectInvoice = new Translation("Create a credit note", "", "Opprett en kreditnota", "Skapa en kreditnota");

export const CustomerContract_Invoicee_Invoices_CreditViaDirectInvoiceInfoText = new Translation("If an invoice is incorrect and needs to be corrected, this can be done by creating a credit note and sending it to the customer. If the credit note corresponds to the entire invoice amount, the customer must pay nothing, if the credit note corresponds to only part of the invoice amount, the customer must pay the difference. If an invoice has gone on to debt collection but is then set off against a credit memo, the debt collection case is closed.\\\\n\\\\nThis option is suitable to use if the end customer is a company, because they often want a credit memo as a basis for their accounting. In some cases, a private person also wants a credit invoice.", "", "Dersom en faktura er feil og må rettes, kan dette gjøres ved å opprette en kreditnota og sende den til kunden. Dersom kreditnotaen tilsvarer hele fakturabeløpet skal kunden ikke betale noe, dersom kreditnotaen kun tilsvarer en del av fakturabeløpet skal kunden betale differansen. Dersom en faktura har gått videre til inkasso men deretter motregnet i en kreditnota, avsluttes inkassosaken.\\\\n\\\\nDette alternativet passer å bruke dersom sluttkunden er en bedrift, fordi de ofte ønsker en kreditnota som grunnlag for deres regnskap. I noen tilfeller ønsker også en privatperson en kredittfaktura.", "Om en faktura är felaktig och ska korrigeras så kan detta göras genom att en kreditnota skapas och skickas ut till kunden.  Om kreditnotan motsvarar hela fakturabeloppet så ska kunden inte betala något, om kreditnotan endast motsvarar en del av fakturabeloppet så ska kunden betala mellanskillnaden. Om en faktura gått vidare till inkasso men sedan kvittas mot en kreditnota så avslutas inkassoärendet.\\\\n\\\\nDetta alternativ är lämpligt att använda om slutkunden är ett företag, eftersom dessa ofta önskar en kreditnota som underlag till sin bokföring. I vissa fall önskar även en privatperson en kreditfaktura.");

export const CustomerContract_Invoicee_Invoices_CreditVoid = new Translation("Void the invoice", "", "Makulere faktura", "Makulera faktura");

export const CustomerContract_Invoicee_Invoices_CreditVoidInfoText = new Translation("If an invoice is incorrect and the customer does not want a basis for the correction, the invoice can be cancelled. If the invoice is canceled in its entirety, the customer does not have to pay anything, if only part of the invoice is cancelled, the customer must pay the remaining balance after the cancellation. An invoice that is canceled in its entirety is closed in the ledger and if the invoice has had time to proceed to collection, the collection case is also closed.\\\\n\\\\nThis option can be used if the end customer is a private person, where you can tell the customer that they do not have to pay the invoice. But less suitable if the end customer is a company as they need a basis for the credit.", "", "Dersom en faktura er feil og kunden ikke ønsker grunnlag for rettingen, kan fakturaen kanselleres. Dersom fakturaen kanselleres i sin helhet, trenger ikke kunden å betale noe, dersom kun deler av fakturaen kanselleres må kunden betale restbeløpet etter kanselleringen. En faktura som er kansellert i sin helhet lukkes i reskontro og dersom fakturaen har rukket å gå videre til inkasso avsluttes også inkassosaken.\\\\n\\\\nDette alternativet kan benyttes dersom sluttkunden er en privatperson, hvor du kan fortelle kunden at de ikke trenger å betale fakturaen. Men mindre egnet hvis sluttkunden er et selskap da de trenger grunnlag for kreditten.", "Om en faktura är felaktig och kunden inte önskar ett underlag på korrigeringen så kan fakturan makuleras. Om fakturan makuleras i sin helhet så ska kunden inte betala något, makuleras endast en del av fakturan så ska kunden betala det kvarvarande restbeloppet efter makuleringen. En fakturas som makuleras i sin helhet stängs i reskontran och om fakturan hunnit gå vidare till inkasso så avslutas även inkassoärendet.\\\\n\\\\nDetta alternativ kan användas om slutkunden är en privatperson, där man kan säga till kunden att de inte behöver betala fakturan. Men passar mindre bra om slutkunden är ett företag då de behöver ett underlag för krediteringen.");

export const CustomerContract_Invoicee_Invoices_CustomerLoss = new Translation("Customer loss", "", "Kundetap", "Kundförlust");

export const CustomerContract_Invoicee_Invoices_DebtCollection = new Translation("Debt collection", "", "Inkasso", "Inkasso");

export const CustomerContract_Invoicee_Invoices_DemandStatus = new Translation("Demand status", "", "Kravstatus", "Kravstatus");

export const CustomerContract_Invoicee_Invoices_DirectPaid = new Translation("Direct paid", "", "Diretkebetalt", "Direktbetald");

export const CustomerContract_Invoicee_Invoices_DownloadInvoice = new Translation("Download invoice", "", "Last ned faktura", "Ladda ner faktura");

export const CustomerContract_Invoicee_Invoices_DownloadTraffic = new Translation("Download traffic specification", "", "Last ned trafikkspesifikasjon", "Ladda ner trafikspecifikation");

export const CustomerContract_Invoicee_Invoices_EmailSubject = new Translation("Copy of invoice", "Laskukopio", "Kopi av faktura", "Fakturakopia");

export const CustomerContract_Invoicee_Invoices_EmailTemplate = new Translation("Hello,\\\\n\\\\nAttached is a copy of the invoice.\\\\n\\\\nPAYMENT INFORMATION\\\\n\\\\nPayable to: Svea\\\\nReference: \u003c#reference#\u003e\\\\nAccountnumber: \u003c#bgnr_svea#\u003e\\\\nAmount: \u003c#amount#\u003e\\\\nDue date: \u003c#due_date#\u003e\\\\n\\\\n\\\\nSincerely\\\\n\\\\n\u003c#client_name#\u003e", "Hei,\\\\n\\\\nLiitteenä laskukopio.\\\\n\\\\nMAKSUTIEDOT\\\\n\\\\nMaksunsaaja: Svea Bank AB, filial i Finland\\\\nViitenumero: \u003c#reference#\u003e\\\\nTilinumero: \u003c#bgnr_svea#\u003e\\\\nIBAN: \u003c#iban#\u003e\\\\nSWIFT/BIC: \u003c#bic#\u003e\\\\nSumma: \u003c#amount#\u003e\\\\nEräpäivä: \u003c#due_date#\u003e\\\\n\\\\n\\\\nYstävällisin terveisin\\\\n\\\\n\u003c#client_name#\u003e", "Hei,\\\\n\\\\nVedlagt følger kopi av faktura.\\\\n\\\\nBETALINGSINFORMASJON\\\\n\\\\nKontomottaker: Svea Bank AB, filial i Norge\\\\nKID-nummer: \u003c#reference#\u003e\\\\nKontonummer: \u003c#bgnr_svea#\u003e\\\\nBeløp: \u003c#amount#\u003e\\\\nForfallsdato: \u003c#due_date#\u003e\\\\n\\\\n\\\\nVennlig hilsen\\\\n\\\\n\u003c#client_name#\u003e", "Hej,\\\\n\\\\nBifogar kopia på faktura.\\\\n\\\\n\\\\nBETALNINGSINFORMATION\\\\n\\\\nBetalas till: Svea\\\\nOCR: \u003c#reference#\u003e\\\\nPlusgiro: \u003c#pgnr_svea#\u003e\\\\nBankgiro: \u003c#bgnr_svea#\u003e\\\\nBelopp: \u003c#amount#\u003e\\\\nFörfallodatum: \u003c#due_date#\u003e\\\\n\\\\n\\\\nMed vänlig hälsning\\\\n\\\\n\u003c#client_name#\u003e");

export const CustomerContract_Invoicee_Invoices_EnterAmount = new Translation("Enter amount", "", "Tast inn beløp", "Ange belopp");

export const CustomerContract_Invoicee_Invoices_ExpirationDate = new Translation("Invoice Expiration Date", "", "Forfallsdato", "Förfallodatum");

export const CustomerContract_Invoicee_Invoices_InternalInvoiceNote = new Translation("Internal invoice notation", "", "Intern fakturanotasjon", "Intern fakturanotering");

export const CustomerContract_Invoicee_Invoices_InvoiceAmount = new Translation("Amount", "", "Beløp", "Belopp");

export const CustomerContract_Invoicee_Invoices_InvoiceDate = new Translation("Invoice Date", "", "Fakturadato", "Fakturadatum");

export const CustomerContract_Invoicee_Invoices_InvoiceNr = new Translation("Invoice Number", "", "Fakturanummer", "Fakturanummer");

export const CustomerContract_Invoicee_Invoices_MarkRemainingAsCustomerLoss = new Translation("Mark the remaining amount as customer loss", "", "Merk det resterende beløpet som kundetap", "Markera resterande belopp som kundförlust");

export const CustomerContract_Invoicee_Invoices_NoInvoices = new Translation("This customer has no invoices", "", "Denne kunden har ingen fakturaer", "Denna kund har inga fakturor");

export const CustomerContract_Invoicee_Invoices_NoNotes = new Translation("Could not find any notes", "", "Kunne ikke finne noen notater", "Kunde inte hitta några noteringar");

export const CustomerContract_Invoicee_Invoices_NoPayments = new Translation("Could not find any payments", "", "Kunne ikke finne noen betalinger", "Kunde inte hitta några betalningar");

export const CustomerContract_Invoicee_Invoices_NoReminderFee = new Translation("Do not charge a reminder fee", "", "Ikke krev påminnelsesgebyr", "Debitera inte påminnelseavgift");

export const CustomerContract_Invoicee_Invoices_Note = new Translation("Note", "", "Notat", "Notering");

export const CustomerContract_Invoicee_Invoices_Notes = new Translation("Notes", "", "Notater", "Noteringar");

export const CustomerContract_Invoicee_Invoices_NoUpcomingInvoices = new Translation("This customer has no upcoming invoices", "", "Denne kunden har ingen kommende fakturaer", "Denna kund har inga kommande fakturor");

export const CustomerContract_Invoicee_Invoices_Paid = new Translation("Payed", "", "Betalt", "Betald");

export const CustomerContract_Invoicee_Invoices_PaidAmount = new Translation("Paid amount", "", "Innbetalt beløp", "Betalt belopp");

export const CustomerContract_Invoicee_Invoices_PaidDebtCollection = new Translation("Paid via debt collection", "", "Betalt via inkasso", "Betald via inkasso");

export const CustomerContract_Invoicee_Invoices_PartiallyCredited = new Translation("Partially credited", "", "Delvis kreditert", "Delkrediterad");

export const CustomerContract_Invoicee_Invoices_PaymentDate = new Translation("Payment Date", "", "Betalingsdato", "Betalningsdatum");

export const CustomerContract_Invoicee_Invoices_Payments = new Translation("Payments", "", "Betalinger", "Betalningar");

export const CustomerContract_Invoicee_Invoices_PaymentStatus = new Translation("Payment status", "", "Betalingsstatus", "Betalstatus");

export const CustomerContract_Invoicee_Invoices_Processing = new Translation("Processing", "", "Under behandling", "Under behandling");

export const CustomerContract_Invoicee_Invoices_ProposeDebtCollection = new Translation("Proposal for debt collection", "", "Forslag til inkasso", "Förslag till inkasso");

export const CustomerContract_Invoicee_Invoices_Reference = new Translation("ReferenceNr", "", "KID-nummer", "OCR");

export const CustomerContract_Invoicee_Invoices_RemainingAmount = new Translation("Remaining", "", "Restbeløp", "Restbelopp");

export const CustomerContract_Invoicee_Invoices_ReminderFee = new Translation("Invoice reminder fee for", "", "Purregebyr på faktura", "Påminnelseavgift för faktura");

export const CustomerContract_Invoicee_Invoices_ReminderFeeAmount = new Translation("Charge", "", "Gebyr", "Avgift");

export const CustomerContract_Invoicee_Invoices_ReminderFeeDescription = new Translation("Statutory reminder fee for invoice", "Lakisääteinen laskun muistutusmaksu", "Lovpålagt purregebyr på faktura", "Lagstadgad påminnelseavgift för faktura");

export const CustomerContract_Invoicee_Invoices_ReminderFeeDescriptionText = new Translation("Text on invoice", "", "Tekst på faktura", "Text på faktura");

export const CustomerContract_Invoicee_Invoices_ReminderFeeDoNotCharge = new Translation("Do not charge a fee", "", "Ikke ta gebyr", "Debitera inte avgift");

export const CustomerContract_Invoicee_Invoices_ReminderFeeIcon = new Translation("Reminder fee", "", "Påminnelsesgebyr", "Påminnelseavgift");

export const CustomerContract_Invoicee_Invoices_ReminderFeeIcon2 = new Translation("charged on invoice", "", "belastes på faktura", "debiterad på faktura");

export const CustomerContract_Invoicee_Invoices_ReminderFeeIcon3 = new Translation("not yet charged", "", "ennå ikke belastet", "ännu inte debiterad");

export const CustomerContract_Invoicee_Invoices_ReminderFeeIconRemoved = new Translation("Reminder fee removed", "", "Påminnelsesgebyr fjernet", "Påminnelseavgift borttagen");

export const CustomerContract_Invoicee_Invoices_ReminderFeeNotToChargeReason = new Translation("Reason not to charge a reminder fee", "", "Årsak til ikke å kreve et påminnelsesgebyr", "Anledning till att inte debitera påminnelseavgift");

export const CustomerContract_Invoicee_Invoices_ReminderFeeRemoved = new Translation("Sent (no fee)", "", "Sendt (uten gebyr)", "Skickad (ingen avgift)");

export const CustomerContract_Invoicee_Invoices_ReminderHeader = new Translation("Reminder", "", "Påminnelse", "Påminnelse");

export const CustomerContract_Invoicee_Invoices_ReminderSent = new Translation("Sent", "", "Sendt", "Skickad");

export const CustomerContract_Invoicee_Invoices_SendInvoiceViaEmail = new Translation("Send invoice via email", "", "Send faktura via e-post", "Skicka faktura via e-post");

export const CustomerContract_Invoicee_Invoices_SendInvoiceViaEmailButton = new Translation("Send email", "", "Send e-post", "Skicka e-post");

export const CustomerContract_Invoicee_Invoices_SendInvoiceViaEmailInfo = new Translation("The invoice PDF will be attached to the email", "", "Fakturaen PDF vil bli vedlagt e-posten", "Faktura PDF kommer att bifogas i mailet");

export const CustomerContract_Invoicee_Invoices_SendInvoiceViaSMS = new Translation("Send payment information via SMS", "", "Send betalingsinformasjon via SMS", "Skicka betalningsinformation via SMS");

export const CustomerContract_Invoicee_Invoices_SendInvoiceViaSMSButton = new Translation("Send SMS", "", "Send SMS", "Skicka SMS");

export const CustomerContract_Invoicee_Invoices_SMSTemplate = new Translation("Hello,\\\\n\\\\nPAYMENT INFORMATION\\\\n\\\\nPayable to: Svea\\\\nReference: \u003c#reference#\u003e\\\\nAccount Number: \u003c#bgnr_svea#\u003e\\\\nAmount: \u003c#amount#\u003e\\\\nDue date: \u003c#due_date#\u003e\\\\n\\\\n\\\\nSincerely\\\\n\\\\n\u003c#client_name#\u003e", "Hei,\\\\n\\\\nMAKSUTIEDOT\\\\n\\\\nMaksunsaaja: Svea Bank AB, filial i Finland\\\\nViitenumero: \u003c#reference#\u003e\\\\nTilinumero: \u003c#bgnr_svea#\u003e\\\\nIBAN: \u003c#iban#\u003e\\\\nSWIFT/BIC: \u003c#bic#\u003e\\\\nSumma: \u003c#amount#\u003e\\\\nEräpäivä: \u003c#due_date#\u003e\\\\n\\\\n\\\\nYstävällisin terveisin\\\\n\\\\n\u003c#client_name#\u003e", "Hei,\\\\n\\\\nBETALINGSINFORMASJON\\\\n\\\\nKontomottaker: Svea Bank AB, filial i Norge\\\\nKID-nummer: \u003c#reference#\u003e\\\\nKontonummer: \u003c#bgnr_svea#\u003e\\\\nBeløp: \u003c#amount#\u003e\\\\nForfallsdato: \u003c#due_date#\u003e\\\\n\\\\n\\\\nVennlig hilsen\\\\n\\\\n\u003c#client_name#\u003e", "Hej,\\\\n\\\\nBETALNINGSINFORMATION\\\\n\\\\nBetalas till: Svea\\\\nOCR: \u003c#reference#\u003e\\\\nPlusgiro: \u003c#pgnr_svea#\u003e\\\\nBankgiro: \u003c#bgnr_svea#\u003e\\\\nBelopp: \u003c#amount#\u003e\\\\nFörfallodatum: \u003c#due_date#\u003e\\\\n\\\\n\\\\nMed vänlig hälsning\\\\n\\\\n\u003c#client_name#\u003e");

export const CustomerContract_Invoicee_Invoices_SoftReminder = new Translation("Soft reminder", "", "Vennlig påminnelse", "Mjuk påminnelse");

export const CustomerContract_Invoicee_Invoices_Status = new Translation("Status", "", "Status", "Status");

export const CustomerContract_Invoicee_Invoices_StatusDemand = new Translation("Claim status", "", "Kravstatus", "Kravstatus");

export const CustomerContract_Invoicee_Invoices_StatusPayment = new Translation("Payment status", "", "Betalingsstatus", "Betalstatus");

export const CustomerContract_Invoicee_Invoices_TransactionType = new Translation("Transaction type", "", "Transaksjonstype", "Transaktionstyp");

export const CustomerContract_Invoicee_Invoices_UpcomingInvoices = new Translation("Upcoming invoices", "", "Kommende fakturaer", "Kommande fakturor");

export const CustomerContract_Invoicee_Invoices_Void = new Translation("Void", "", "Slette", "Makulera");

export const CustomerContract_Invoicee_Invoices_VoidInvoice = new Translation("Void/Write-off", "", "Slette/Avskrive", "Makulera/Avskriva");

export const CustomerContract_Invoicee_Invoices_VoidRemaining = new Translation("Void remaining amount", "", "Kreditere resterende beløp", "Makulera resterande belopp");

export const CustomerContract_Invoicee_Invoices_WaitingToLoad = new Translation("Waiting to load", "", "Venter på å laste", "Väntar på att ladda");

export const CustomerContract_Invoicee_InvoiceStatus = new Translation("Invoiced", "", "Fakturert", "Faktureras");

export const CustomerContract_Invoicee_ManualDistributionChannel = new Translation("Invoice distribution", "", "Fakturadistribusjon", "Fakturadistribution");

export const CustomerContract_Invoicee_MissingInvoiceeNr = new Translation("Missing invoicee number", "", "Mangler kundenummer", "Saknar kundnummer");

export const CustomerContract_Invoicee_Mortgage = new Translation("Mortgage", "", "Belåning", "Belåning");

export const CustomerContract_Invoicee_Name = new Translation("Name", "", "Navn", "Namn");

export const CustomerContract_Invoicee_NotApproved = new Translation("Not approved", "", "Ikke godkjent", "Ej godkänd");

export const CustomerContract_Invoicee_Notes_Value = new Translation("Notes", "", "Notater", "Anteckningar");

export const CustomerContract_Invoicee_Notes_CreateNote = new Translation("Create note", "", "Lag et notat", "Skapa anteckning");

export const CustomerContract_Invoicee_Notes_WaitingToLoad = new Translation("Waiting to load notes", "", "Venter på å laste notater", "Väntar på att ladda anteckningar");

export const CustomerContract_Invoicee_Notes_WriteNotePlaceholder = new Translation("Write a note here", "", "Skriv et notat her", "Skriv en anteckning här");

export const CustomerContract_Invoicee_NumberDirectory_Value = new Translation("Number Directory", "", "Nummerinformasjon", "Nummerupplysning");

export const CustomerContract_Invoicee_NumberDirectory_AddressOnly = new Translation("Only address", "", "Bare adresse", "Bara adress");

export const CustomerContract_Invoicee_NumberDirectory_All = new Translation("All (name \u0026 address)", "", "Alt (navn \u0026 adresse)", "Allt (namn \u0026 adress)");

export const CustomerContract_Invoicee_NumberDirectory_CurrentChoice = new Translation("Current choice", "", "Nåværende valg", "Nuvarande val");

export const CustomerContract_Invoicee_NumberDirectory_NameOnly = new Translation("Only name", "", "Bare navn", "Bara namn");

export const CustomerContract_Invoicee_NumberDirectory_SearchNumber = new Translation("Search number", "", "Søk nummer", "Sök nummer");

export const CustomerContract_Invoicee_NumberDirectory_SendAgain = new Translation("Send again", "", "Send igjen", "Skicka igen");

export const CustomerContract_Invoicee_NumberDirectory_YouHaveUnsavedChanges = new Translation("You have unsaved changes", "", "Du har ulagrede endringer", "Du har osparade ändringar");

export const CustomerContract_Invoicee_OmniChannel = new Translation("Automatic (via Omnichannel)", "", "Automatisk (via Omnichannel)", "Automatisk (via Omnichannel)");

export const CustomerContract_Invoicee_OmniChannelViaFenix = new Translation("Manual (via Fenix)", "", "Manuell (via Fenix)", "Manuell (via Fenix)");

export const CustomerContract_Invoicee_OnlyViaApi = new Translation("This field can only be edited through API", "", "Dette feltet kan bare redigeres via API", "Detta fält kan bara redigeras via API");

export const CustomerContract_Invoicee_OpenS5 = new Translation("Open in S5", "", "Åpne i S5", "Öppna i S5");

export const CustomerContract_Invoicee_OrgNrExist = new Translation("Personnummer already exists", "", "Personnummer eksisterer allerede", "Personnummer finns redan");

export const CustomerContract_Invoicee_OrgNrValidation = new Translation("Invalid personal number", "", "Ugyldig personnummer", "Ogiltigt personnummer");

export const CustomerContract_Invoicee_OurReference = new Translation("Our invoice reference", "", "Vår fakturareferanse", "Vår fakturareferens");

export const CustomerContract_Invoicee_PaymentMethod = new Translation("Payment method", "", "Betalingsmetode", "Betalningsmetod");

export const CustomerContract_Invoicee_PaymentSlip = new Translation("Custom payment slip", "", "Betalingsseddel", "Inbetalningsavi");

export const CustomerContract_Invoicee_PaymentTerms_Value = new Translation("Payment terms", "", "Betalingsbetingelser", "Betalningsvillkor");

export const CustomerContract_Invoicee_PaymentTerms_ClientStandard = new Translation("Default", "", "Standard", "Standard");

export const CustomerContract_Invoicee_PaymentTerms_ClientStandardInfo = new Translation("The number of days after the invoice date when the invoice becomes due if nothing specific is selected for the customer. It is a default value that is set for all customers.", "", "Antall dager etter fakturadato når fakturaen forfaller dersom det ikke er valgt noe spesifikt for kunden. Det er en standardverdi som er satt for alle kunder.", "Det antal dagar efter fakturadatum då fakturan förfaller om inget specifikt väljs för kunden. Det är ett standardvärde som sätts för alla kunder.");

export const CustomerContract_Invoicee_PaymentTerms_InvoiceeFixed = new Translation("Fixed day of the month", "", "Fast dag i måneden", "Fast dag i månaden");

export const CustomerContract_Invoicee_PaymentTerms_InvoiceeFixedInfo = new Translation("This means a fixed day of the month when the invoice is always due. That is, if you specify 25 as a fixed due date, then the invoice will always be due on the 25th of each month. If you enter 31, for a month shorter it will choose the latest possible day. February therefore gets the 28th.", "", "Dette betyr en fast dag i måneden når fakturaen alltid forfaller. Det vil si at hvis du oppgir 25 som fast forfallsdato, så vil alltid fakturaen forfalle den 25. i hver måned. Hvis du skriver inn 31, vil den for en måned kortere velge den siste mulige dagen. februar får derfor den 28.", "Det betyder en fast dag i månaden då fakturan alltid förfaller. Dvs om man anger 25 som fast förfallodag, då kommer fakturan alltid förfalla den 25e varje månad. Om du anger 31 kommer det för en månad som är kortare att välja den senaste möjliga dagen. Februari får alltså den 28e.");

export const CustomerContract_Invoicee_PaymentTerms_InvoiceeSpecific = new Translation("Specific", "", "Spesifikk", "Specifik");

export const CustomerContract_Invoicee_PaymentTerms_InvoiceeSpecificInfo = new Translation("It is possible to specify the number of days for each customer.", "", "Det er mulig å angi antall dager for hver kunde.", "Det går att specificera antal dagar för respektive kund.");

export const CustomerContract_Invoicee_PaymentTermsInfo = new Translation("Payment terms specify the date on which the invoice is due. The normal is a number of days from the invoice date. For example, if the invoice date is 2023-01-01 and there are 10-day payment terms, then the invoice is due on 2023-01-11.", "", "Betalingsbetingelser spesifiserer forfallsdatoen for fakturaen. Normalen er et antall dager fra fakturadato. For eksempel, hvis fakturadatoen er 2023-01-01 og det er 10-dagers betalingsbetingelser, forfaller fakturaen 2023-01-11.", "Betalningsvillkor specificerar det datum då fakturan förfaller. Det normala är ett antal dagar från fakturadatum. Exempelvis om fakturadatum är 2023-01-01 och det är 10 dagars betalningsvillkor, då förfaller fakturan 2023-01-11.");

export const CustomerContract_Invoicee_PeppolAddress = new Translation("Peppol ID", "", "EHF-adresse", "Peppol ID");

export const CustomerContract_Invoicee_PeppolAddressRequired = new Translation("Peppol ID is required.", "", "EHF-adresse må fylles ut.", "Peppol ID måste vara ifyllt.");

export const CustomerContract_Invoicee_PhoneNr = new Translation("Phone", "", "Telefon", "Telefon");

export const CustomerContract_Invoicee_PostalAddress = new Translation("Postal Address", "", "Adresse ", "Postadress");

export const CustomerContract_Invoicee_PostalCode = new Translation("ZIP Code", "", "Post kode", "Postnummer");

export const CustomerContract_Invoicee_SendSMS_Value = new Translation("Send SMS", "", "Send SMS", "Skicka SMS");

export const CustomerContract_Invoicee_SendSMS_Message = new Translation("Message (max 320 characters)", "", "Melding (maks 320 tegn)", "Meddelande (max 320 tecken)");

export const CustomerContract_Invoicee_SendSMS_Receiver = new Translation("Receiver", "", "Mottaker", "Mottagare");

export const CustomerContract_Invoicee_SendSMS_Send = new Translation("Send", "", "Send", "Skicka");

export const CustomerContract_Invoicee_SendSMS_Sent = new Translation("SMS will be sent within 5 minutes", "", "SMS vil bli sendt innen 5 minutter", "SMS skickas inom 5 minuter");

export const CustomerContract_Invoicee_Services = new Translation("Services", "", "Tjenester", "Tjänster");

export const CustomerContract_Invoicee_Subscriptions_Active = new Translation("Active", "", "Aktiv", "Aktiv");

export const CustomerContract_Invoicee_Subscriptions_CannotLoadSims = new Translation("Cannot load Sims. Missing phone numbers with active Imsi number.", "", "Kan ikke laste inn Sims. Manglende telefonnumre med aktivt Imsi-nummer.", "Kan ej ladda Sims. Det saknas telefonnummer med aktiva Imsi nummer.");

export const CustomerContract_Invoicee_Subscriptions_Close = new Translation("Close", "", "Lukk", "Stäng");

export const CustomerContract_Invoicee_Subscriptions_Consumption_AccountNo = new Translation("Account number", "Tilinumero", "Kontonummer", "Kontonummer");

export const CustomerContract_Invoicee_Subscriptions_Consumption_Cancel = new Translation("Cancel", "Peruuta", "Avbryt", "Avbryt");

export const CustomerContract_Invoicee_Subscriptions_Consumption_ChargePerUnit = new Translation("Charge per unit", "Hinta yksikköä kohden", "Pris per enhet", "Pris per enhet");

export const CustomerContract_Invoicee_Subscriptions_Consumption_ChargeUnit = new Translation("Charge unit", "Hinnoitteluyksikkö", "Debiteringsenhet", "Debiteringsenhet");

export const CustomerContract_Invoicee_Subscriptions_Consumption_Close = new Translation("Close", "Sulje", "Lukk", "Stäng");

export const CustomerContract_Invoicee_Subscriptions_Consumption_Description = new Translation("Description", "Kuvaus", "Beskrivelse", "Beskrivning");

export const CustomerContract_Invoicee_Subscriptions_Consumption_Edit = new Translation("Edit consumption fee", "Muokkaa kulutusmaksua", "Rediger forbruksavgift", "Redigera förbrukningsavgift");

export const CustomerContract_Invoicee_Subscriptions_Consumption_FeeExclVat = new Translation("Fee excl. VAT", "Maksu ilman ALV:tä", "Avgift ekskl. MVA", "Avgift exkl. moms");

export const CustomerContract_Invoicee_Subscriptions_Consumption_FeeInclVat = new Translation("Fee incl. VAT", "Maksu sisältäen ALV:n", "Avgift inkl. MVA", "Avgift inkl. moms");

export const CustomerContract_Invoicee_Subscriptions_Consumption_PeriodFrom = new Translation("Period from", "Jakso alkaen", "Periode fra", "Period från");

export const CustomerContract_Invoicee_Subscriptions_Consumption_PeriodTo = new Translation("Period to", "Jakso asti", "Periode til", "Period till");

export const CustomerContract_Invoicee_Subscriptions_Consumption_Save = new Translation("Save", "Tallenna", "Lagre", "Spara");

export const CustomerContract_Invoicee_Subscriptions_Consumption_UnitOfMeasure = new Translation("Unit of measure", "Mittayksikkö", "Måleenhet", "Måttenhet");

export const CustomerContract_Invoicee_Subscriptions_Consumption_VatRatePercent = new Translation("VAT rate (%)", "ALV-prosentti", "MVA-sats (%)", "Momssats (%)");

export const CustomerContract_Invoicee_Subscriptions_Consumption_Volume = new Translation("Volume", "Määrä", "Volum", "Volym");

export const CustomerContract_Invoicee_Subscriptions_Contract = new Translation("Contract", "", "Kontrakt", "Kontrakt");

export const CustomerContract_Invoicee_Subscriptions_ContractsMissing = new Translation("This customer has no contract", "", "Denne kunden har ingen kontrakt", "Denna kund saknar kontrakt");

export const CustomerContract_Invoicee_Subscriptions_CreateActivation = new Translation("Create number", "", "Opprett nummer", "Skapa nummer");

export const CustomerContract_Invoicee_Subscriptions_CreateDocument = new Translation("Create letter", "", "Lag brev", "Skapa brev");

export const CustomerContract_Invoicee_Subscriptions_CreateFrozenMonth = new Translation("Create frozen month", "", "Lag frossen måned", "Skapa frusen månad");

export const CustomerContract_Invoicee_Subscriptions_CreateFrozenMonths_Value = new Translation("Create frozen months", "", "Lag frosne måneder", "Skapa frysta månader");

export const CustomerContract_Invoicee_Subscriptions_CreateFrozenMonths_Cancel = new Translation("Cancel", "", "Avbryt", "Avbryt");

export const CustomerContract_Invoicee_Subscriptions_CreateFrozenMonths_Create = new Translation("Create", "", "Skape", "Skapa");

export const CustomerContract_Invoicee_Subscriptions_CreateFrozenMonths_Edit = new Translation("Edit", "", "Redigere", "Redigera");

export const CustomerContract_Invoicee_Subscriptions_CreateFrozenMonths_FeeImpact = new Translation("Fees that are impacted", "", "Avgifter som påverkes", "Avgifter som påverkas");

export const CustomerContract_Invoicee_Subscriptions_CreateFrozenMonths_FeeNotImpact = new Translation("Fees that not are impacted", "", "Avgifter som inte påverkes", "Avgifter som inte påverkas");

export const CustomerContract_Invoicee_Subscriptions_CreateFrozenMonths_Save = new Translation("Save", "", "Lagre", "Spara");

export const CustomerContract_Invoicee_Subscriptions_CreateInportation_Value = new Translation("Create inportation", "", "Opprett import", "Skapa inportering");

export const CustomerContract_Invoicee_Subscriptions_CreateInportation_CreatePortationNotAllowed = new Translation("There is already an active port, cancel it before a new one is created", "", "Det er allerede en aktiv port, avbryt den før en ny opprettes", "Det finns redan en aktiv portering, avbryt den innan en ny skapas");

export const CustomerContract_Invoicee_Subscriptions_CreateSubscription_ShowInactiveContractTypes = new Translation("Also show inactive", "", "Vis også inaktiv", "Visa även inaktiva");

export const CustomerContract_Invoicee_Subscriptions_DownloadPDF = new Translation("Download PDF", "", "Last ned PDF", "Ladda ner PDF");

export const CustomerContract_Invoicee_Subscriptions_FeeAdjustConfirmation_Value = new Translation("You have changed the customers billing interval, do you also want to adjust the fees?", "", "Du har endret faktureringsintervallet på kunden, vil du også justere avgifter?", "Du har ändrat faktureringsintervall på kunden, vill du även justera avgifterna?");

export const CustomerContract_Invoicee_Subscriptions_FeeAdjustConfirmation_Cancel = new Translation("Cancel", "", "Avbryt", "Avbryt");

export const CustomerContract_Invoicee_Subscriptions_FeeAdjustConfirmation_Change = new Translation("Change", "", "Avansere", "Förskott");

export const CustomerContract_Invoicee_Subscriptions_FeeAdjustConfirmation_Confirm = new Translation("Confirm", "", "Bekrefte", "Bekräfta");

export const CustomerContract_Invoicee_Subscriptions_FeeAdjustConfirmation_Fee = new Translation("Fee", "", "Lade", "Avgift");

export const CustomerContract_Invoicee_Subscriptions_FeeAdjustConfirmation_From = new Translation("from", "", "fra", "från");

export const CustomerContract_Invoicee_Subscriptions_FeeAdjustConfirmation_Info = new Translation("The number of months in advance should correspond to the billing interval.", "", "Antall måneder i forveien skal tilsvare faktureringsintervallet.", "Antal månader i förskott bör motsvara faktureringsintervallet.");

export const CustomerContract_Invoicee_Subscriptions_FeeAdjustConfirmation_To = new Translation("to", "", "til", "till");

export const CustomerContract_Invoicee_Subscriptions_FeeForm_MonthsInAdvance = new Translation("Months in advance", "", "Avansere", "Förskott");

export const CustomerContract_Invoicee_Subscriptions_FeeForm_OngoingFee = new Translation("Ongoing fee", "", "Løpende gebyr", "Löpande avgift");

export const CustomerContract_Invoicee_Subscriptions_FeeForm_Value = new Translation("Value", "", "Verdi", "Värde");

export const CustomerContract_Invoicee_Subscriptions_Fees_Value = new Translation("Fees", "", "Avgifter", "Avgifter");

export const CustomerContract_Invoicee_Subscriptions_Fees_CreateFee = new Translation("Create fee", "", "Opprett avgift", "Skapa avgift");

export const CustomerContract_Invoicee_Subscriptions_Fees_FeeDescriptionWarning1 = new Translation("Only the first", "", "Kun de første", "Endast de första");

export const CustomerContract_Invoicee_Subscriptions_Fees_FeeDescriptionWarning2 = new Translation("characters will appear on the invoice", "", "tegnene vises på fakturaen", "tecknen kommer att synas på fakturan");

export const CustomerContract_Invoicee_Subscriptions_Fees_FeesAreMortgaged = new Translation("These fees belong to a mortgaged contract and cannot be edited.", "", "Disse gebyrene tilhører en pantsatt kontrakt og kan ikke redigeres.", "Dessa avgifter tillhör ett belånat kontrakt och kan inte redigeras.");

export const CustomerContract_Invoicee_Subscriptions_Fees_TerminatedFees = new Translation("Terminated fees", "", "Fullførte avgifter", "Avslutade avgifter");

export const CustomerContract_Invoicee_Subscriptions_Fees_TerminatingFee = new Translation("Terminating fee", "", "Avslutter avgifter", "Avslutar avgift");

export const CustomerContract_Invoicee_Subscriptions_Fees_WaitingToLoadFees = new Translation("Waiting to load fees", "", "Venter på å laste avgifter", "Väntar på att ladda avgifter");

export const CustomerContract_Invoicee_Subscriptions_FeesMissing = new Translation("This subscription has no fees", "", "Dette abonnementet har ingen avgifter", "Detta abonnemang saknar avgifter");

export const CustomerContract_Invoicee_Subscriptions_FrozenMonths = new Translation("Frozen Months", "", "Fryste måneder", "Frysta månader");

export const CustomerContract_Invoicee_Subscriptions_FrozenMonthsForm_BindingTime = new Translation("Impact binding time", "", "Påvirke bindingstid", "Påverka bindningstid");

export const CustomerContract_Invoicee_Subscriptions_FrozenMonthsForm_Extend = new Translation("Extend binding time", "", "Forleng bindningstid", "Förläng bindningstid");

export const CustomerContract_Invoicee_Subscriptions_FrozenMonthsForm_Header = new Translation("Free months means that monthly fees are paused for a period of time. Only defined fees are invoiced.", "", "Frie måndeder innebærer at månedsavgifter pauses i en periode. Fortsatt definerte avgifter faktureres.", "Fria månader innebär att månadsavgifter pausas under en tid. Endast definierade avgifter faktureras.");

export const CustomerContract_Invoicee_Subscriptions_FrozenMonthsForm_NoReason = new Translation("No reason", "", "Ingen anledning", "Ingen anledning");

export const CustomerContract_Invoicee_Subscriptions_FrozenMonthsForm_Reason = new Translation("Reason for frozen month", "", "Årsak til fryst abonnement", "Orsak till fryst månad");

export const CustomerContract_Invoicee_Subscriptions_FrozenMonthsMissing = new Translation("This subscription has no frozen months", "", "Dette abonnementet har ingen frosne måneder", "Denna prenumeration har inga frysta månader");

export const CustomerContract_Invoicee_Subscriptions_History_Value = new Translation("History", "", "Historik", "Historik");

export const CustomerContract_Invoicee_Subscriptions_History_AreYouSure = new Translation("Are you sure you want to delete the last change?", "", "Er du sikker på at du vil slette den siste endringen?", "Är du säker på att du vill ta bort den senaste ändringen?");

export const CustomerContract_Invoicee_Subscriptions_History_AreYouSure2 = new Translation("Please note that this action does not affect any fees. This must be done manually.", "", "Vær oppmerksom på at denne handlingen ikke påvirker noen avgifter. Dette må gjøres manuelt.", "Observera att denna handling inte påverkar några avgifter. Detta måste skötas manuellt.");

export const CustomerContract_Invoicee_Subscriptions_History_ContractEvent = new Translation("Contract", "", "Kontrakt", "Kontrakt");

export const CustomerContract_Invoicee_Subscriptions_History_ContractType = new Translation("Contract type", "", "Abonnementsskjema", "Abonnemangsform");

export const CustomerContract_Invoicee_Subscriptions_History_ContractTypeChanges = new Translation("Contract type changes", "", "Abonnementsskjemaendringer", "Abonnemangsformsbyten");

export const CustomerContract_Invoicee_Subscriptions_History_NoContractEvent = new Translation("No changes", "", "Ingen forandringer", "Inga förändringar");

export const CustomerContract_Invoicee_Subscriptions_History_NoContractTypeChanges = new Translation("Could not find any contract type changes", "", "Fant ingen endringer i abonnementsskjemaet", "Kunde inte hitta några abonnemangsformsbyten");

export const CustomerContract_Invoicee_Subscriptions_History_NoNumberChanges = new Translation("Could not find any number changes", "", "Fant ingen nummerendringer", "Kunde inte hitta några nummerförändringar");

export const CustomerContract_Invoicee_Subscriptions_History_NumberChanges = new Translation("Number changes", "", "Nummerendringer", "Nummerförändringar");

export const CustomerContract_Invoicee_Subscriptions_History_NumberHistory = new Translation("Number history", "", "Nummerhistorikk", "Nummerhistorik");

export const CustomerContract_Invoicee_Subscriptions_History_UntilFurtherNotice = new Translation("Until further notice", "", "Inntil videre", "Tillsvidare");

export const CustomerContract_Invoicee_Subscriptions_Inactive = new Translation("Inactive", "", "Inaktiv", "Inaktiv");

export const CustomerContract_Invoicee_Subscriptions_Month = new Translation("month", "", "måned", "månad");

export const CustomerContract_Invoicee_Subscriptions_Months = new Translation("months", "", "måneder", "månader");

export const CustomerContract_Invoicee_Subscriptions_Number = new Translation("Number", "", "Nummer", "Nummer");

export const CustomerContract_Invoicee_Subscriptions_NumberInfo = new Translation("If the number belongs to a person other than the selected customer, enter this personal or organization number instead.", "", "Hvis nummeret tilhører en annen person enn den valgte kunden, skriver du inn dette person- eller organisasjonsnummeret i stedet.", "Om numret tillhör annan person än vald kund, ange detta person- eller organisationsnumret istället.");

export const CustomerContract_Invoicee_Subscriptions_Order_Value = new Translation("Order", "", "Rekkefølge", "Order");

export const CustomerContract_Invoicee_Subscriptions_Order_Add = new Translation("Add", "", "Legg til", "Lägg till");

export const CustomerContract_Invoicee_Subscriptions_Order_Addition = new Translation("Addition", "", "Tillegg", "Tillägg");

export const CustomerContract_Invoicee_Subscriptions_Order_CancelledDate = new Translation("Cancel time", "", "Avbryt tid", "Avbryttid");

export const CustomerContract_Invoicee_Subscriptions_Order_CreatedBy = new Translation("Created by", "", "Laget av", "Skapad av");

export const CustomerContract_Invoicee_Subscriptions_Order_ErrorDate = new Translation("Error time", "", "Feil tid", "Feltid");

export const CustomerContract_Invoicee_Subscriptions_Order_Errors = new Translation("Errors", "", "Fel", "Fel");

export const CustomerContract_Invoicee_Subscriptions_Order_NetworkDetails = new Translation("Network details", "", "Nettverksdetaljer", "Nätverksdetaljer");

export const CustomerContract_Invoicee_Subscriptions_Order_NoPendingRequests = new Translation("No pending requests", "", "Ingen ventende forespørsler", "Inga väntande förfrågningar");

export const CustomerContract_Invoicee_Subscriptions_Order_NoRequests = new Translation("No requests", "", "Ingen forespørsler", "Inga förfrågningar");

export const CustomerContract_Invoicee_Subscriptions_Order_OrderTime = new Translation("Order time", "", "Bestill tid", "Beställningstid");

export const CustomerContract_Invoicee_Subscriptions_Order_OrderType = new Translation("Order type", "", "Bestillingstype", "Ordertyp");

export const CustomerContract_Invoicee_Subscriptions_Order_Parameters = new Translation("Parameters", "", "Parametere", "Parametrar");

export const CustomerContract_Invoicee_Subscriptions_Order_PendingRequests = new Translation("Pending requests", "", "Forespørsel under behandling", "Väntande förfrågningar");

export const CustomerContract_Invoicee_Subscriptions_Order_Removal = new Translation("Removal", "", "Fjerning", "Borttag");

export const CustomerContract_Invoicee_Subscriptions_Order_Requests = new Translation("Requests", "", "Forespørsel", "Förfrågningar");

export const CustomerContract_Invoicee_Subscriptions_Order_Retry = new Translation("Retry", "", "Prøv igjen", "Försök igen");

export const CustomerContract_Invoicee_Subscriptions_Order_SuccessTime = new Translation("Success time", "", "Ferdig tid", "Färdigtid");

export const CustomerContract_Invoicee_Subscriptions_Order_UpdateNetStatus = new Translation("Update net status", "", "Oppdater nettverksstatus", "Uppdatera nätstatus");

export const CustomerContract_Invoicee_Subscriptions_Order_ViewNetworkDetails = new Translation("View network details", "", "Vis nettverksdetaljer", "Se nätverksdetaljer");

export const CustomerContract_Invoicee_Subscriptions_Other_Value = new Translation("Other", "", "Annen", "Övrigt");

export const CustomerContract_Invoicee_Subscriptions_Other_BilledToInfo = new Translation("Invoicing takes place at the next invoicing occasion, either the current month or the next", "", "Fakturering skjer ved neste faktureringsanledning, enten inneværende måned eller neste", "Fakturering sker vid nästa faktureringstillfälle, antingen innevarande månad eller nästkommande");

export const CustomerContract_Invoicee_Subscriptions_Other_NextInvoiceMonth = new Translation("Next billing", "", "Neste fakturering", "Nästa fakturering");

export const CustomerContract_Invoicee_Subscriptions_Other_NoInvoiceInformation = new Translation("There is no invoicing information", "", "Det er ingen faktureringsinformasjon", "Det finns ingen faktureringsinformation");

export const CustomerContract_Invoicee_Subscriptions_Overview_AbortInportation = new Translation("Abort inportation", "", "Avbryt import", "Avbryt inportering");

export const CustomerContract_Invoicee_Subscriptions_Overview_Activation = new Translation("Activation", "", "Aktivering", "Aktivering");

export const CustomerContract_Invoicee_Subscriptions_Overview_ActiveFor = new Translation("Active for", "", "Aktiv i", "Aktivt i");

export const CustomerContract_Invoicee_Subscriptions_Overview_ActiveFrom = new Translation("Active from", "", "Aktiv fra", "Aktivt från");

export const CustomerContract_Invoicee_Subscriptions_Overview_ActiveIn = new Translation("Active in", "", "Aktiv om", "Aktivt om");

export const CustomerContract_Invoicee_Subscriptions_Overview_ActiveTo = new Translation("Active to", "", "Aktiv for", "Aktivt till");

export const CustomerContract_Invoicee_Subscriptions_Overview_Activity = new Translation("Activity", "", "Aktivitet", "Aktivitet");

export const CustomerContract_Invoicee_Subscriptions_Overview_BilledTo = new Translation("Last invoiced", "", "Sist fakturert", "Senast fakturerad");

export const CustomerContract_Invoicee_Subscriptions_Overview_BillingInfo = new Translation("Billing information", "", "Faktureringsinformasjon", "Faktureringsinformation");

export const CustomerContract_Invoicee_Subscriptions_Overview_BillingInfoFailed = new Translation("Could not find any billing information", "", "Fant ingen faktureringsinformasjon", "Det gick inte att hitta någon faktureringsinformation");

export const CustomerContract_Invoicee_Subscriptions_Overview_BillingInterval = new Translation("Billing interval", "Faktureringsintervall", "Faktureringsinformasjon", "Faktureringsintervall");

export const CustomerContract_Invoicee_Subscriptions_Overview_BoundTo = new Translation("Bound to", "", "Bundet til", "Bundet till");

export const CustomerContract_Invoicee_Subscriptions_Overview_Cancel = new Translation("Cancel", "", "Avbryt", "Avbryt");

export const CustomerContract_Invoicee_Subscriptions_Overview_Choose = new Translation("Choose", "", "Velge", "Välj");

export const CustomerContract_Invoicee_Subscriptions_Overview_ContractMovedFrom = new Translation("Moved from contract", "", "Kontrakt flyttet frå", "Flyttat från kontrakt");

export const CustomerContract_Invoicee_Subscriptions_Overview_ContractMovedTo = new Translation("Moved to contract", "", "Kontrakt flyttet til", "Flyttat till kontrakt");

export const CustomerContract_Invoicee_Subscriptions_Overview_ContractTransfered = new Translation("Contract Transfered", "", "Kontrakt flyttet", "Kontrakt flyttat");

export const CustomerContract_Invoicee_Subscriptions_Overview_CouldNotFindContract = new Translation("Could not find subscription", "", "Kunne ikke finne abonnementet", "Kunde inte hitta abonnemang");

export const CustomerContract_Invoicee_Subscriptions_Overview_Created = new Translation("Created", "", "Laget", "Skapad");

export const CustomerContract_Invoicee_Subscriptions_Overview_CreatedBy = new Translation("by", "", "av", "av");

export const CustomerContract_Invoicee_Subscriptions_Overview_CreatedChanged = new Translation("Last modified", "", "Sist endret", "Senast ändrad");

export const CustomerContract_Invoicee_Subscriptions_Overview_Date = new Translation("Date", "", "Dato", "Datum");

export const CustomerContract_Invoicee_Subscriptions_Overview_Day = new Translation("day", "", "dag", "dag");

export const CustomerContract_Invoicee_Subscriptions_Overview_Days = new Translation("days", "", "dager", "dagar");

export const CustomerContract_Invoicee_Subscriptions_Overview_DeactivateNumber = new Translation("Telephone numbers associated with this contract will be deactivated", "", "Telefonnumre knyttet til denne kontrakten vil bli deaktivert", "Telefonnummer som hör till detta kontrakt kommer att deaktiveras");

export const CustomerContract_Invoicee_Subscriptions_Overview_DeleteContract_Value = new Translation("Delete subscription", "", "Slett abonnement", "Ta bort abonnemang");

export const CustomerContract_Invoicee_Subscriptions_Overview_DeleteContract_AreYouSure = new Translation("Are you sure you want to delete the subscription?", "", "Er du sikker på at du vil slette abonnementet?", "Är du säker på att du vill ta bort abonnemanget?");

export const CustomerContract_Invoicee_Subscriptions_Overview_DeleteContract_Restrictions = new Translation("It is not possible to delete subscriptions that have been invoiced or have telephony connected", "", "Det er ikke mulig å slette abonnement som er fakturert eller har telefoni tilkoblet", "Det går inte att ta bort abonnemang som fakturerats eller har telefoni kopplat");

export const CustomerContract_Invoicee_Subscriptions_Overview_EndDate = new Translation("End date", "", "Sluttdato", "Avslutningsdatum");

export const CustomerContract_Invoicee_Subscriptions_Overview_EndUser_Value = new Translation("End user", "", "Sluttbrukere", "Slutanvändare");

export const CustomerContract_Invoicee_Subscriptions_Overview_EndUser_AlternateDisplayName = new Translation("Alternate display name", "", "Alternativt visningsnavn", "Alternativt visningsnamn");

export const CustomerContract_Invoicee_Subscriptions_Overview_EndUser_AlternateDisplayNameError = new Translation("It is not possible to have an Alternate Display Name at the same time as First, Middle and Last Name.", "", "Det er ikke mulig å ha et alternativt visningsnavn samtidig med for-, mellom- og etternavn.", "Det går inte att ha Alternativt visningsnamn samtidigt som För- Mellan- och Efternamn.");

export const CustomerContract_Invoicee_Subscriptions_Overview_EndUser_FirstName = new Translation("First name", "", "Fornavn", "Förnamn");

export const CustomerContract_Invoicee_Subscriptions_Overview_EndUser_LastName = new Translation("Last name", "", "Etternavn", "Efternamn");

export const CustomerContract_Invoicee_Subscriptions_Overview_EndUser_MiddleName = new Translation("Middle name", "", "Mellomnavn", "Mellannamn");

export const CustomerContract_Invoicee_Subscriptions_Overview_EndUserCategory = new Translation("End user category", "", "Sluttbrukerkategori", "Slutanvändarkategori");

export const CustomerContract_Invoicee_Subscriptions_Overview_EndUserOrgNr = new Translation("End user Org.nr/SSN", "", "Sluttbrukerens Org-/Personnummer", "Slutanvändares Org.nr/Personnummer");

export const CustomerContract_Invoicee_Subscriptions_Overview_ExclVat = new Translation("excl. VAT", "", "ekskl. mva", "exkl. moms");

export const CustomerContract_Invoicee_Subscriptions_Overview_From = new Translation("From", "", "Fra", "Från");

export const CustomerContract_Invoicee_Subscriptions_Overview_GiveRemainingAmount = new Translation("Give remaining amount for free", "", "By på gjenværende beløp", "Bjud på resterande belopp");

export const CustomerContract_Invoicee_Subscriptions_Overview_GoToPlannedChanges = new Translation("Go to planned changes", "", "Gå til planlagte endringer", "Gå till planerade byten");

export const CustomerContract_Invoicee_Subscriptions_Overview_Hour = new Translation("hour", "", "time", "timme");

export const CustomerContract_Invoicee_Subscriptions_Overview_Hours = new Translation("hours", "", "timer", "timmar");

export const CustomerContract_Invoicee_Subscriptions_Overview_InclVat = new Translation("incl. VAT", "", "inkl. mva", "inkl. moms");

export const CustomerContract_Invoicee_Subscriptions_Overview_InvoiceRemainingAmount = new Translation("Invoice remaining amount", "", "Fakturere gjenværende beløp", "Slutfakturera resterande belopp");

export const CustomerContract_Invoicee_Subscriptions_Overview_InvoiceStatus = new Translation("Invoiced", "", "Fakturert", "Faktureras");

export const CustomerContract_Invoicee_Subscriptions_Overview_InvoiceUntilDate = new Translation("Invoice as usual until chosen date", "", "Faktura som vanlig til valgt dato", "Fakturera som vanligt fram till valt datum");

export const CustomerContract_Invoicee_Subscriptions_Overview_Mortgage = new Translation("Mortgage", "", "Belåning", "Belåning");

export const CustomerContract_Invoicee_Subscriptions_Overview_No = new Translation("No", "", "Nei", "Nej");

export const CustomerContract_Invoicee_Subscriptions_Overview_None = new Translation("None", "Ingen", "Nei", "Ingen");

export const CustomerContract_Invoicee_Subscriptions_Overview_Object = new Translation("Object", "", "Gjenstand", "Objekt");

export const CustomerContract_Invoicee_Subscriptions_Overview_OrgNr = new Translation("Organization number", "", "Organisasjonsnummer", "Organisationsnummer");

export const CustomerContract_Invoicee_Subscriptions_Overview_PlannedContractTypeChange = new Translation("A contract type change is planned on", "", "Det er planlagt et abonnementsendring for", "Ett abonnemangsformsbyte är planerat");

export const CustomerContract_Invoicee_Subscriptions_Overview_PlannedOutportation = new Translation("Outportation planned", "", "Utportering planlagt", "Utportering planerad");

export const CustomerContract_Invoicee_Subscriptions_Overview_PlannedOutportationDone = new Translation("Outportation done", "", "Utportering gjennomført", "Utportering genomförd");

export const CustomerContract_Invoicee_Subscriptions_Overview_Portation = new Translation("Portation", "", "Portering", "Portering");

export const CustomerContract_Invoicee_Subscriptions_Overview_Recipient = new Translation("Recipient", "", "Mottaker", "Mottagare");

export const CustomerContract_Invoicee_Subscriptions_Overview_SearchInvoicee = new Translation("Search customer", "", "Søk kunde", "Sök kund");

export const CustomerContract_Invoicee_Subscriptions_Overview_StartDate = new Translation("Start date", "", "Startdato", "Startdatum");

export const CustomerContract_Invoicee_Subscriptions_Overview_Status = new Translation("Status", "", "Status", "Status");

export const CustomerContract_Invoicee_Subscriptions_Overview_Subscriptions = new Translation("Subscription", "", "Abonnement", "Abonnemang");

export const CustomerContract_Invoicee_Subscriptions_Overview_SumRemainingFees = new Translation("The sum of remaining fees at chosen end date is:", "", "Summen av gjenværende gebyrer på valgt sluttdato er:", "Summan av kvarvarande avgifter vid valt slutdatum är:");

export const CustomerContract_Invoicee_Subscriptions_Overview_TerminateSubscription = new Translation("Terminate subscription", "", "Avslutte abonnement", "Avsluta abonnemang");

export const CustomerContract_Invoicee_Subscriptions_Overview_TerminatingSubscription = new Translation("Terminating subscription", "", "Avslutter abonnementet", "Avslutar abonnemang");

export const CustomerContract_Invoicee_Subscriptions_Overview_Transfer = new Translation("Transfer", "", "Overfør", "Överlåt");

export const CustomerContract_Invoicee_Subscriptions_Overview_TransferContract = new Translation("Transfer subscription", "", "Flytt abonnement", "Flytta abonnemang");

export const CustomerContract_Invoicee_Subscriptions_Overview_TransferContractNew = new Translation("Hand over subscription", "", "Flytt abonnement", "Överlåt abonnemang");

export const CustomerContract_Invoicee_Subscriptions_Overview_TransferDate = new Translation("Transfer date", "", "Flyttedato", "Flyttdatum");

export const CustomerContract_Invoicee_Subscriptions_Overview_TransferringContract = new Translation("Transferring subscription", "", "Flytter abonnement", "Flyttar abonnemang");

export const CustomerContract_Invoicee_Subscriptions_Overview_Unknown = new Translation("Unknown", "", "Ukjent", "Okänd");

export const CustomerContract_Invoicee_Subscriptions_Overview_UpdateContractType_Value = new Translation("Change subscription type", "", "Endre abonnementsskjema", "Byt abonnemangsform");

export const CustomerContract_Invoicee_Subscriptions_Overview_UpdateContractType_FeesEnding = new Translation("Fees that will end", "", "Avgifter som vil bli avsluttet", "Avgifter som kommer avslutas");

export const CustomerContract_Invoicee_Subscriptions_Overview_UpdateContractType_FeesStarting = new Translation("Fees that will start", "", "Avgifter som skal igangsettes", "Avgifter som kommer påbörjas");

export const CustomerContract_Invoicee_Subscriptions_Overview_UpdateContractType_MoveAndCancellationPeriodBoundMonths = new Translation("Current cancellation period and bound months will be moved to the new fee.", "", "Nåværende oppsigelsestid og bindingstid flyttes til nytt gebyr.", "Nuvarande uppsägningstid och bindningstid kommer att flyttas till den nya avgiften.");

export const CustomerContract_Invoicee_Subscriptions_Overview_UpdateContractType_NoFeeManipulation = new Translation("No fees will be affected, only a change in subscription type will occur.", "", "Ingen avgifter vil bli påvirket, kun en abonnementstype vil skje.", "Inga avgifter kommer att påverkas, endast ett abonnemangsformsbyte kommer att ske.");

export const CustomerContract_Invoicee_Subscriptions_Overview_UpdateContractType_NoFeesWithAccountNr = new Translation("Could not find fees with the same account number.", "", "Kunne ikke finne avgifter å igangsette som har samme kontonummer.", "Kunde inte hitta avgifter som har samma kontonummer.");

export const CustomerContract_Invoicee_Subscriptions_Overview_UpdateContractType_RequiredNrOfFeesSelected = new Translation("If there is a fee to be started, there must be one to be ended, and vice versa.", "", "Hvis det er en avgift som skal startes, må det være en som skal avsluttes, og omvendt.", "Om det finns en avgift som ska påbörjas så måste det finnas en som ska avslutas, och vice versa.");

export const CustomerContract_Invoicee_Subscriptions_Overview_UpdateContractType_ShowInactiveContractTypes = new Translation("Also show inactive", "", "Vis også inaktiv", "Visa även inaktiva");

export const CustomerContract_Invoicee_Subscriptions_Overview_UpdateContractType_Today = new Translation("Today", "", "I dag", "Idag");

export const CustomerContract_Invoicee_Subscriptions_Overview_UpdateContractType_TooManyEndingFees = new Translation("It is only possible to specify one fee that will end.", "", "Det er kun mulig å spesifisere én avgift gebyr som avsluttes.", "Det är endast möjligt att ange en avgift att avsluta.");

export const CustomerContract_Invoicee_Subscriptions_Overview_UpdateContractType_TooManyStartingFees = new Translation("It is only possible to specify one fee that will begin.", "", "Det er kun mulig å spesifisere én avgift som starter.", "Det är endast möjligt att ange en avgift att påbörja.");

export const CustomerContract_Invoicee_Subscriptions_Overview_UpdateContractType_WillEnd = new Translation("Will end", "", "Skal avsluttes", "Ska avslutas");

export const CustomerContract_Invoicee_Subscriptions_Overview_UpdateContractType_WillStart = new Translation("Will begin", "", "Skal startes", "Ska påbörjas");

export const CustomerContract_Invoicee_Subscriptions_Overview_WaitingToLoadActivation = new Translation("Waiting to load activation", "", "Venter på å laste aktivering", "Väntar på att ladda aktivering");

export const CustomerContract_Invoicee_Subscriptions_Overview_WaitingToLoadSubscription = new Translation("Waiting to load subscription", "", "Venter på å laste abonnement", "Väntar på att ladda abonnemang");

export const CustomerContract_Invoicee_Subscriptions_Overview_WaitingToTerminate = new Translation("Waiting to terminate subscription", "", "Venter på å avslutte abonnementet", "Väntar på att avsluta abonnemang");

export const CustomerContract_Invoicee_Subscriptions_Overview_WithBoundTo = new Translation("taking into account the bound-to period and the cancellation period.", "", "tar hensyn til bindingsperioden og oppsigelsestiden.", "med hänsyn taget till bindningstid och uppsägningstid.");

export const CustomerContract_Invoicee_Subscriptions_PortationDate = new Translation("Portation date", "", "Porteringsdato", "Porteringsdatum");

export const CustomerContract_Invoicee_Subscriptions_PortationInfo = new Translation("A portation should be done a week in advance and can not be done on weekends or holidays. The recommended time is", "", "En portering skal gjøres en uke i forveien, og kan ikke gjøres i helgene eller på helligdager. Anbefalt tid er", "En portering bör göras en vecka i förväg och kan inte ske på helger eller helgdagar. Den rekommenderade tidpunkten är");

export const CustomerContract_Invoicee_Subscriptions_SearchContractInfo = new Translation("Possible searches are:\\\\nContract, contract type, phone number, end user, clientCrossRef.", "", "Mulige søk er:\\\\nKontrakt, kontrakt type, telefonnummer, slutt bruker, clientCrossRef.", "Möjliga sökningar är:\\\\nKontrakt, abonnemangsform, telefonnummer, slutanvändare, clientCrossRef.");

export const CustomerContract_Invoicee_Subscriptions_ShowCancelledSubscriptions = new Translation("Show cancelled", "", "Vis kansellerte", "Visa avslutade");

export const CustomerContract_Invoicee_Subscriptions_Subproduct_Value = new Translation("Subproduct", "", "Delprodukt", "Subprodukt");

export const CustomerContract_Invoicee_Subscriptions_Subproduct_Argument = new Translation("Argument", "", "Argument", "Argument");

export const CustomerContract_Invoicee_Subscriptions_Subproduct_CreateSubproduct = new Translation("Create subproduct", "", "Lag delprodukt", "Skapa subprodukt");

export const CustomerContract_Invoicee_Subscriptions_Subproduct_InactiveSubproducts = new Translation("Inactive subproducts", "", "Inaktive delprodukter", "Inaktiva subprodukter");

export const CustomerContract_Invoicee_Subscriptions_Subproduct_TerminateSubproduct = new Translation("Terminate subproduct", "", "Avslutte delprodukt", "Avsluta subprodukt");

export const CustomerContract_Invoicee_Subscriptions_SubproductFreeMonthFeeMissing = new Translation("No fee is defined as a free monthly fee.", "", "Ingen avgifter er definert som en gratis månedlig avgift.", "Ingen avgift är definierad som fri månadsavgift.");

export const CustomerContract_Invoicee_Subscriptions_SubscriptionForm = new Translation("Subscription type", "", "Abonnementsskjema", "Abonnemangsform");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Value = new Translation("Telecom", "", "Telekom", "Telekom");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Activate = new Translation("Activate", "", "Aktiver", "Aktivera");

export const CustomerContract_Invoicee_Subscriptions_Telecom_ActivateIngress = new Translation("Activate number and SIM card on the subscription.", "", "Aktiver nummer og SIM-kort på abonnementet.", "Aktivera nummer och sim-kort på abonnemanget.");

export const CustomerContract_Invoicee_Subscriptions_Telecom_ActivationTime = new Translation("Activation time", "", "Aktiveringstid", "Aktiveringstid");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Active = new Translation("Active", "", "Aktiv", "Aktivt");

export const CustomerContract_Invoicee_Subscriptions_Telecom_AllServices = new Translation("All services", "", "Alle tjenester", "Alla tjänster");

export const CustomerContract_Invoicee_Subscriptions_Telecom_AreYouSureCancelOrder = new Translation("Are you sure you want to cancel the order?", "", "Er du sikker på at du vil kansellere ordren?", "Är du säker på att du vill avbryta ordern?");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Barring = new Translation("Barring", "", "Sperring", "Spärra");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Brand = new Translation("Brand", "", "Varemerke", "Varumärke");

export const CustomerContract_Invoicee_Subscriptions_Telecom_CancelCurrentOrder = new Translation("Cancel current order", "", "Kanseller gjeldende ordre", "Avbryt nuvarande order");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Cancelled = new Translation("Cancelled", "", "Kansellert", "Avbruten");

export const CustomerContract_Invoicee_Subscriptions_Telecom_ChangeSimCard = new Translation("Change SIM-card", "", "Bytt SIM-kort", "Byt SIM-kort");

export const CustomerContract_Invoicee_Subscriptions_Telecom_CreateActivation = new Translation("Create activation", "", "Opprett aktivering", "Skapa aktivering");

export const CustomerContract_Invoicee_Subscriptions_Telecom_DataPackage = new Translation("Data package", "", "Datapakke", "Datapaket");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Deactivate = new Translation("Deactivate", "", "Deaktiver", "Deaktivera");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Done = new Translation("Done", "", "Ferdig", "Färdig");

export const CustomerContract_Invoicee_Subscriptions_Telecom_EndTime = new Translation("End time", "", "Sluttid", "Sluttid");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Error_Active = new Translation("The SIM card is active", "", "SIM-kortet er aktivt", "SIM-kortet är aktivt");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Error_Nummersatt = new Translation("The SIM is a Package Number and cannot be switched to", "", "SIM-kortet er \u0027nummersatt\u0027 og kan ikke endres", "SIM-kortet är nummersatt och går inte att byta till");

export const CustomerContract_Invoicee_Subscriptions_Telecom_FetchNumbers = new Translation("Fetch numbers", "", "Hente nummer", "Hämta nummer");

export const CustomerContract_Invoicee_Subscriptions_Telecom_History = new Translation("History", "", "Historie", "Historik");

export const CustomerContract_Invoicee_Subscriptions_Telecom_IccNotFound = new Translation("Couldn\u0027t find the ICC number in our system", "", "Kunne ikke finne ICC-nummeret i systemet vårt", "Kunde inte hitta ICC-numret i vårt system");

export const CustomerContract_Invoicee_Subscriptions_Telecom_ImsiReq1 = new Translation("This contract\u0027s contract type indicates that the product type is", "", "Denne kontraktens kontraktstype indikerer at produkttypen er", "Detta kontrakts kontraktyp indikerar att produkttypen är");

export const CustomerContract_Invoicee_Subscriptions_Telecom_ImsiReq2 = new Translation("Therefore, IMSI or ICC is required", "", "Derfor er IMSI or ICC nødvendig", "Därför krävs IMSI eller ICC");

export const CustomerContract_Invoicee_Subscriptions_Telecom_ImsiReq3 = new Translation("Go to contract type", "", "Gå til kontraktstype", "Gå till kontraktstypen");

export const CustomerContract_Invoicee_Subscriptions_Telecom_InportationNumber = new Translation("Inported number", "", "Inporteret nummer", "Inporterat nummer");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Inportations = new Translation("Inportations", "", "Inportering", "Inporteringar");

export const CustomerContract_Invoicee_Subscriptions_Telecom_InternationalOut = new Translation("International", "", "Internasjonal", "Internationellt");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Last = new Translation("Last", "", "Siste", "Senaste");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Locked = new Translation("Locked", "", "Låst", "Låst");

export const CustomerContract_Invoicee_Subscriptions_Telecom_ManualDeactivation = new Translation("Manual deactivation", "", "Manuell deaktivering", "Manuell deaktivering");

export const CustomerContract_Invoicee_Subscriptions_Telecom_MissingNetworkContractNr = new Translation("The network contract number is missing for this contract type. This can be adjusted under the Handle - Subscription Types menu.", "", "Nettverkskontraktnummeret mangler for denne kontraktstypen. Dette kan justeres under menyen Administrere - Abonnementsformer.", "Nätverkets kontraktsnummer saknas för denna kontraktstyp. Detta kan justeras under menyn Hantera - Abonnemangsformer.");

export const CustomerContract_Invoicee_Subscriptions_Telecom_MissingSim = new Translation("Missing sim", "", "Sim mangler", "Sim saknas");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Model = new Translation("Model", "", "Modell", "Modell");

export const CustomerContract_Invoicee_Subscriptions_Telecom_ModifyNumberRegistry = new Translation("Change registered number", "", "Endre registrert nummer", "Ändra registrerat nummer");

export const CustomerContract_Invoicee_Subscriptions_Telecom_MoreInfo = new Translation("More info", "", "Mer info", "Mer info");

export const CustomerContract_Invoicee_Subscriptions_Telecom_NewIcc = new Translation("New ICC", "", "Nytt ICC", "Nytt ICC");

export const CustomerContract_Invoicee_Subscriptions_Telecom_NewNumber = new Translation("New number", "", "Nytt nummer", "Nytt nummer");

export const CustomerContract_Invoicee_Subscriptions_Telecom_NoHistoryFound = new Translation("Could not find any number history", "", "Fant ingen nummerhistorikk", "Kunde inte hitta någon nummerhistorik");

export const CustomerContract_Invoicee_Subscriptions_Telecom_NoInportations = new Translation("No inportations", "", "Ingen inporteringer", "Inga inporteringar");

export const CustomerContract_Invoicee_Subscriptions_Telecom_NoOutportations = new Translation("No outportations", "", "Ingen utporteringer", "Inga utporteringar");

export const CustomerContract_Invoicee_Subscriptions_Telecom_NoProvisioning = new Translation("This function does not do any provisioning against the operator\u0027s network.", "", "Denne funksjonen gjør ingen klargjøring mot operatørens nettverk.", "Denna funktion gör ingen provisionering mot operatörens nät.");

export const CustomerContract_Invoicee_Subscriptions_Telecom_NoSimFound = new Translation("Could not find any sim card information", "", "Fant ingen SIM-kortinformasjon", "Kunde inte hitta någon simkortsinformation");

export const CustomerContract_Invoicee_Subscriptions_Telecom_NumberCategory = new Translation("Number category", "", "Nummerkategori", "Nummerkategori");

export const CustomerContract_Invoicee_Subscriptions_Telecom_NumbersReserved = new Translation("Fetched numbers are reserved for", "", "Hentet nummer er reservert i", "Hämtade nummer är reserverade i");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Outgoing = new Translation("Outgoing", "", "Utgående", "Utgående");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Outportations = new Translation("Outportations", "", "Utporteringer", "Utporteringar");

export const CustomerContract_Invoicee_Subscriptions_Telecom_SaveNewOrder = new Translation("Save new order", "", "Lagre ny ordre", "Spara ny order");

export const CustomerContract_Invoicee_Subscriptions_Telecom_ShowEverything = new Translation("Show everything", "", "Vis alt", "Visa allt");

export const CustomerContract_Invoicee_Subscriptions_Telecom_SimAndDevice = new Translation("SIM \u0026 Device", "", "SIM \u0026 Enhet", "SIM \u0026 Enhet");

export const CustomerContract_Invoicee_Subscriptions_Telecom_SimInactive = new Translation("The SIM card is inactive", "", "SIM-kortet er inaktivt", "SIM-kortet är inaktivt");

export const CustomerContract_Invoicee_Subscriptions_Telecom_SimTypeCode = new Translation("Sim card type", "", "Sim-korttype", "Simkortstyp");

export const CustomerContract_Invoicee_Subscriptions_Telecom_Supports5G = new Translation("Supports 5G", "", "Støtter 5G", "Stöder 5G");

export const CustomerContract_Invoicee_Subscriptions_Telecom_SurfLimit = new Translation("Surf limit", "", "Surfegrense", "Surfgräns");

export const CustomerContract_Invoicee_Subscriptions_Telecom_SurfRemaining = new Translation("Surf remaining", "", "Surfe gjenstående", "Surf kvar");

export const CustomerContract_Invoicee_Subscriptions_Telecom_UntilFurtherNotice = new Translation("Until further notice", "", "Inntil videre", "Tillsvidare");

export const CustomerContract_Invoicee_Subscriptions_Telecom_WaitingToLoadSims = new Translation("Waiting to load Sims", "", "Venter på å laste Sims", "Väntar på att ladda Sims");

export const CustomerContract_Invoicee_Subscriptions_TerminatedFees = new Translation("Terminated fees", "", "Fullførte avgifter", "Avslutade avgifter");

export const CustomerContract_Invoicee_Subscriptions_Traffic_Value = new Translation("Traffic", "", "Trafikk", "Trafik");

export const CustomerContract_Invoicee_Subscriptions_Traffic_Amount = new Translation("Amount", "", "Mengde", "Mängd");

export const CustomerContract_Invoicee_Subscriptions_Traffic_BasePrice = new Translation("Cost", "", "Kostnad", "Kostnad");

export const CustomerContract_Invoicee_Subscriptions_Traffic_BearerType = new Translation("Call type", "", "Samtaletype", "Samtalstyp");

export const CustomerContract_Invoicee_Subscriptions_Traffic_DownloadToExcel = new Translation("Download to excel", "", "Hent til Excel", "Hämta till Excel");

export const CustomerContract_Invoicee_Subscriptions_Traffic_NotInvoicedTraffic = new Translation("Uninvoiced traffic", "", "U fakturert trafikk", "Ej fakturerad trafik");

export const CustomerContract_Invoicee_Subscriptions_Traffic_NoTrafficFound = new Translation("No traffic found", "", "Ingen trafikk funnet", "Ingen trafik hittades");

export const CustomerContract_Invoicee_Subscriptions_Traffic_Price = new Translation("Price", "", "Pris", "Pris");

export const CustomerContract_Invoicee_Subscriptions_Traffic_PriceExcVAT = new Translation("Price (excl. VAT)", "", "Pris (ekskl. mva)", "Pris (exkl. moms)");

export const CustomerContract_Invoicee_Subscriptions_Traffic_PriceIncVAT = new Translation("Prices incl. VAT", "", "Priser inkl. mva", "Priser inkl. moms");

export const CustomerContract_Invoicee_TerminationState_Alert = new Translation("The customer has invoices in debt collection.", "The customer has invoices in debt collection.", "Kunden har fakturaer til inkasso.", "Kunden har fakturor på inkasso.");

export const CustomerContract_Invoicee_TerminationState_History = new Translation("Termination History", "Irtisanomishistoria", "Oppsigelseshistorikk", "Uppsägningshistorik");

export const CustomerContract_Invoicee_TerminationState_Hold = new Translation("The customer\u0027s termination process has been manually paused.", "The customer\u0027s termination process has been manually paused.", "Kundens termineringsprosess er manuelt satt på pause.", "Kundens terminieringsprocess är manuellt pausad.");

export const CustomerContract_Invoicee_TerminationState_Paus = new Translation("Paus termination process", "Paus termination process", "Pausa termineringsprocess", "Pausa termineringsprocess");

export const CustomerContract_Invoicee_TerminationState_Terminated = new Translation("The customer has been terminated due to multiple unpaid invoices in debt collection.", "The customer has been terminated due to multiple unpaid invoices in debt collection.", "Kunden har blitt terminert etter flere ubetalte fakturaer til inkasso.", "Kunden har terminerats efter flera obetalda fakturor på inkasso.");

export const CustomerContract_Invoicee_TerminationState_Terminating = new Translation("The customer has multiple invoices in debt collection and will be terminated.", "The customer has multiple invoices in debt collection and will be terminated.", "Kunden har flere fakturaer til inkasso, og oppsigelse vil bli gjennomført.", "Kunden har flera fakturor på inkasso och terminering kommer utföras.");

export const CustomerContract_Invoicee_TerminationState_Warning = new Translation("The customer has multiple invoices in debt collection and is at risk of termination.", "The customer has multiple invoices in debt collection and is at risk of termination.", "Kunden har flere fakturaer til inkasso og risikerer terminering.", "Kunden har flera fakturor på inkasso och riskerar terminering.");

export const CustomerContract_Invoicee_TermsOfPayment = new Translation("Terms of payment", "", "Betalingsvilkår", "Betalningsvillkor");

export const CustomerContract_Invoicee_ValidateDirectDebitDistribution = new Translation("Client not allow to set direct debit distribute.", "", "Klienten tillater ikke å stille inn varselet.", "Klienten tillåter inte att ställa in varsel.");

export const CustomerContract_Invoicee_ValidateDirectDebitDistributionOnAugogiro = new Translation("Not possible to set direct debit distribute true when Autogiro is turn off.", "", "Ikke tillat å sette varsel til sann når Autogiro er slått av.", "Ej möjligt att ställa in autogirodistribution när Autogiro är avstängt.");

export const CustomerContract_Invoicee_Vat = new Translation("Vat", "", "Mva-melding", "Momsredovisning");

export const CustomerContract_Invoicee_WaitingToLoad = new Translation("Waiting to load details", "", "Venter på å laste inn detaljer", "Väntar på att ladda detaljer");

export const CustomerContract_Invoicee_Yes = new Translation("Yes", "", "Ja", "Ja");

export const CustomerContract_LinkAccount = new Translation("Link account", "", "Koble til konto", "Länka konto");

export const CustomerContract_Logout = new Translation("Logout", "", "Logg ut", "Logga ut");

export const CustomerContract_Name = new Translation("Name", "", "Navn", "Namn");

export const CustomerContract_NewVersionAvailable = new Translation("A new version of FenixWeb is available", "", "En ny versjon av FenixWeb er tilgjengelig", "En ny version av FenixWeb är tillgänglig");

export const CustomerContract_OrgNr = new Translation("Organization number", "", "Organisasjonsnummer", "Organisationsnummer");

export const CustomerContract_OrgPersNr = new Translation("Org-/Personal Number", "", "Org-/Personnummer", "Org-/Personnummer");

export const CustomerContract_PhoneNr = new Translation("Phone Number", "", "Telefonnummer", "Telefonnummer");

export const CustomerContract_Refresh = new Translation("Refresh", "", "Oppdater", "Uppdatera");

export const CustomerContract_RegisterInvoicee_Value = new Translation("Register customer", "", "Registrer ny kunde", "Registrera ny kund");

export const CustomerContract_RegisterInvoicee_Address = new Translation("Address", "", "Adresse", "Adress");

export const CustomerContract_RegisterInvoicee_ChooseCountry = new Translation("Choose country", "", "Velg land", "Välj land");

export const CustomerContract_RegisterInvoicee_City = new Translation("City", "", "Postkontor", "Postort");

export const CustomerContract_RegisterInvoicee_CO = new Translation("C/O", "", "C/O", "C/O");

export const CustomerContract_RegisterInvoicee_Common_Digipost = new Translation("Digipost", "", "Digipost", "Digipost");

export const CustomerContract_RegisterInvoicee_Common_HalfYear = new Translation("Every 6th month", "", "Hver sjette måned", "Var 6:e månad");

export const CustomerContract_RegisterInvoicee_Common_Mail = new Translation("Mail", "", "Post", "Brev");

export const CustomerContract_RegisterInvoicee_Common_Month = new Translation("Every month", "", "Hver måned", "Varje månad");

export const CustomerContract_RegisterInvoicee_Common_Peppol = new Translation("Peppol", "", "Peppol", "Peppol");

export const CustomerContract_RegisterInvoicee_Common_Quarter = new Translation("Every 3rd month", "", "Hver tredje måned", "Var 3:e månad");

export const CustomerContract_RegisterInvoicee_Common_Year = new Translation("Once a year", "", "En gang i året", "En gång per år");

export const CustomerContract_RegisterInvoicee_ContactNumber = new Translation("Contact number", "", "Kontaktnummer", "Kontaktnummer");

export const CustomerContract_RegisterInvoicee_ContactPerson = new Translation("Contact person", "", "Kontaktperson", "Kontaktperson");

export const CustomerContract_RegisterInvoicee_CreateInvoicee = new Translation("Create customer", "", "Opprett kunde", "Skapa kund");

export const CustomerContract_RegisterInvoicee_CreateInvoiceeError = new Translation("Cannot create a new customer. Essential data  missing.", "", "Kan ikke opprette ny kunde. Essensielle data mangler.", "Kan ej skapa ny kund. Essentiell data saknas.");

export const CustomerContract_RegisterInvoicee_CreatingInvoicee = new Translation("Creating customer", "", "Skaper ny kunde", "Skapar ny kund");

export const CustomerContract_RegisterInvoicee_CreditCheck = new Translation("Credit check", "", "Kredittsjekk", "Kreditupplysning");

export const CustomerContract_RegisterInvoicee_CreditCheckError = new Translation("Could not perform a credit check. Please contact support-sbs@svea.com.", "", "Kunne ikke utføre en kredittsjekk. Ta kontakt med support-sbs@svea.com.", "Kunde inte gära en kreditupplysning. Kontakta support-sbs@svea.com.");

export const CustomerContract_RegisterInvoicee_CustomerGroup = new Translation("Customer Group", "", "Kundegruppe", "Kundgrupp");

export const CustomerContract_RegisterInvoicee_Distribution = new Translation("Distribution type", "", "Distribusjonsmetode", "Distributionssätt");

export const CustomerContract_RegisterInvoicee_Email = new Translation("Email", "", "E-Post", "E-post");

export const CustomerContract_RegisterInvoicee_ErrorExistingOrgNr = new Translation("A customer with this Org.nr/SSN already exists", "", "En kunde med dette organisasjons-/personnummeret eksisterer allerede", "En kund med detta Org-/Personnummer existerar redan");

export const CustomerContract_RegisterInvoicee_ErrorExistingOrgNr2 = new Translation("Do you want to create it anyway?", "", "Vil du opprette den likevel?", "Vill du skapa den ändå?");

export const CustomerContract_RegisterInvoicee_General = new Translation("General", "", "Generelt", "Allmänt");

export const CustomerContract_RegisterInvoicee_GoToForm = new Translation("Back to the form", "", "Tilbake til skjemaet", "Tillbaka till formuläret");

export const CustomerContract_RegisterInvoicee_GoToInvoicee = new Translation("Go to customer", "", "Gå til kunde", "Gå till kund");

export const CustomerContract_RegisterInvoicee_InvoiceeCreated = new Translation("New customer created", "", "Ny kunde opprettet", "Ny kund skapad");

export const CustomerContract_RegisterInvoicee_InvoiceeDetails = new Translation("Customer details", "", "Kundedata", "Kunduppgifter");

export const CustomerContract_RegisterInvoicee_InvoiceeFailed = new Translation("Could not create customer", "", "Kunne ikke opprette ny kunde", "Kunde ej skapa ny kund");

export const CustomerContract_RegisterInvoicee_InvoiceeType = new Translation("Customer type", "", "Kundetype", "Kundtyp");

export const CustomerContract_RegisterInvoicee_InvoiceInterval = new Translation("Invoice interval", "", "Faktureringsintervall", "Faktureringsintervall");

export const CustomerContract_RegisterInvoicee_InvoiceReference = new Translation("Invoice reference", "", "Fakturareferanse", "Fakturareferens");

export const CustomerContract_RegisterInvoicee_InvoiceStatus = new Translation("Invoiced", "", "Fakturert", "Faktureras");

export const CustomerContract_RegisterInvoicee_LoadingCreditCheck = new Translation("Loading credit check...", "", "Laster inn kredittsjekk...", "Laddar kreditupplysning...");

export const CustomerContract_RegisterInvoicee_Name = new Translation("Name", "", "Navn", "Namn");

export const CustomerContract_RegisterInvoicee_OrgNr = new Translation("Org.nr/SSN", "", "Org-/Personnummer", "Org.nr/Personnummer");

export const CustomerContract_RegisterInvoicee_OrgNrInvalid = new Translation("Incorrect social security number or organization number", "", "Feil personnummer eller organisasjonsnummer", "Felaktigt personnummer eller organisationsnummer");

export const CustomerContract_RegisterInvoicee_PeppolAddress = new Translation("Peppol ID", "", "EHF-adresse", "Peppol ID");

export const CustomerContract_RegisterInvoicee_Skip = new Translation("Skip", "", "Hopp over", "Hoppa över");

export const CustomerContract_RegisterInvoicee_StreetAddress = new Translation("Street address", "", "Gateadresse", "Gatuadress");

export const CustomerContract_RegisterInvoicee_ValidationError = new Translation("One or more fields are invalid.", "", "Ett eller flere felt er ugyldige.", "Ett eller flera fält har felaktig data.");

export const CustomerContract_RegisterInvoicee_Vat = new Translation("Vat", "", "Mva-rapportering", "Momsredovisning");

export const CustomerContract_RegisterInvoicee_WaitingInvoicee = new Translation("Waiting to create customer", "", "Venter på å opprette kunde", "Väntar på att skapa kund");

export const CustomerContract_RegisterInvoicee_ZipCode = new Translation("Zip code", "", "Postkode", "Postnr");

export const CustomerContract_Search_Value = new Translation("Search customer", "", "Søk", "Sök kund");

export const CustomerContract_Search_Active = new Translation("Active", "", "Aktive", "Aktiva");

export const CustomerContract_Search_ActiveFilters = new Translation("active filters", "", "aktive filtre", "aktiva filter");

export const CustomerContract_Search_AdjustFilters = new Translation("Try adjusting the search filters", "", "Prøv å justere søkefiltrene", "Prova att justera sökfiltren");

export const CustomerContract_Search_Cancelled = new Translation("Cancelled", "", "Avsluttede", "Avslutade");

export const CustomerContract_Search_NoContracts = new Translation("Without subscription", "", "Uten abonnement", "Utan abonnemang");

export const CustomerContract_Search_Pending = new Translation("During startup", "", "Under oppstart", "Under uppstart");

export const CustomerContract_Search_PendingCancellation = new Translation("During closing", "", "Under avslutning", "Under avslut");

export const CustomerContract_Search_ThereAre = new Translation("There are", "", "Det er", "Det finns");

export const CustomerContract_SearchNoResult = new Translation("Your search returned no results", "", "Søket ditt ga ingen resultater", "Din sökning gav inga resultat");

export const CustomerContract_SearchResult_ContractNr = new Translation("Contract number", "", "Kontraktsnummer", "Kontraktsnummer");

export const CustomerContract_SearchResult_Email = new Translation("E-mail", "", "E-post", "E-post");

export const CustomerContract_SearchResult_MalformedSearchQuery = new Translation("Illegal characters in the search", "", "Ulovlige karakterer i søket", "Otillåtna tecken i sökningen");

export const CustomerContract_SearchResult_Name = new Translation("Name", "", "Navn", "Namn");

export const CustomerContract_SearchResult_OrgNr = new Translation("Organization number/SSN", "", "Org-/Personnummer", "Org-/Personnummer");

export const CustomerContract_SearchResult_PhoneNr = new Translation("Phone number", "", "Telefonnummer", "Telefonnummer");

export const CustomerContract_Welcome = new Translation("Welcome", "", "Velkommen", "Välkommen");

export const CustomersContracts = new Translation("Customers \u0026 Subscriptions", "", "Kunder \u0026 abonnement", "Kunder \u0026 abonnemang");

export const Dataset = new Translation("Dataset", "", "Datasett", "Dataset");

export const Date$ = new Translation("Date", "", "Dato", "Datum");

export const days = new Translation("days ", "", "dager", "dagar");

export const Description = new Translation("Description", "", "Beskrivelse", "Beskrivning");

export const Discounts = new Translation("Discounts", "", "Rabatter", "Rabatter");

export const DomainTypes_ClaimStatus_ClaimStopped = new Translation("Claim stopped", "", "Krav stoppet", "Kravstoppad");

export const DomainTypes_ClaimStatus_Collection = new Translation("Collection", "", "Inkasso", "Inkasso");

export const DomainTypes_ClaimStatus_CollectionCancelled = new Translation("Collection cancelled", "", "Inkasso avbrutt", "Inkasso avbrutet");

export const DomainTypes_ClaimStatus_CollectionProposal = new Translation("Collection proposal", "", "Inkassoforslag", "Inkassoförslag");

export const DomainTypes_ClaimStatus_Overdue = new Translation("Overdue", "", "Forfalt", "Försenad");

export const DomainTypes_ClaimStatus_Reminder1 = new Translation("Reminder", "", "Påminnelse", "Påminnelse");

export const DomainTypes_ClaimStatus_ReminderSoft = new Translation("Soft reminder", "", "Mild påminnelse", "Mjuk påminnelse");

export const DomainTypes_Distribution_Digipost = new Translation("Digipost", "", "Digipost", "Digipost");

export const DomainTypes_Distribution_EHFInvoice = new Translation("EHF-Invoice", "", "EHF-faktura", "EHF-Faktura");

export const DomainTypes_Distribution_EInvoice = new Translation("E-Invoice", "", "E-faktura", "E-faktura");

export const DomainTypes_Distribution_Email = new Translation("Email", "", "E-Post", "E-post");

export const DomainTypes_Distribution_Mail = new Translation("Post", "", "Post", "Brev");

export const DomainTypes_Distribution_Peppol = new Translation("Peppol", "", "Peppol", "Peppol");

export const DomainTypes_Distribution_Unknown = new Translation("Unknown", "", "Ukjent", "Okänd");

export const DomainTypes_InvoiceeState_NoSubscriptions = new Translation("No subscriptions", "", "Ingen abonnementer", "Inga abonnemang");

export const DomainTypes_InvoiceeType_Company = new Translation("Company", "", "Virksomhet", "Företag");

export const DomainTypes_InvoiceeType_OrgNr = new Translation("Org.Nr", "", "Org.Nr", "Org.Nr");

export const DomainTypes_InvoiceeType_Private = new Translation("Private", "", "Privatperson", "Privatperson");

export const DomainTypes_InvoiceeType_SSN = new Translation("SSN", "", "Pers.nr", "Pers.nr");

export const DomainTypes_PaymentMethod_Card = new Translation("Card", "", "Kort", "Kort");

export const DomainTypes_PaymentMethod_Payflow = new Translation("Digital payment", "", "Digital betaling", "Digital betalning");

export const DomainTypes_PaymentStatus_Credited = new Translation("Credited", "", "Kreditert", "Krediterad");

export const DomainTypes_PaymentStatus_Loss = new Translation("Loss", "", "Tap", "Förlust");

export const DomainTypes_PaymentStatus_Paid = new Translation("Paid", "", "Betalt", "Betald");

export const DomainTypes_PaymentStatus_PaidWithACredited = new Translation("Paid and credited", "", "Betald og krediterad", "Betald och krediterad");

export const DomainTypes_PaymentStatus_PaidWithALoss = new Translation("Paid with a Loss", "", "Betalt med tap", "Betald med förlust");

export const DomainTypes_PaymentStatus_PaidWithATerminated = new Translation("Void", "", "Makulert", "Makulerad");

export const DomainTypes_PaymentStatus_PartiallyPaid = new Translation("Partially Paid", "", "Delvis betalt", "Delbetald");

export const DomainTypes_PaymentStatus_PartiallyPaidWithACredited = new Translation("Partially Paid with a Credited", "", "Delvis betalt med kredittering", "Delbetald med kreditering");

export const DomainTypes_PaymentStatus_PartiallyPaidWithALoss = new Translation("Partially Paid with a Loss", "", "Delvis betalt med tap", "Delbetald med förlust");

export const DomainTypes_PaymentStatus_PartiallyPaidWithATerminated = new Translation("Partially paid with termination", "", "Delbetald med avskrivning", "Delbetald med avskrivning");

export const DomainTypes_PaymentStatus_Terminated = new Translation("Void", "", "Makulert", "Makulerad");

export const DomainTypes_PaymentStatus_Unpaid = new Translation("Unpaid", "", "Ubetalt", "Obetald");

export const DomainTypes_Period_HalfYearFee = new Translation("Half-year fee", "", "Halvårlig avgift", "Halvårsavgift");

export const DomainTypes_Period_MonthlyDateFee = new Translation("Monthly fee date", "", "Månedlig avgift dato", "Månadsavgift datum");

export const DomainTypes_Period_MonthlyFee = new Translation("Monthly fee", "", "Månedlig avgift", "Månadsavgift");

export const DomainTypes_Period_MonthlyWith12MonthsInvoice = new Translation("Monthly fee - 12 month invoice", "", "Månedlig avgift - 12 måneders faktura", "Månadsavgift – 12 mån fakturering");

export const DomainTypes_Period_MonthlyWith3MonthsInvoice = new Translation("Monthly fee - 3 month invoice", "", "Månedlig avgift - 3 måneders faktura", "Månadsavgift – 3 mån fakturering");

export const DomainTypes_Period_MonthlyWith6MonthsInvoice = new Translation("Monthly fee - 6 month invoice", "", "Månedlig avgift - 6 måneders faktura", "Månadsavgift – 6 mån fakturering");

export const DomainTypes_Period_OneTimeFee = new Translation("One-time fee", "", "Engangsavgift", "Engångsavgift");

export const DomainTypes_Period_PerInvoice = new Translation("Per invoice", "", "Per faktura", "Per faktura");

export const DomainTypes_Period_QuarterlyFee = new Translation("Quarterly fee", "", "Kvartalsavgift", "Kvartalsavgift");

export const DomainTypes_Period_Unknown = new Translation("Unknown", "", "Ukjent", "Okänd");

export const DomainTypes_Period_YearlyFee = new Translation("Yearly fee", "", "Årsavgift", "Årsavgift");

export const DomainTypes_TransactionTypeDesc_Bankgiro = new Translation("Account", "", "Konto", "Bankgiro");

export const DomainTypes_TransactionTypeDesc_BankgiroOcr = new Translation("Account OCR", "", "Konto OCR", "Bankgiro OCR");

export const DomainTypes_TransactionTypeDesc_BetaldTillUg = new Translation("Paid to UG", "", "Betalt til UG", "Betald till UG");

export const DomainTypes_TransactionTypeDesc_Bortskrivning = new Translation("Write-off", "", "Avskrivning", "Avskrivning");

export const DomainTypes_TransactionTypeDesc_DebitOrCredit = new Translation("Debit or credit", "", "Debet eller kredit", "Debet eller kredit");

export const DomainTypes_TransactionTypeDesc_InkassoKapital = new Translation("Collection capital", "", "Inkasso kapital", "Inkasso kapital");

export const DomainTypes_TransactionTypeDesc_KassaOrCheck = new Translation("Cash or check", "", "Kontanter eller sjekk", "Kontant eller check");

export const DomainTypes_TransactionTypeDesc_Kundforlust = new Translation("Customer loss", "", "Kundetap", "Kundförlust");

export const DomainTypes_TransactionTypeDesc_Postgiro = new Translation("Postal account", "", "Postkonto", "Postgiro");

export const DomainTypes_TransactionTypeDesc_PostgiroOcr = new Translation("Postal account OCR", "", "Postkonto OCR", "Postgiro OCR");

export const DomainTypes_VatMode_VatExcl = new Translation("Excl.", "", "Ekskl.", "Exkl.");

export const DomainTypes_VatMode_VatIncl = new Translation("Incl.", "", "Inkl.", "Inkl.");

export const DropFilesHere = new Translation("Drag and drop files here", "", "Slipp filer her", "Dra och släpp filer här");

export const Email_Value = new Translation("E-mail ", "", "E-post", "E-post");

export const Email_AuxInputInfo = new Translation("Your email address will be your password", "", "Din e-postadresse vil være ditt brukernavn", "Din epost-adress blir ditt användarnamn");

export const Email_PlaceHolder = new Translation("email@example.com", "", "email@example.com", "email@example.com");

export const EnterYourPassword = new Translation("Password", "", "Passord", "Ange lösenord");

export const EnterYourUsername = new Translation("Username ", "", "Brukernavn", "Ange ditt användarnamn");

export const ExclVAT = new Translation("Excl VAT ", "", "Ekskl. MVA", "Exkl. moms");

export const ExtendOrConvert = new Translation("Extend/convert", "", "Forlengelse / byte", "Förlängning/konvertering");

export const Fee = new Translation("Fee", "", "Avgift", "Avgift");

export const Fees = new Translation("Fees", "", "Kostnader", "Avgifter");

export const FeeTypeMonth = new Translation("Month", "", "Måned", "Månad");

export const FeeTypeOnce = new Translation("One time", "", "Engang", "Engång");

export const FileName = new Translation("File Name", "", "Filnavn", "Filnamn");

export const FileUploadedBy = new Translation("Uploaded by", "", "Lastet opp av", "Uppladdad av");

export const FileUploadedTime = new Translation("Uploaded", "", "Lastet opp", "Uppladdad");

export const Filter = new Translation("Filter", "", "Filter", "Filtrera");

export const FindContract = new Translation("Find contract", "", "Søk kontrakt", "Sök kontrakt");

export const ForgetPassword_forgotPass = new Translation("Forgot password", "", "Glemt passord", "Glömt lösenord");

export const ForgetPassword_forgotPassText = new Translation("If you forgot your password, enter your username and email below. If you are unsure of your username, contact support-sbs@svea.com", "", "Om du har glemt ditt passord, angi ditt brukernavn og din e-post nedenfor. Er du usikker på ditt brukernavn, kontakt support-sbs@se. ", "Om du glömt ditt lösenord, ange ditt användarnamn och din e-post nedan. Är du osäker på ditt användarnamn, kontakta support-sbs@svea.com");

export const ForgetPassword_Pass = new Translation("Password", "", "Passord", "Lösemord");

export const ForgetPassword_Save = new Translation("Save", "", "Lagre", "Spara");

export const ForgetPassword_User = new Translation("Username", "", "Brukernavn", "Användare");

export const From = new Translation("From", "", "Fra", "Från");

export const HasNeverBeenActive = new Translation("Never been active", "", "Det har aldri vært aktiv", "Har aldrig varit aktivt");

export const Home_Admin = new Translation("Admin", "", "Admin", "Admin");

export const Home_Admittanceadmin = new Translation("Admittance admin", "", "Addmittance admin", "Admittance admin");

export const Home_AdmittanceUser = new Translation("Users \u0026 Security", "", "Brukere \u0026 tilganger", "Användare \u0026 behörigheter");

export const Home_Age = new Translation("Age", "", "Aldersfordeling", "Åldersfördelning");

export const Home_Api = new Translation("Api", "", "Api", "Api");

export const Home_ClientDetails = new Translation("Client details", "", "UG-detaljer", "UG Detaljer");

export const Home_ClientNr = new Translation("Client number", "", "Kundenummer", "Kundnummer");

export const Home_ClientSettings = new Translation("Client Settings", "", "Innstillinger UG", "Inställningar UG");

export const Home_Contracts = new Translation("Subscription", "", "Abonnement", "Abonnemang");

export const Home_ContractTypes = new Translation("Subscription Types", "", "Abonnementsformer", "Abonnemangsformer");

export const Home_CopyPriceList = new Translation("Copy pricelist", "", "Kopiere prisliste", "Kopiera prislista");

export const Home_CostControl = new Translation("Cost control", "", "Kostnadskontroll", "Kostnadskontroll");

export const Home_CreateInvoices = new Translation("Create invoices", "", "Skape fakturaer", "Fakturering");

export const Home_FindContract = new Translation("Mortgage \u0026 physical contract", "", "Belåning \u0026 fysiske kontrakt", "Belåning \u0026 fysiska kontrakt");

export const Home_FindCreditCheck = new Translation("Find credit check", "", "Søk kreditopplysning", "Sök kreditupplysning");

export const Home_Handle = new Translation("Handle", "", "Administrere", "Hantera");

export const Home_HighUsage = new Translation("High usage", "", "Høyt forbruk", "Hög förbrukning");

export const Home_HighusageDataEurope = new Translation("High data usage in  Europe", "", "Høyt dataforbruk i Europa", "Hög dataförbrukning i Europa");

export const Home_HighusageDataNorway = new Translation("High data usage in Norway", "", "Høyt dataforbruk i Norge", "Hög dataförbrukning i Norge");

export const Home_Import = new Translation("File Import", "", "Filimport", "Filimport");

export const Home_Internal = new Translation("Internal", "", "Intern", "Intern");

export const Home_InvoiceFileFormat = new Translation("Invoice file format", "", "Filformat ved fakturering", "Filformat fakturering");

export const Home_ManageNrSeries = new Translation("Number", "", "Nummer", "Nummer");

export const Home_MargReport = new Translation("Margin report", "", "Marginalrapport", "Marginalrapport");

export const Home_MortgageEval = new Translation("Contract evaluation", "", "Kontraktsverdi", "Kontraktsvärdering");

export const Home_MortgageSettings = new Translation("Mortgage Settings", "", "Belåninginnstillinger", "Belåningsinställningar");

export const Home_NetAdminTelia = new Translation("Networkadmin - Telia", "", "Networkadmin - Telia", "Nätverksadmin - Telia");

export const Home_NetAdminTre = new Translation("Networkadmin - Tre", "", "Networkadmin - Tre", "Nätverksadmin - Tre");

export const Home_NetworkOrderErrors = new Translation("Provisioning error", "", "Provisjoneringsfeil", "Provisioneringsfel");

export const Home_NextInvoiceDate = new Translation("Next invoice", "", "Neste fakturering", "Nästa fakturering");

export const Home_NotInvoiced = new Translation("Not invoiced", "", "Ikke fakturert", "Inte fakturerat");

export const Home_NrImport = new Translation("Import numbers", "", "Importere nummer", "Importera nummer");

export const Home_NrSerieImport = new Translation("Import number series", "", "Importere nummerserier", "Importera Nummerserier");

export const Home_NumberInventory = new Translation("Number inventory", "", "Nummerpeiling", "Nummerlager");

export const Home_Onboarding = new Translation("Onboarding", "", "Onboarding", "Onboarding");

export const Home_Other = new Translation("Other", "", "Øvrig", "Övrigt");

export const Home_OutPort = new Translation("Outportations", "", "Utporteringer", "Utporteringar");

export const Home_PriceChanges = new Translation("Feechanges", "", "Avgiftsendringer", "Avgiftsändringar");

export const Home_Pricelists = new Translation("Pricelists", "", "Prislister", "Prislistor");

export const Home_Register = new Translation("Register", "", "Register", "Registrera");

export const Home_Registered = new Translation("Registered contracts", "", "Registrert kontrakt", "Registrerade kontrakt");

export const Home_Reports = new Translation("Reports", "", "Rapporter", "Rapporter");

export const Home_Services = new Translation("Services", "", "Tjenester", "Tjänster");

export const Home_Status = new Translation("Status", "", "Status", "Status");

export const Home_StatusAndWarnings = new Translation("Status and warnings", "", "Status og advarsler", "Status och varningar");

export const Home_SubproductDefinitions = new Translation("Subproduct", "", "Delprodukt", "Subprodukt");

export const Home_Support = new Translation("Support", "", "Support", "Support");

export const Home_Suspens = new Translation("Suspens", "", "Suspens", "Suspens");

export const Home_SwitchDiscount = new Translation("Switch discounts", "", "Bytterabatter", "Växelrabatter");

export const Home_Tab = new Translation("TAB", "", "TAB", "TAB");

export const Home_TempTable = new Translation("Temp table", "", "Temp table", "Temp table");

export const Home_TraficReport = new Translation("Traffic", "", "Trafikk", "Trafik");

export const Home_TransferContract = new Translation("Transfer contract", "", "Overfør kontrakt", "Flytta abonnemang");

export const Home_Welcome = new Translation("Welcome", "", "Velkommen", "Välkommen");

export const Icc = new Translation("icc", "", "ICC", "ICC");

export const IMEI = new Translation("imei", "", "IMEI", "IMEI");

export const Import_ImportProgram_Approve_Value = new Translation("Approve", "", "Vedta", "Godkänn");

export const Import_ImportProgram_Approve_BodyText = new Translation("Are you sure you want to approve the file import?", "", "Er du sikker på at du vil godkjenne filimporten?", "Är du säker på att du vill godkänna filimporten?");

export const Import_ImportProgram_Approve_Header = new Translation("Approve file import", "", "Godkjenn filimport", "Godkänn filimporten");

export const Import_ImportProgram_ApprovedAtUtc = new Translation("Approved", "", "Godkjent", "Godkänd");

export const Import_ImportProgram_ApprovedByUserId = new Translation("Approved by", "", "Godkjent av", "Godkänd av");

export const Import_ImportProgram_CompletedAtUtc = new Translation("Completed", "", "Fullført", "Avslutad");

export const Import_ImportProgram_CreatedAtUtc = new Translation("Created", "", "Opprettet", "Skapad");

export const Import_ImportProgram_DataNotAvailable = new Translation("Data not available", "", "Data ikke tilgjengelig", "Data inte tillgängligt");

export const Import_ImportProgram_Details_Approve = new Translation("Approve", "", "Godkjenn", "Godkänn");

export const Import_ImportProgram_Details_Errors = new Translation("Errors", "", "Feil", "Fel");

export const Import_ImportProgram_Details_FeeTotals = new Translation("Fee Totals", "", "Gebyrsummer", "Avgiftssummor");

export const Import_ImportProgram_Details_FileImportSummary = new Translation("File Import Summary", "", "Sammendrag av filimport", "Sammanfattning av filimport");

export const Import_ImportProgram_Details_FileName = new Translation("File Name", "", "Filnavn", "Filnamn");

export const Import_ImportProgram_Details_ImportDate = new Translation("Import Date", "", "Importdato", "Importdatum");

export const Import_ImportProgram_Details_ImportSummary = new Translation("Import Summary", "", "Importoppsummering", "Importöversikt");

export const Import_ImportProgram_Details_Messages = new Translation("Messages", "", "Meldinger", "Meddelanden");

export const Import_ImportProgram_Details_MoreActions = new Translation("More actions", "", "Flere handlinger", "Fler åtgärder");

export const Import_ImportProgram_Details_RecordCounts = new Translation("Record Counts", "", "Antall poster", "Antal poster");

export const Import_ImportProgram_Details_Reject = new Translation("Reject", "", "Makulere", "Makulera");

export const Import_ImportProgram_Details_Update = new Translation("Update", "", "Oppdater", "Uppdatera");

export const Import_ImportProgram_Details_Warnings = new Translation("Warnings", "", "Advarsler", "Varningar");

export const Import_ImportProgram_DownloadErrors = new Translation("Download import errors", "", "Last ned importfeil", "Hämta importfel");

export const Import_ImportProgram_Error = new Translation("Error", "", "Feil", "Fel");

export const Import_ImportProgram_ErrorAtUtc = new Translation("Error At", "", "Feil ved", "Fel vid");

export const Import_ImportProgram_FileImport = new Translation("File import", "", "Filimport", "Filimport");

export const Import_ImportProgram_FileName = new Translation("File name", "", "Filnavn", "Filnamn");

export const Import_ImportProgram_ImportErrors = new Translation("Import errors", "", "Importfeil", "Import fel");

export const Import_ImportProgram_Message = new Translation("Message", "", "Beskjed", "Meddelande");

export const Import_ImportProgram_NoStatisticsData = new Translation("No statistics data", "", "Ingen statistiske data", "Ingen statistikdata");

export const Import_ImportProgram_ParsedAtUtc = new Translation("Parsed", "", "Analysert", "Analyserad");

export const Import_ImportProgram_Reject_Value = new Translation("Reject", "", "Avbryt", "Makulera");

export const Import_ImportProgram_Reject_BodyText = new Translation("Are you sure you want to reject the file import?", "", "Er du sikker på at du vil makulera filimporten?", "Är du säker på att du vill makulera filimporten?");

export const Import_ImportProgram_Reject_Header = new Translation("Reject file import", "", "Makulere filimporten", "Makulera filimporten");

export const Import_ImportProgram_RejectedAtUtc = new Translation("Rejected at", "", "Fjernet", "Borttagen");

export const Import_ImportProgram_RejectedByUserId = new Translation("Rejected by", "", "Fjernet av", "Borttagen av");

export const Import_ImportProgram_SeeDetails = new Translation("See details", "", "Se detaljer", "Se detaljer");

export const Import_ImportProgram_Statistics = new Translation("Statistics", "", "Statistiske", "Statistik");

export const Import_ImportProgram_Status_Value = new Translation("State", "", "Status", "Status");

export const Import_ImportProgram_Status_Completed = new Translation("File import is completed", "", "Filimporten er fullført", "Filimporten är klar");

export const Import_ImportProgram_Status_Error = new Translation("File import have an error", "", "Filimporten har en feil", "Filimporten har ett fel");

export const Import_ImportProgram_Status_Importing = new Translation("File is importing", "", "Fil importeres", "Fil importeras");

export const Import_ImportProgram_Status_Other = new Translation("File import having unknown status", "", "Filkimporten med ukjent status", "Filimport med okänd status");

export const Import_ImportProgram_Status_Parsing = new Translation("File import is parsing", "", "Filimport analyseres", "Filimport analyseras");

export const Import_ImportProgram_Status_PendingRejection = new Translation("Filimport is pending rejection", "", "Filimporten venter på makulering", "Filimport väntar på makulering");

export const Import_ImportProgram_Status_Rejected = new Translation("Filimport is rejected", "", "Filimport makulert", "Filimport makulerad");

export const Import_ImportProgram_Update_Value = new Translation("Update", "", "Oppdater", "Uppdatera");

export const Import_ImportProgram_Update_BodyText = new Translation("Are you sure you want to update the file import?", "", "Er du sikker på at du vil oppdatere filimporten?", "Är du säker på att du vill uppdatera filimporten?");

export const Import_ImportProgram_Update_Header = new Translation("Update file import", "", "Oppdater filimporten", "Uppdatera filimporten");

export const Import_ImportProgram_Warning = new Translation("Warnings", "", "Advarsel", "Varningar");

export const Imsi = new Translation("imsi", "", "IMSI", "IMSI");

export const Inactive = new Translation("passive", "", "Inaktiv", "Inaktiv");

export const InclVAT = new Translation("incl. VAT", "", "Inkl. Mva", "Inkl. moms");

export const InPort = new Translation("Portations", "", "Porteringer", "Porteringar");

export const InvalidEmail = new Translation("Invalid e-mail address", "", "Ugyldig e-postadresse", "Ogiltig epost-adress");

export const InvalidOrganizationNumber = new Translation("Invalid VAT or ID number", "", "Ugyldig organisasjonsnummer eller Fødselsnr", "Ogiltigt org- eller personnummer");

export const InvalidPhoneNumber = new Translation("Invalid telephone number", "", "Ugyldig telefonnummer", "Ogiltigt telefonnummer");

export const Invoice = new Translation("Invoice", "", "Faktura", "Faktura");

export const InvoiceAddress = new Translation("Address", "", "Fakturaadresse", "Fakturaadress");

export const InvoiceAdmin = new Translation("Invoice Admin", "", "Faktura Admin", "Faktura Admin");

export const InvoiceDate = new Translation("Date", "", "Fakturadato", "Fakturadatum");

export const InvoiceDistribution_Value = new Translation("Distribution", "", "Fakturametode", "Fakturametod");

export const InvoiceDistribution_Email = new Translation("Email", "", "Epost", "Epost");

export const InvoiceDistribution_Paper = new Translation("Paper", "", "Papirfaktura", "Papper");

export const Invoicee_Reference = new Translation("Your reference", "", "Deres referanse", "Er referens");

export const InvoiceeDetails = new Translation("Customer details", "", "Kundedata", "Kunduppgifter");

export const InvoiceNumber_Long = new Translation("Invoice number", "", "Fakturanummer", "Fakturanummer");

export const InvoiceNumber_Short = new Translation("Invoice nr", "", "Fakturanr", "Fakturanr");

export const Invoices = new Translation("Invoices", "", "Dine faktura", "Fakturor");

export const Invoicing = new Translation("Invoicing", "", "Fakturering", "Fakturering");

export const LatestInvoice_PlaceHolder = new Translation("You find it in the upper right corner of the  invoice (eg 10233)", "", "Du finner det øverst til høyre på fakturaen din (f.eks 10233) ", "Du hittar det högst uppe till höger på fakturan (t.ex. 10233)");

export const LinkAccount_Body = new Translation("\u003cp\u003e\u003cstrong\u003eYour security is our priority!\u003c/strong\u003e To make your experience with us as safe as possible, you need to link your account to BankID. It is a simple way to give your account an extra layer of protection.\u003c/p\u003e\u003cp\u003eIt only takes a minute – click the button below to get started!\u003c/p\u003e", "\u003cp\u003e\u003cstrong\u003eTurvallisuutesi on meille tärkeää!\u003c/strong\u003e Jotta käyttökokemuksesi olisi mahdollisimman turvallinen, sinun on yhdistettävä tilisi BankID-tunnukseen. Se on helppo tapa antaa tilillesi ylimääräinen suojakerros.\u003c/p\u003e\u003cp\u003eTämä vie vain minuutin – aloita klikkaamalla alla olevaa painiketta!\u003c/p\u003e", "\u003cp\u003e\u003cstrong\u003eVi er opptatt av din sikkerhet!\u003c/strong\u003e For å gjøre opplevelsen din hos oss så trygg som mulig, må du koble kontoen din til BankID. Det er en enkel måte å gi kontoen din et ekstra lag med beskyttelse.\u003c/p\u003e\u003cp\u003eDet tar bare et minutt – klikk på knappen nedenfor for å komme i gang!\u003c/p\u003e", "\u003cp\u003e\u003cstrong\u003eVi är måna om din trygghet!\u003c/strong\u003e För att göra din upplevelse hos oss så säker som möjligt behöver du koppla ditt konto till BankID. Det är ett enkelt sätt att ge ditt konto ett extra lager av skydd.\u003c/p\u003e \u003cp\u003eDet tar bara någon minut – klicka på knappen här under för att komma igång!\u003c/p\u003e");

export const LinkAccount_Header = new Translation("Connect account to BankID", "Yhdistä tili BankID-tunnukseen", "Koble konto til BankID", "Koppla konto till BankID");

export const LockInPeriod = new Translation("Fixed period", "", "Bindingstid", "Bindingstid");

export const Login_Value = new Translation("Login", "", "Logg inn", "Logga in");

export const Login_ForgotPass = new Translation("Forgot Your Password?", "", "Glemt passord? ", "Glömt ditt  lösenord?");

export const Login_LoggaIn = new Translation("Sign in", "", "Logg inn ", "Logga in");

export const Login_SignIn = new Translation("Sign in", "", "Logg inn ", "Logga in");

export const Logout = new Translation("Logout", "", "Logg ut", "Logga ut");

export const M2M_Active = new Translation("Active", "", "Aktive", "Aktiva");

export const M2M_AreYouSure = new Translation("Are you sure that you want to deactivate the number?", "", "Er du sikker på at du vil deaktivere nummeret?", "Är du säker på att du vill deaktivera nummret?");

export const M2M_ContractType = new Translation("Contract type", "", "Abonnementsskjema", "Abonnemangform");

export const M2M_Deactivate = new Translation("Deactivate", "", "Deaktiver", "Deaktivera");

export const M2M_Deactive = new Translation("Deactive", "", "Deaktive", "Deaktiva");

export const M2M_Domain = new Translation("Domain", "", "Domene", "Domän");

export const M2M_EndUser = new Translation("End user", "", "Slutt bruker", "Slutanvändare");

export const M2M_New = new Translation("New", "", "Nye", "Nya");

export const M2M_NumberDeactivated = new Translation("Number deactivated", "", "Nummer deaktivert", "Nummer deaktiverat");

export const M2M_PhoneNumber = new Translation("Phone number", "", "Telefonnummer", "Telefonnummer");

export const M2M_Status = new Translation("Status", "", "Status", "Status");

export const MainFeeTemplateNr = new Translation("Main fee ID", "Päämaksun tunnus", "Hovedgebyr-ID", "Huvudavgifts-ID");

export const Menu = new Translation("Menu", "", "Meny", "Meny");

export const months = new Translation("months", "", "måneder", "månader");

export const Mortgage = new Translation("Mortgage", "", "Belåning", "Belåning");

export const MortgageAgeInRange = new Translation("Age", "", "Alder", "Ålder");

export const MortgageApprovalStatus = new Translation("Mortgage Status", "", "Belåningsstatus", "Belåningstatus");

export const MortgageMonthlyValueInRange = new Translation("Amount", "", "Beløp", "Belopp");

export const MortgageStarted = new Translation("Mortgage started", "", "Belåning startet", "Kund godkänd för belåning");

export const MortgageValidation_ApproveMortgage = new Translation("Approve mortgage for the contracts in the table above", "", "Godkjenne pant for kontraktene i tabellen ovenfor", "Godkänn belåning för kontrakten i tabellen ovan");

export const MortgageValidation_CouldNotFind = new Translation("Could not find any contracts to approve mortgage for", "", "Kunne ikke finne noen kontrakter å godkjenne pant for", "Kunde inte hitta några kontrakt att godkänna belåning för.");

export const MortgageValidation_Heading = new Translation("Approve mortgage", "", "Godkjenne pant", "Godkänna belåning");

export const MortgageValidation_NrOfContracts = new Translation("Number of contracts", "", "Antall kontrakter", "Antal kontrakt");

export const MortgageValidation_Summary = new Translation("Summary", "", "Sammendrag", "Sammanfattning");

export const MortgageValidation_TotalContractValue = new Translation("The total value of the contracts", "", "Den totale verdien av kontraktene", "Kontraktens totala värde");

export const Name = new Translation("Name", "", "Navn", "Namn");

export const NewSubscription = new Translation("New Subscription", "", "Nytt abonnement", "Nytt Abonnemang");

export const No = new Translation("No", "", "Ikke", "Nej");

export const NoInvoicedTrafficFound = new Translation("We were unable to find information during the given period. Please check datum and try again. ", "", "Vi kunne ikke finne trafikk i det gitte datoperioden. Sjekk datoene og prøv igjen.", "Vi kunde inte hitta någon trafik inom det angivna datumintervallet. Kontrollera datumen och försök igen.");

export const NotPaid = new Translation("Unpaid", "", "Ikke betalt", "Ej betald");

export const NotPayed = new Translation("Unpaid", "", "Ubetalt", "Ej betalda");

export const Number$ = new Translation("Number", "", "Nummer", "Nummer");

export const NumberInventory_Activated = new Translation("Activated", "", "Aktivert", "Aktiverat");

export const NumberInventory_Category = new Translation("Category", "", "Kategori", "Kategori");

export const NumberInventory_Contract = new Translation("Contract", "", "Kontrakt", "Kontrakt");

export const NumberInventory_Filters_AdjustFilters = new Translation("Try adjusting the search filters. The active filters are", "", "Prøv å justere søkefiltrene. De aktive filtrene er", "Försök att justera sökfiltren. De aktiva filtren är");

export const NumberInventory_Filters_Category = new Translation("A specific category is active", "", "En spesifikk kategori er aktiv", "En specifik kategori är aktiv");

export const NumberInventory_Filters_NetworkName = new Translation("A specific network is active", "", "Et spesifikt nettverk er aktivt", "Ett specifikt nätverk är aktivt");

export const NumberInventory_Filters_NotIncludeActivated = new Translation("Activated are not included", "", "Aktiverte er ikke inkludert", "Aktiverade ingår inte");

export const NumberInventory_Filters_Search = new Translation("The search field contains a number/contract", "", "Søkefeltet inneholder et tall/en kontrakt", "Sökfältet innehåller ett nummer/kontrakt");

export const NumberInventory_Filters_ShowOnlyAvailable = new Translation("Only shows available numbers", "", "Viser bare tilgjengelige numre", "Visar endast tillgängliga nummer");

export const NumberInventory_GoToOldPage = new Translation("Go to old page", "", "Gå til den gamle siden", "Gå till gamla sidan");

export const NumberInventory_IncludeActivated = new Translation("Include activated", "", "Inkluder aktivert", "Inkludera aktiverade");

export const NumberInventory_Invalid = new Translation("Invalid", "", "Ugyldig", "Ogiltig");

export const NumberInventory_MissingContracts = new Translation("Contracts missing", "", "Kontrakt mangler", "Kontrakt saknas");

export const NumberInventory_Network = new Translation("Network", "", "Nettverk", "Nätverk");

export const NumberInventory_NoResult = new Translation("No results.", "", "Ingen resultater.", "Inga resultat.");

export const NumberInventory_NumberFrom = new Translation("Number from", "", "Nummer fra", "Nummer från");

export const NumberInventory_NumberTo = new Translation("Number to", "", "Nummer fra", "Nummer till");

export const NumberInventory_QuarantineNumber = new Translation("Quarantine number", "", "Sett nummeret i karantene", "Sätt nummer i karantän");

export const NumberInventory_QuarantineUntil = new Translation("Quarantine until", "", "Karantene til", "Karantän tills");

export const NumberInventory_ReasonForDeletion = new Translation("Please enter the reason to make unavailable (max 10 characters):", "", "Vennligst skriv inn årsaken til slettingen (maks 10 tegn):", "Ange orsaken till borttagningen (max 10 tecken):");

export const NumberInventory_Register = new Translation("Register contract", "", "Registrer kontrakt", "Registrera kontrakt");

export const NumberInventory_Reserve = new Translation("Reserve", "", "Reservere", "Reservera");

export const NumberInventory_ReservedDate = new Translation("Reserved date", "", "Reservert dato", "Reserverat datum");

export const NumberInventory_ReservedRemark = new Translation("Reserved remark", "", "Reserverad kommentar", "Reserverat kommentar");

export const NumberInventory_ReserveNumberSerie = new Translation("Reserve number serie", "", "Reserver nummerserie", "Reservera nummerserie");

export const NumberInventory_ReserveTo = new Translation("Reserve to (customer name)", "", "Reserver til (kundenavn)", "Reservera till (kundnamn)");

export const NumberInventory_SearchNumber = new Translation("Search number or contract", "", "Søk nummer eller kontrakt", "Sök nummer eller kontrakt");

export const NumberInventory_SetAsOutported = new Translation("Set number as outported", "", "Angi nummer som eksportert", "Sätt nummer som utporterat");

export const NumberInventory_SetCategory = new Translation("Set category", "", "Angi kategori", "Ange kategori");

export const NumberInventory_SetNumberUnavailable = new Translation("Set number as unavailable", "", "Sett nummeret som utilgjengelig", "Ange nummer som otillgängligt");

export const NumberInventory_ShowOnlyAvailable = new Translation("Show only available", "", "Vis kun tilgjengelig", "Visa endast tillgängliga");

export const NumberInventory_UnavailableReason = new Translation("Unavailable reason", "", "Utilgjengelig grunn", "Otillgänglig orsak");

export const NumberInventory_Unregister = new Translation("Unregister contract", "", "Avregistrer kontrakt", "Avregistrera kontrakt");

export const NumberInventory_Verified = new Translation("Verified", "", "Verifisert", "Verifierat");

export const NumberOfActive = new Translation("Number of active", "", "Antall aktive", "Antal aktiva");

export const NumberOfAllowedSubscriptions = new Translation("Approved subscriptions ", "", "Antal tillatt", "Antal tillåtna abo");

export const numberOfContracts = new Translation("Number of Contracts", "", "kontrakt", "st kontrakt");

export const NumberTakenTryAnother = new Translation("Number is used by someone else. Please try with a new number. ", "", "Nummeret du har tastet er allerede reservert av noen andre, prøv et nytt nummer", "Numret har redan reserverats av någon annan, prova med ett annat nummer");

export const OnlyNumbersAllowed = new Translation("Only Numbers allowed ", "", "Skal kun inneholde nummer", "Ska enbart innehålla siffror");

export const OrganizationNumber_Long = new Translation("organization number ", "", "Organisasjonsnummer", "Organisationsnummer");

export const OrganizationNumber_Mask = new Translation("DDMMYYYYNNNNN", "", "DDMMYYNNNNN", "YYMMDDNNNN");

export const OrganizationNumber_Short = new Translation("Org Number ", "", "Org.nummer", "Org.nummer");

export const OriginCost = new Translation("Price ", "", "Grunnpris", "Grundpris");

export const PageTitle_RegisterS = new Translation("Register customer and subscriptions", "", "Registrere kunde og abonnementer", "Registrera Kund och Abonnemang");

export const PageTitle_Translations = new Translation("Translation", "", "Oversettelse", "Översättning");

export const Paid = new Translation("Paid", "", "Betalt", "Betald");

export const PayedInvoices = new Translation("Invoices", "", "Fakturaer", "Fakturor");

export const Pending = new Translation("Pending", "", "Venter", "Avvaktande");

export const PhoneNumber_Value = new Translation("Telephone Number", "", "Telefonnummer", "Telefonnummer");

export const PhoneNumber_AuxInputInfo = new Translation("All numbers without spaces or punctuations", "", "Alle siffer uten mellomrom eller skilletegn", "Alla siffor utan blanksteg eller skiljetecken");

export const PhoneNumber_PlaceHolder = new Translation("Subscription telephone number", "", "Abonnementets telefonnummer (f.eks 90120123)", "Abbonemangets telefonnummer (t.ex. 07615444233)");

export const Pricelists_Value = new Translation("Pricelists", "", "Prislister", "Prislistor");

export const Pricelists_CopyPriceList = new Translation("Copy price list", "", "Kopier prisliste", "Kopiera prislista");

export const Pricelists_PriceChanges_Value = new Translation("Feechanges", "", "Avgiftsendringar", "Avgiftsändringar");

export const Pricelists_PriceChanges_Affected = new Translation("Changed", "", "Endret", "Ändrade");

export const Pricelists_PriceChanges_ApprovedBy = new Translation("Approved by", "", "Godkjent av", "Godkänd av");

export const Pricelists_PriceChanges_Choose = new Translation("Select file to make fee changes", "", "Velg fil for å gjøre gebyrendringer", "Välj fil för att genomföra avgiftsändringar");

export const Pricelists_PriceChanges_Download = new Translation("Download csv file with fees", "", "Last ned csv-fil med avgifter", "Hämta csv fil med avgifter");

export const Pricelists_PriceChanges_FeesPriceChange = new Translation("Prepare fee change", "", "Forbered avgiftsendring", "Förbered avgiftsändring");

export const Pricelists_PriceChanges_FileName = new Translation("FileName", "", "FileName", "Filnamn");

export const Pricelists_PriceChanges_Ignored = new Translation("Ignored", "", "Ignored", "Ignoreras");

export const Pricelists_PriceChanges_Instruction1 = new Translation("Download a CSV file containing all active fees", "Lataa CSV-tiedosto, joka sisältää kaikki aktiiviset maksut", "Last ned en CSV-fil med alle aktive gebyrer", "Ladda ner en CSV-fil med alla aktiva avgifter");

export const Pricelists_PriceChanges_Instruction2 = new Translation("Open the file in Excel and feel free to use AutoFilter to filter and sort", "Avaa tiedosto Excelissä ja käytä halutessasi automaattista suodatusta tietojen suodattamiseen ja lajitteluun", "Åpne filen i Excel, og bruk gjerne autofilter for å filtrere og sortere", "Öppna filen i Excel och använd gärna autofilter för att filtrera och sortera");

export const Pricelists_PriceChanges_Instruction3 = new Translation("Where changes are required, add a new column to the right of the existing columns. Use the format New + field name, e.g. NewUnitPrice and NewStartDate", "Jos haluat tehdä muutoksia, lisää uusi sarake olemassa olevien sarakkeiden oikealle puolelle. Käytä muotoa New + kentän nimi, esimerkiksi NewUnitPrice ja NewStartDate", "Hvis du skal gjøre endringer, legger du til en ny kolonne til høyre for de eksisterende kolonnene. Bruk formatet New + feltnavn, for eksempel NewUnitPrice og NewStartDate", "Om ändringar ska göras lägger du till en ny kolumn till höger om de befintliga kolumnerna. Använd formatet New + fältnamn, till exempel New UnitPrice och New StartDate");

export const Pricelists_PriceChanges_Instruction4 = new Translation("Once you have made the changes, save the file in CSV format", "Kun olet tehnyt muutokset, tallenna tiedosto CSV-muodossa", "Når du er ferdig med endringene, lagrer du filen i CSV-format", "När du är klar med ändringarna sparar du filen i CSV-format");

export const Pricelists_PriceChanges_Instruction5 = new Translation("Select the file and upload it", "Valitse tiedosto ja lataa se", "Velg filen og last den opp", "Välj filen och ladda upp den");

export const Pricelists_PriceChanges_Instruction6 = new Translation("Click Fee Changes and check that the number of changes is correct", "Napsauta Maksumuutokset ja tarkista, että muutosten määrä on oikea", "Klikk på Gebyrendringer, og kontroller at antallet endringer stemmer", "Klicka på Avgiftsändringar och kontrollera att antalet ändringar stämmer");

export const Pricelists_PriceChanges_Instruction7 = new Translation("Click Implement Fee Changes", "Napsauta Toteuta maksumuutokset.", "Klikk på Gjennomfør gebyrendringer", "Klicka på Genomför avgiftsändringar");

export const Pricelists_PriceChanges_InstructionDesc = new Translation("Here you can make fee changes to subscription fees.", "", "Her kan du gjøre gebyrendringer i abonnementsavgiftene.", "Här kan du göra avgiftsändringar på abonnemangsavgifter.");

export const Pricelists_PriceChanges_InstructionDoThis = new Translation("Do this", "", "Gjør dette", "Gör så här");

export const Pricelists_PriceChanges_MakeChange = new Translation("Make change", "", "Gjør forandring", "Genomför ändring");

export const Pricelists_PriceChanges_StartBy = new Translation("Started by", "", "Startet av", "Startad av");

export const Pricelists_PriceChanges_Status = new Translation("Status", "", "Status", "Status");

export const Pricelists_PriceChanges_Updatefees = new Translation("Fee changes", "", "Avgiftsendringer", "Avgiftsändringar");

export const Pricelists_PriceChanges_Upload = new Translation("Upload", "", "Laste opp", "Ladda upp");

export const Pricelists_PriceChanges_Uploaded = new Translation("Quantity", "", "Mengde", "Antal");

export const Pricelists_PriceChanges_UploadTime = new Translation("Uploaded", "", "Lastet opp", "Uppladdad");

export const Pricelists_Pricelists = new Translation("Pricelists", "", "Prislister", "Prislistor");

export const ProductType_Broadband = new Translation("Broadband", "", "Bredbånd", "Bredband");

export const ProductType_Electricity = new Translation("Electricity", "", "El", "El");

export const ProductType_Fixed = new Translation("Telephone", "", "Fastnett", "Fast telefoni");

export const ProductType_Mobile = new Translation("Mobile phone", "", "Mobiltelefoni", "Mobiltelefoni");

export const ProductType_MobileBroadband = new Translation("Mobile broadband", "", "Mobilt bredbånd", "Mobilt bredband");

export const ProductType_Other = new Translation("Other", "", "Annet", "Annat");

export const ProductType_Voip = new Translation("IP line", "", "IP-telefoni", "IP-telefoni");

export const ReceiptInvoices = new Translation("Receipt S1", "", "Kvittering S1", "Kvittens S1");

export const Receiver = new Translation("Answering machine", "", "Mottakere", "Mottagare ");

export const Register_AddSeller = new Translation("Add seller", "", "Legg til selger", "Lägg till säljare");

export const Register_ChooseSeller = new Translation("Choose seller", "", "Velg selger", "Välj säljare");

export const Register_Company = new Translation("Company", "", "Bedrift", "Företag");

export const Register_Confirmation = new Translation("Confirmation", "", "Bekreftelse", "Bekräftelse");

export const Register_ConfirmOrder = new Translation("Confirm order", "", "Bekreft ordre", "Bekräfta order");

export const Register_CreatedSubscription = new Translation("Created subscription", "", "Opprettet abonnement", "Skapat abonnemang");

export const Register_CreateNewNumber = new Translation("Create new number", "", "Opprett nytt nummer", "Skapa nytt nummer");

export const Register_CreateNewSubscription = new Translation("Created another subscription", "", "Opprett et nytt abonnement", "Skapa ett till abonnemang");

export const Register_CreditCheckApproved = new Translation("Credit check approved", "", "Godkjent kredittsjekk", "Godkänd kreditprövning");

export const Register_CustomerData = new Translation("Customer data", "", "Kundedata", "Kunddata");

export const Register_DesiredPortingDate = new Translation("Desired porting date", "", "Ønsket porteringsdato", "Önskat porteringsdatum");

export const Register_FirstName = new Translation("First name", "", "Fornavn", "Förnamn");

export const Register_FullName = new Translation("Full name", "", "Full navn", "Fullständigt namn");

export const Register_General = new Translation("General", "", "Generelt", "Generellt");

export const Register_IdControl = new Translation("ID-control", "", "Kontroll av ID", "Kontroll av ID");

export const Register_Keep = new Translation("Keep", "", "Behold", "Behåll");

export const Register_KeepExistingNumberInfo = new Translation("Choose whether you want to keep your existing mobile number or create a new one", "", "Velg om du vil beholde eksisterende mobilnummer eller oprette et nytt", "Välj om du vill behålla ditt befintliga mobilnummer eller skapa ett nytt");

export const Register_LastName = new Translation("Last name", "", "Etternavn", "Efternman");

export const Register_MonthlyCost = new Translation("Monthly cost", "", "Månedlig kostnad", "Månadskostnad");

export const Register_NewCustomer = new Translation("New customer", "", "Ny kunde", "Ny kund");

export const Register_OrderOverview = new Translation("Order overview", "", "Ordreoversikt", "Orderöversikt");

export const Register_PersonOrgNr = new Translation("Person/org-number", "", "Person/org-nummer", "Person/org-nummer");

export const Register_Private = new Translation("Private", "", "Privat", "Privat");

export const Register_RegisterNewCustomer = new Translation("Register new customer", "", "Registrer ny kunde", "Registrera ny kund");

export const Register_Seller = new Translation("Seller", "", "Selger", "Säljare");

export const Register_Subscription = new Translation("Subscriptions", "", "Abonnement", "Abonnemang");

export const Register_Twin = new Translation("Twin", "", "Tvilling", "Tvilling");

export const Register_UnpaidInvoices = new Translation("The customer has unpaid invoices", "", "Kunden har ubetalte fakturaer", "Kunden har obetalda fakturor");

export const RegisterNewAccountTo = new Translation("Register new account to ", "", "Registrere nytt konto til", "Registrera nytt konto till");

export const ReplaceWithContractTypeCode = new Translation("When replacing, replace with", "Kun vaihdat, vaihda tilalle", "Ved utskifting, erstatt med", "Vid byte ersätt med");

export const Reports_R03_Subscriptions_Active = new Translation("Active", "", "Aktiv", "Aktiva");

export const Reports_R03_Subscriptions_Contracts = new Translation("Subscription", "", "Abonnement", "Abonnemang");

export const Reports_R03_Subscriptions_ContractType = new Translation("Contract type", "", "Kontraktstype", "Kontraktstyp");

export const Reports_R03_Subscriptions_Details = new Translation("All subscriptions with details", "", "Alle abonnement med detaljer", "Alla abonnemang med detaljer");

export const Reports_R03_Subscriptions_Inactive = new Translation("Deactive", "", "Inaktiv", "Inaktiva");

export const Reports_R03_Subscriptions_Summation = new Translation("Summation", "", "Sum", "Summering");

export const Reports_R03_Subscriptions_ToExcel = new Translation("Download full report to Excel", "", "Hent full rapport til Excel", "Hämta full rapport till Excel");

export const Reports_R03_SubscriptionsNew_AllContracts = new Translation("All contracts", "", "Alle kontrakter", "Alla kontrakt");

export const Reports_R03_SubscriptionsNew_Contracts = new Translation("Contracts", "", "Abonnement", "Abonnemang");

export const Reports_R03_SubscriptionsNew_ContractType = new Translation("Contract type", "", "Kontraktstype", "Kontraktstyp");

export const Reports_R03_SubscriptionsNew_ContractValue = new Translation("Contract Value", "", "Kontraktsverdi", "Kontraktsvärde");

export const Reports_R03_SubscriptionsNew_Created = new Translation("Created", "", "Opprettet", "Skapade");

export const Reports_R03_SubscriptionsNew_CreatedContracts = new Translation("Number of contracts created / month", "", "Antall kontrakter opprettet per måned", "Antal skapade kontrakt / månad");

export const Reports_R03_SubscriptionsNew_Entries = new Translation("Entries", "", "Innganger", "Entiteter");

export const Reports_R03_SubscriptionsNew_mortgage = new Translation("Leveraged", "", "Belånt", "Belånat");

export const Reports_R03_SubscriptionsNew_Next = new Translation("Next", "", "Neste", "nästa");

export const Reports_R03_SubscriptionsNew_NoActive = new Translation("Number of active", "", "Antall aktive", "Aktiva #");

export const Reports_R03_SubscriptionsNew_NoInactive = new Translation("Number of deactive", "", "Antall inaktive", "Inaktiva #");

export const Reports_R03_SubscriptionsNew_Oerview = new Translation("Oerview", "", "Oversikt", "Översikt");

export const Reports_R03_SubscriptionsNew_Previous = new Translation("Previous", "", "Forrige", "förra");

export const Reports_R03_SubscriptionsNew_Show = new Translation("Show", "", "Vis", "Visa");

export const Reports_R03_SubscriptionsNew_ToExcel = new Translation("Download full report to Excel for the selected period", "", "Hent full rapport til Excel for valgt periode", "Hämta full rapport till Excel för vald period");

export const Reports_R03_SubscriptionsNew_TopTen = new Translation("(Top 10) Created contracts / Users and sellers", "", "(Topp 10) Opprettede kontrakter / Brukere og selgere", "(Top 10) Skapade kontrakt /Användare och säljare");

export const Reports_R03_SubscriptionsNew_Views = new Translation("Views", "", "Visninger", "Vyer");

export const Reports_R06_CostControl_Contract = new Translation("Contract", "", "Kontrakt", "Kontrakt");

export const Reports_R06_CostControl_ContractType = new Translation("Contract type code", "", "Kontraktstypekode", "Kontraktstyp-kod");

export const Reports_R06_CostControl_CostControl = new Translation("Cost control", "", "Kostnadskontroll", "Kostnadskontroll");

export const Reports_R06_CostControl_CostControl2 = new Translation("Cost control", "", "Kostnadskontroll", "Kostnadskontroll");

export const Reports_R06_CostControl_Load = new Translation("Loading", "", "Laster data", "Laddar data");

export const Reports_R06_CostControl_MissDay = new Translation("Contract types that lack day control", "", "Kontraktstyper savner dagskontroll", "Kontraktstyper som saknar dags-kontroll ");

export const Reports_R06_CostControl_MissDefault = new Translation("Contracts lacking \u0027default\u0027 cost control", "", "Kontrakt savner \u0027default\u0027 kostnadskontroll", "Kontrakt som saknar \u0027default\u0027 kostnadskontroll");

export const Reports_R06_CostControl_MissMounth = new Translation("Contract types that do not have monthly checks", "", "Kontraktstyper savner månedskontroll", "Kontraktstyper som saknar månads-kontroll");

export const Reports_R06_CostControl_Populate = new Translation("Populate SQL", "", "Populerings SQL", "Populerings SQL");

export const Reports_R07_Highusage_ContractNr = new Translation("Contract number", "", "Kontraktsnummer", "Kontraktsnummer");

export const Reports_R07_Highusage_exceed = new Translation("Upper amount", "", "Øvre beløp", "Övre belopp");

export const Reports_R07_Highusage_ExVAT = new Translation("Total excluding VAT", "", "Sum ekskl. mva", "Summa exklusive moms");

export const Reports_R07_Highusage_HighUsage = new Translation("High Usage", "", "Høyt forbruk", "Hög förbrukning");

export const Reports_R07_Highusage_HighUsageText = new Translation("Current month per contract", "", "Inneværende måned per kontrakt", "Innevarande månad per kontrakt");

export const Reports_R07_Highusage_ResentReg = new Translation("Last registered traffic", "", "Seneste registrerte trafikk", "Senast registrerad trafik");

export const Reports_R07_Highusage_Summation = new Translation("Summation", "", "Sum", "Summering");

export const Reports_R08_Marginreport_Contracttype = new Translation("Contract type", "", "Kontraktstype", "Kontrakttyp/Bärare");

export const Reports_R08_Marginreport_Income = new Translation("Income", "", "Inntekt", "Intäkt");

export const Reports_R08_Marginreport_MargReport = new Translation("Margin Report", "", "Marginalrapport", "Marginalrapport");

export const Reports_R08_Marginreport_MargReportText = new Translation("The Margin Report is indicative and based on CDR data. Improvement work is in progress.", "", "Marginalrapport er indikativ og basert på CDR-data. Forbedringsarbeid pågår. ", "Marginalrapporten är indikativ och baserad på CDR data. Förbättringsarbete pågår.");

export const Reports_R08_Marginreport_OrgCost = new Translation("Org cost", "", "Org. kost", "\"Org Cost\"");

export const Reports_R08_Marginreport_ToExcel = new Translation("Download full report to Excel for the selected period", "", "Hent full rapport til Excel for valgt periode", "Hämta full rapport till Excel för vald period");

export const Reports_R08_Marginreport_TraficPeriod = new Translation("Trafic period", "", "Trafikkperiode", "Trafikperiod");

export const Reports_R08_Marginreport_Units = new Translation("Units", "", "Enheter", "enheter");

export const Reports_R09_Unboundtrafic_After = new Translation("After", "", "Etter", "Efter");

export const Reports_R09_Unboundtrafic_Entries = new Translation("entries", "", "Innganger", "Poster");

export const Reports_R09_Unboundtrafic_From = new Translation("From", "", "Fra", "Tidigaste trafik");

export const Reports_R09_Unboundtrafic_Imsi = new Translation("Imsi", "", "Imsi", "Imsi");

export const Reports_R09_Unboundtrafic_Kontact = new Translation("Contact our support \u003ca href=\"mailto:support-sbs@svea.com\"\u003esupport-sbs@svea.com\u003c/a\u003e ", "", "Kontakte support \u003ca href=\"mail:support-sbs@svea.com\"\u003esupport-sbs@svea.com\u003c/a\u003e så kanskje vi kan hjelpe deg.", "Kontakta \u003ca href=\"mailto:support-sbs@svea.com\"\u003esupport-sbs@svea.com\u003c/a\u003e så kanske vi kan hjälpa er.");

export const Reports_R09_Unboundtrafic_MissingInfoText = new Translation("Missing contract information", "", "Informasjon om denne kontrakten savnes i våre systemer.", "Information om detta kontrakt saknas i våra system.");

export const Reports_R09_Unboundtrafic_Next = new Translation("Next", "", "Neste", "Nästa");

export const Reports_R09_Unboundtrafic_NoPosts = new Translation("Number of posts", "", "Antall poster", "Antal poster");

export const Reports_R09_Unboundtrafic_Phonenumber = new Translation("Phonenumber", "", "Telefonnummer", "Telefonnummer");

export const Reports_R09_Unboundtrafic_Port = new Translation("Port/Contract", "", "Port/avtale", "Port/avtal");

export const Reports_R09_Unboundtrafic_Previous = new Translation("Previous", "", "Forrige", "Förra");

export const Reports_R09_Unboundtrafic_Search = new Translation("Search", "", "Søk", "Sök");

export const Reports_R09_Unboundtrafic_Show = new Translation("Show", "", "Vis", "Visa");

export const Reports_R09_Unboundtrafic_Showing = new Translation("Showing", "", "Viser", "Visar");

export const Reports_R09_Unboundtrafic_Suspens = new Translation("Suspens", "", "Suspens", "Suspens");

export const Reports_R09_Unboundtrafic_SuspensText = new Translation("The cost is indicative and is based on CDR data", "", "Kostnaden er indikativ og baseres på CDR-data", "Kostnaden är indikativ och baseras på CDR data");

export const Reports_R09_Unboundtrafic_To = new Translation("To", "", "Til", "Senaste trafik");

export const Reports_R09_Unboundtrafic_ToExcel = new Translation("Download full report to Excel for the selected period", "", "Hente full rapport til Excel for valgt periode", "Hämta full rapport till Excel för vald period");

export const Reports_R09_Unboundtrafic_TooManyText = new Translation("Total amount", "", "Total kostnad", "Det finns för många möjliga korrigeringar att göra.");

export const Reports_R09_Unboundtrafic_ToShow = new Translation("To", "", "Til", "Till");

export const Reports_R09_Unboundtrafic_TotalAmount = new Translation("Total amount", "", "Total kostnad", "Total kostnad");

export const Reports_R12_NotInvoiced_Contract = new Translation("Contract", "", "Kontrakt", "Kontrakt");

export const Reports_R12_NotInvoiced_ContractText = new Translation("contract", "", "Kontrakt", "kontrakt");

export const Reports_R12_NotInvoiced_Customer = new Translation("Customer", "", "Kunde", "Kund");

export const Reports_R12_NotInvoiced_Customers = new Translation("customers", "", "kunder", "kunder");

export const Reports_R12_NotInvoiced_Fees = new Translation("Fees", "", "Avgifter", "Avgifter");

export const Reports_R12_NotInvoiced_Load = new Translation("Loading", "", "Laster data", "Laddar data");

export const Reports_R12_NotInvoiced_LoadData = new Translation("loading", "", "laster data", "laddar data");

export const Reports_R12_NotInvoiced_Marked = new Translation("marked as \"Do not invoice\"", "", "markert som \"Faktureres ikke\"", "markerade som \"Faktureras ej\"");

export const Reports_R12_NotInvoiced_NotInvoiced = new Translation("Not invoiced", "", "Ikke fakturert", "Inte fakturerat");

export const Reports_R12_NotInvoiced_OfTheese = new Translation("Of theese are", "", "Av disse er", "Av dessa är");

export const Reports_R12_NotInvoiced_Period = new Translation("Period", "", "Periode", "Period");

export const Reports_R12_NotInvoiced_Text = new Translation("List of clients / contracts that have active fees that are more than 6 months back in time or more than 36 months in the future.", "", "Oversikt over kunder/kontrakter som har aktive avgifter som er mer enn seks måneder tilbake i tid eller mer enn 36 måneder frem i tid.", "Lista över kunder/kontrakt som har aktiva avgifter som ligger mer än 6 månader bakåt i tiden eller mer än 36 månader framåt i tiden.");

export const Reports_R12_NotInvoiced_Text2 = new Translation("means that the customer or contract is marked as \"Do not invoice\"", "", "betyr at kunde eller kontrakt er markert som \"Faktureres ikke\"", "betyder att kund eller kontrakt är markerade som \"Faktureras ej\"");

export const Reports_R12_NotInvoiced_Total = new Translation("Total", "", "Totalt", "Totalt");

export const Reports_R13_DetailReport_Contract = new Translation("Contract", "", "Kontrakt", "Kontrakt");

export const Reports_R13_DetailReport_ContractDate = new Translation("Contract date", "", "Kontrakt dato", "Kontraktsdatum");

export const Reports_R13_DetailReport_ContractType = new Translation("Contract type", "", "Kontrakt type", "Kontraktstyp");

export const Reports_R13_DetailReport_ContractTypeDisplay = new Translation("Description", "", "Beskrivelse", "Beskrivning");

export const Reports_R13_DetailReport_MortgageBlocked = new Translation("Blocked", "", "Blokkert", "Blockerad");

export const Reports_R13_DetailReport_MortgageValue = new Translation("Mortgage value", "", "Panteverdi", "Belåningsvärde");

export const Reports_R13_DetailReport_Name = new Translation("Name", "", "Navn", "Namn");

export const Reports_R13_DetailReport_NoNextInvoice = new Translation("Don’t invoice", "", "Ikke fakturer", "Fakturera ej");

export const Reports_R13_DetailReport_Status = new Translation("Status", "", "Status", "Status");

export const Reports_R13_DetailReport_Stopped = new Translation("Stopped", "", "Stoppet", "Stoppad");

export const Reports_R14_Age_Age = new Translation("Age", "", "Aldersfordeling", "Åldersfördelning");

export const Reports_R14_Age_AgeGroup = new Translation("Age group", "", "Aldersgruppe", "Åldersgrupp");

export const Reports_R14_Age_GroupedToExcel = new Translation("Download Grouped To Excel", "", "Hent til Excel", "Hämta grupperad till Excel");

export const Reports_R14_Age_Load = new Translation("Loading", "", "Laster data", "Laddar data");

export const Reports_R14_Age_Number = new Translation("Number", "", "Antall", "Antal");

export const Reports_R14_Age_ToExcel = new Translation("Download to Excel", "", "Hent til Excel", "Hämta till Excel");

export const Reports_R25_R26_Portations_Advanced = new Translation("Advanced", "", "Avansert", "Avancerat");

export const Reports_R25_R26_Portations_ArchiveAbort = new Translation("", "", "Av-arkivere", "Av-arkivera");

export const Reports_R25_R26_Portations_Archived = new Translation("Archived", "", "Arkivert", "Arkiverad");

export const Reports_R25_R26_Portations_Cancelled = new Translation("Cancelled", "", "", "Avbrutna");

export const Reports_R25_R26_Portations_Contract = new Translation("Contract", "", "Kontrakt", "Kontrakt");

export const Reports_R25_R26_Portations_Created = new Translation("Created", "", "Skapet", "Skapad");

export const Reports_R25_R26_Portations_Customer = new Translation("Client", "", "Kunde", "Kund");

export const Reports_R25_R26_Portations_Description = new Translation("Description", "", "Beskrivelse", "Beskrivning");

export const Reports_R25_R26_Portations_Empty = new Translation("Empty", "", "Tom", "Töm");

export const Reports_R25_R26_Portations_Fees = new Translation("Fees", "", "Avgifter", "Avgifter");

export const Reports_R25_R26_Portations_FeeStatus = new Translation("Fee Status", "", "Avgiftsstatus", "Avgiftsstatus");

export const Reports_R25_R26_Portations_FeeType = new Translation("Fee type", "", "Avgiftstype", "Avgiftstyp");

export const Reports_R25_R26_Portations_History = new Translation("History", "", "Historikk", "Historiska");

export const Reports_R25_R26_Portations_Id = new Translation("Id", "", "Id", "Id");

export const Reports_R25_R26_Portations_Inportations = new Translation("Inportations", "", "Inportering", "Inporteringar");

export const Reports_R25_R26_Portations_MSISDN = new Translation("Number", "", "Nummer", "Nummer");

export const Reports_R25_R26_Portations_NetStatus = new Translation("Net Status", "", "Netstatus", "Nätstatus");

export const Reports_R25_R26_Portations_Next = new Translation("Next Page", "", "Neste side", "Nästa sida");

export const Reports_R25_R26_Portations_Of = new Translation("of", "", "av", "av");

export const Reports_R25_R26_Portations_Other = new Translation("Pending", "", "", "Väntande");

export const Reports_R25_R26_Portations_OtherNearTime = new Translation("Pending Near Time", "", "", "Väntande i närtid");

export const Reports_R25_R26_Portations_Page = new Translation("Page", "", "Side", "Sida");

export const Reports_R25_R26_Portations_Planned = new Translation("Planned", "", "Planlagt", "Planerade");

export const Reports_R25_R26_Portations_PortingId = new Translation("Porting Id", "", "Porterings Id", "Porterings Id");

export const Reports_R25_R26_Portations_PortingStatus = new Translation("Porting Status", "", "Porteringsstatus", "Porteringsstatus");

export const Reports_R25_R26_Portations_PortTime = new Translation("Porting Time", "", "Porteringstidspunkt", "Porteringstidpunkt");

export const Reports_R25_R26_Portations_Previous = new Translation("Previous page", "", "Forrige Side", "Föregående sida");

export const Reports_R25_R26_Portations_PrevPort = new Translation("Previous porting attempts", "", "Tidligere porteringsforsøk", "Tidigare porteringsförsök");

export const Reports_R25_R26_Portations_requestAbort = new Translation("Abort Inportation", "", "Avbryt portering", "Begär avbryt portering");

export const Reports_R25_R26_Portations_sortAsc = new Translation("Ascending", "", "Stigende", "Stigande");

export const Reports_R25_R26_Portations_sortDesc = new Translation("Descending", "", "Synkende", "Sjunkande");

export const Reports_R25_R26_Portations_Sorting = new Translation("Sort", "", "Sortering", "Sortering");

export const Reports_R25_R26_Portations_SP = new Translation("Service Provider", "", "Tilbyder", "Operatör");

export const Reports_R25_R26_Portations_SPID = new Translation("SPID", "", "Tilbyderid", "SPID");

export const Reports_R25_R26_Portations_Start = new Translation("Start date", "", "Startdato", "Startdatum");

export const Reports_R25_R26_Portations_Status = new Translation("Status", "", "Status", "Status");

export const Reports_R25_R26_Portations_Sum = new Translation("amount", "", "Sum", "Summa");

export const Reports_R25_R26_Portations_TextSearch = new Translation("Free text search", "", "Fritekstsøk", "Fritextsök");

export const Reports_R25_R26_Portations_ToExcel = new Translation("Download to Excel", "", "Hent til Excel", "Hämta till Excel");

export const Reports_R25_R26_Portations_Total = new Translation("Total:", "", "Totalt antall", "Totalt antal:");

export const Reports_R25_R26_Portations_Unsuccessful = new Translation("Denied", "", "", "Nekade");

export const Reports_R25_Outportations_Date = new Translation("Outport date", "", "Utporteringsdato", "utporteringsdatum");

export const Reports_R25_Outportations_Event = new Translation("Event", "", "Hendelse", "Händelse");

export const Reports_R25_Outportations_Number = new Translation("Number of Contracts", "", "Antall kontrakter", "antal kontrakt");

export const Reports_R25_Outportations_OutPort = new Translation("Outportations", "", "Utporteringer", "Utporteringar");

export const Reports_R25_Outportations_ToExcel = new Translation("Download full report to Excel", "", "Hent full rapport til Excel", "Hämta full rapport till Excel");

export const Reports_R35_CallsByDate_Amount = new Translation("Amount", "", "Mengde", "Volym");

export const Reports_R35_CallsByDate_BasePrice = new Translation("Base Price", "", "Pris", "Grundpris");

export const Reports_R35_CallsByDate_BearerType = new Translation("Call type", "", "Samtaletype", "Samtalstyp");

export const Reports_R35_CallsByDate_B$002Dnumber = new Translation("B-Number", "", "B-nummer", "B-nummer");

export const Reports_R35_CallsByDate_ContractNumber = new Translation("Contract, Number …", "", "Kontrakt, nummer…", "Kontrakt, nummer…");

export const Reports_R35_CallsByDate_Cost = new Translation("Cost", "", "Koste", "Kostnad");

export const Reports_R35_CallsByDate_Description = new Translation("Description", "", "Beskrivelse", "Beskrivning");

export const Reports_R35_CallsByDate_Earlier = new Translation("Formerly R02, R35 and R36 combined", "", "Tidligere R02, R35 og R36 kombinert", "Tidigare R02, R35 och R36 kombinerade");

export const Reports_R35_CallsByDate_GetToExcel = new Translation("Download to Excel", "", "Hent til Excel", "Hämta till Excel");

export const Reports_R35_CallsByDate_InvoiceDate = new Translation("Invoice Date", "", "Fakturadato", "Fakturadatum");

export const Reports_R35_CallsByDate_InvoicedTrafic = new Translation("Invoiced trafic", "", "Fakturert trafikk", "Fakturerad trafik");

export const Reports_R35_CallsByDate_InvoiceNumber = new Translation("Invoice Number", "", "Fakturanummer", "Fakturanummer");

export const Reports_R35_CallsByDate_LoadData = new Translation("loading...", "", "laster data…", "laddar data...");

export const Reports_R35_CallsByDate_MaxResult = new Translation("The result is limited to a maximum of 5000 lines. Narrow the date range to see additional rows.", "", "Resultatet er begrenset til mat 5000 rader. Begrens datointervallet for å se ytterligere rader.", "Resultatet är begränsat till max 5000 rader. Begränsa datumintervallet för att se ytterligare rader.");

export const Reports_R35_CallsByDate_NotingFound = new Translation("We could not find any traffic within the specified date range. Please check the dates and try again.", "", "Vi kan ikke finne noen trafikk i det angitte datointervallet. Vennligst kontroller datoene og forsøk på nytt. ", "Vi kunde inte hitta någon trafik inom det angivna datumintervallet. Kontrollera datumen och försök igen.");

export const Reports_R35_CallsByDate_NotInvoicedTrafic = new Translation("Not invoiced trafic", "", "Ikke-fakturert trafikk", "Ej fakturerad trafik");

export const Reports_R35_CallsByDate_Number = new Translation("Number", "", "Nummer", "Nummer");

export const Reports_R35_CallsByDate_Price = new Translation("Price", "", "Pris", "Pris");

export const Reports_R35_CallsByDate_PriceExcVAT = new Translation("Price", "", "Pris", "Pris");

export const Reports_R35_CallsByDate_PriceIncVAT = new Translation("Prices incl. VAT", "", "Priser inkl. mva", "Priser inkl. moms");

export const Reports_R35_CallsByDate_ShowTrafik = new Translation("Show all Trafic", "", "Vis all trafikk", "Visa all trafik");

export const Reports_R35_CallsByDate_Time = new Translation("Time", "", "Tidspunkt", "Tidpunkt");

export const Reports_R35_CallsByDate_TraficReport = new Translation("Traffic", "", "Trafikk", "Trafik");

export const Reports_TooBig = new Translation("This dataset is too large to display online - download to excel using the button above.", "", "Dette datasettet er for stort til å vises online – last ned for å utmerke seg ved å bruke knappen ovenfor.", "Detta dataset är för stort för att visa online - hämta till excel med knappen ovan.");

export const Repports_R13_Mortgage_Accepted = new Translation("Meet the conditions", "", "Oppfyller vilkår", "Uppfyller villkoren");

export const Repports_R13_Mortgage_Age = new Translation("Age", "", "Alder", "Ålder");

export const Repports_R13_Mortgage_Amount = new Translation("Amount", "", "Beløp", "Belopp");

export const Repports_R13_Mortgage_AnnualBinding = new Translation("Annual binding", "", "Årlig binding", "Årlig ombindning");

export const Repports_R13_Mortgage_ApprovedInTable = new Translation("Approved", "", "Godkjent", "Godkänt");

export const Repports_R13_Mortgage_ApprovedValue = new Translation("Approved value", "", "Godkjent verdi", "Godkänt värde");

export const Repports_R13_Mortgage_Contract = new Translation("Contract", "", "Avtal", "Avtal");

export const Repports_R13_Mortgage_ContractPerMounth = new Translation("Contracts Per mounth", "", "Kontrakt per måned", "Kontrakt per månad");

export const Repports_R13_Mortgage_ContractPerMounthText = new Translation("The current month\u0027s number is an interpolation based on the number of contracts registered so far", "", "Inneværende måneds antall er en interpolering utifra antallet registrerte kontrakter så langt", "Innevarande månads antal är en interpolering utifrån antalet hittills registrerade kontrakt");

export const Repports_R13_Mortgage_ContractRegisterdPerM = new Translation("Registered contracts per month", "", "Registrerte kontrakter per måned", "Registrerade kontrakt per månad");

export const Repports_R13_Mortgage_ContractText = new Translation("Contract text", "", "Ved godkjent fysisk kontrakt", "Om det fysiska kontraktet är godkänt");

export const Repports_R13_Mortgage_ContractValue = new Translation("Contract value", "Sopimuksen arvo", "Kontraktsverdi", "Kontraktsvärde");

export const Repports_R13_Mortgage_ContractValueInTable = new Translation("Contract Value", "", "Kontraktsverdi", "Kontraktsvärde");

export const Repports_R13_Mortgage_CreditCheck = new Translation("Credit checked", "", "Kredittkontroll", "Kreditkontroll");

export const Repports_R13_Mortgage_CreditCheckText = new Translation("Credit checked text", "", "Ved godkjent kredittkontroll", "Om godkänd kreditkontroll finns");

export const Repports_R13_Mortgage_FysContract = new Translation("Physical contract", "", "Fysisk kontrakt", "Fysiskt kontrakt");

export const Repports_R13_Mortgage_Invoices = new Translation("Invoices", "", "Fakturaer", "Fakturor");

export const Repports_R13_Mortgage_InvoicesText = new Translation("Invoices text", "", "Fakturatekst", "Om tillräckligt många betalda fakturor finns");

export const Repports_R13_Mortgage_IsValidMortgageBlocked = new Translation("Meet the conditions but: \"Mortgage stopped\"", "", "Oppfyller vilkår men:\"Belåning stoppet\"", "Uppfyller villkoren men: \"Belåning stoppad\"");

export const Repports_R13_Mortgage_IsValidNoNextInvoice = new Translation("Meet the conditions but: \"No next invoice\"", "", "Oppfyller vilkår men: \"Ikke fakturer\"", "Uppfyller villkoren men: \"Fakturera ej\"");

export const Repports_R13_Mortgage_LastUpdated = new Translation("Last updated:", "", "Sist oppdatert:", "Senast uppdaterad:");

export const Repports_R13_Mortgage_Leverage = new Translation("Leverage", "", "Belåning", "Belåning");

export const Repports_R13_Mortgage_Limit = new Translation("Limit", "Limiitti", "Grense", "Limit");

export const Repports_R13_Mortgage_LoanableAmount = new Translation("Eligible for mortgage", "Lainoitettava määrä", "Belåningsbart", "Belåningsbart");

export const Repports_R13_Mortgage_LoanValueRatio = new Translation("Loan-to-value ratio", "Lainoitusaste", "Belåningsgrad", "Belåningsgrad");

export const Repports_R13_Mortgage_MissingContractType = new Translation("Missing Contract Type", "", "Kontraktstype savnes", "Kontraktstyp saknas");

export const Repports_R13_Mortgage_Mortgage = new Translation("Contract Evaluation", "", "Kontraktsverdi", "Kontraktsvärdering");

export const Repports_R13_Mortgage_MortgageBlocked = new Translation("Mortgage stopped", "", "Belåning stoppet", "Belåning stoppad");

export const Repports_R13_Mortgage_MortgageFees = new Translation("Mortgage fees", "", "Fysisk kontrakt", "Belåningsbara avgifter");

export const Repports_R13_Mortgage_MortgageHeader = new Translation("Mortgage", "Asuntolaina", "Belåning", "Belåning");

export const Repports_R13_Mortgage_New = new Translation("Newly registered", "", "Nye registreringer", "Nyregistrerade");

export const Repports_R13_Mortgage_NewText = new Translation("Newly registered text", "", "Ikke verdsatte kontrakter", "Ännu ej validerade kontrakt");

export const Repports_R13_Mortgage_Noise = new Translation("Noise", "", "Støy", "brus");

export const Repports_R13_Mortgage_NoiseText = new Translation("Noise is mostly due to faults in registration. See", "", "Støy skyldes hovedsakelig feilregistreringer langt frem i tid samt eldre avgifter som av ulike årsaker ikke skal faktureres. Se", "Bruset beror primärt på felregistreringar långt fram i tiden samt äldre avgifter som av olika skäl inte fakturerats. Se");

export const Repports_R13_Mortgage_NoNextInvoice = new Translation("Don\u0027t invoice", "", "Ikke fakturer", "Fakturera ej");

export const Repports_R13_Mortgage_NotApprovedValue = new Translation("Not Approved Value", "", "Ikke-godkjent verdi", "Icke godkänt värde");

export const Repports_R13_Mortgage_NumberOfContracts = new Translation("number of Contracts", "", "Antall kontrakter", "Antal kontrakt");

export const Repports_R13_Mortgage_OutstandingLoan = new Translation("Loan", "Lainata", "Lån", "Lån");

export const Repports_R13_Mortgage_R12 = new Translation("R12 - Not Invoiced", "", "R12 - Ikke fakturert", "R12 - Inte fakturerat för en sammanställning av dessa.");

export const Repports_R13_Mortgage_ReduceNoise = new Translation("Reduce noise", "", "Reduser støy", "Reducera \"brus\"");

export const Repports_R13_Mortgage_showInvoicedValue = new Translation("show Invoiced value", "", "Hvis fakturert beløp", "Visa fakturerade belopp");

export const Repports_R13_Mortgage_StartFullReportJob = new Translation("This job (FullReport) will be started in the background. Depending on the amount of data, the process can take anywhere from a few seconds to 30 minutes.", "", "Denne jobben (FullReport) vil bli startet i bakgrunnen. Avhengig av mengden data, kan prosessen ta alt fra noen få sekunder til 30 minutter.", "Detta jobb (FullReport) kommer att startas i bakgrunden. Beroende på datamängd kan processen ta allt från några sekunder upp till 30 minuter.");

export const Repports_R13_Mortgage_Status = new Translation("Status", "", "Status", "Status");

export const Repports_R13_Mortgage_Total = new Translation("Total", "", "Totalt", "Totalt");

export const Repports_R13_Mortgage_TotalValue = new Translation("Total value", "", "Total verdi", "Totalt värde");

export const Repports_R13_Mortgage_TotalValueChange = new Translation("Total Value change", "", "Total verdiendring", "Total värdeutveckling");

export const Repports_R13_Mortgage_update = new Translation("Update", "", "Oppdater", "Uppdatera");

export const Repports_R13_Mortgage_UpdatesDaily = new Translation("Due to large amounts of data, this report is updated every day at approximately 23:00.", "", "På grunn av store datamengder oppdateres denne rapporten hver dag ca kl. 23:00.", "P.g.a. stora datamängder uppdateras denna rapport varje dag ca 23:00.");

export const Repports_R13_Mortgage_Valuation = new Translation("Valuation", "", "Verdsettelse", "Värdering");

export const Repports_R13_Mortgage_Value = new Translation("Value", "", "Verdi", "Värde");

export const Repports_R13_Mortgage_ValueModell = new Translation("Value model", "", "Verdsettelsesmodell", "Värderingsmodell");

export const Repports_R13_Mortgage_ValueOverTime = new Translation("Value Over Time", "", "Verdi over tid", "Värde över tid");

export const Repports_R13_Mortgage_ValueT = new Translation("Value", "", "Verdi", "Värde");

export const Salesman = new Translation("Salesperson", "", "Selger", "Säljare");

export const SaveInvoicee = new Translation("Save client ", "", "Lagre kunde", "Spara kund");

export const Search_AtTime = new Translation("At Time", "", "På tidspunkt", "vid");

export const Search_NoResult = new Translation("No Results", "", "Ingen resultater", "Inga resultat");

export const Search_Search = new Translation("Search Credit check", "", "Søk i kredittsjekk", "Sök Kreditupplysningar");

export const Search_SearchFor = new Translation("Search For", "", "Søk etter", "Sökning efter");

export const Search_SearchText = new Translation("Search Text", "", "Søketekst", "SökText");

export const ShouldBeAPhoneNumber = new Translation("Should be a telephone number ", "", "Må være en nummer", "Skall vara ett telefonnummer");

export const SimTakenTryAnother = new Translation("SIM card is used by another person or cannot find it. Please try another SIM card. ", "", "SIM-kortet er allerede i bruk eller finnes ikke, prøv et nytt SIM-kort", "Simkortet är redan taget eller så finns det inte, prova med ett annat simkort");

export const SomeFieldsNotCorrect = new Translation("One or more fields are not correct ", "", "Ett eller flere felt ikke er korrekt utfylt", "Något eller några fält är felaktigt ifyllda");

export const SomethingIsNotFilledInCorrectly = new Translation("One or more fields are not correct ", "", "Noe er ikke korrekt utfylt", "Något är inte korrekt ifyllt");

export const Startdate = new Translation("Startdate", "", "Startdato", "Startdatum");

export const StartMortgage = new Translation("Start mortgage", "", "Start belåning", "Ta bort belåningsstopp");

export const StartTime = new Translation("Time", "", "Tid", "Tidpunkt");

export const Status = new Translation("Status", "", "Status", "Status");

export const StatusAndWarnings_Cancelled = new Translation("Cancelled", "", "Abortert", "Avbrutna");

export const StatusAndWarnings_CancelledInfo = new Translation("All cancelled inportations. When action is taken on each inportation you should set it as Archived, thereafter it is removed from this report.", "", "Alle kansellerte inportasjoner. Når det iverksettes tiltak på hver inportasjon, bør du angi den som Arkivert, deretter fjernes den fra denne rapporten.", "Alla inställda inporteringar. När åtgärder vidtas för varje inportering bör du ställa in den som Arkiverad, därefter tas den bort från denna rapport.");

export const StatusAndWarnings_Denied = new Translation("Denied", "", "Nektet", "Nekade");

export const StatusAndWarnings_DeniedInfo = new Translation("All denied inportations. When action is taken on each inportation you should set it as Archived, thereafter it is removed from this report.", "", "Samtliga nekade inportasjoner. Når tiltakene for hver importering bør du ställa i den som Arkiverad, deretter tas den bort fra denne rapporten.", "Samtliga nekade inporteringar. När åtgärder vidtas för varje inportering bör du ställa in den som Arkiverad, därefter tas den bort från denna rapport.");

export const StatusAndWarnings_DirectDebit_ApprovedApplications = new Translation("Approved applications", "", "Godkjente søknader", "Godkända ansökningar");

export const StatusAndWarnings_DirectDebit_ApprovedApplicationsInfo = new Translation("All applications done last or current month and are approved.", "", "Alle søknader gjort forrige eller inneværende måned og godkjent", "Alla ansökningar gjorda förra eller innevarande månad och som godkänts.");

export const StatusAndWarnings_DirectDebit_NotApprovedApplications = new Translation("Previously not approved applications", "", "Tidligere ikke godkjente søknader", "Tidigare ej godkända ansökningar");

export const StatusAndWarnings_DirectDebit_NotApprovedApplicationsInfo = new Translation("All not approved applications.", "", "Alle ikke godkjente søknader.", "Alla ej godkända ansökningar.");

export const StatusAndWarnings_DirectDebit_PendingApplications = new Translation("Pending applications", "", "Ventende søknader", "Väntande ansökningar");

export const StatusAndWarnings_DirectDebit_PendingApplicationsInfo = new Translation("All applications done current or last month and not yet approved.", "", "Alle søknader gjort gjeldende eller forrige måned og ennå ikke godkjent.", "Alla ansökningar gjorda innevarande eller förra månaden och ännu inte godkända.");

export const StatusAndWarnings_DoneLastWeekday = new Translation("Done last weekday", "", "Gjort forrige ukedag", "Gjorda förra vardagen");

export const StatusAndWarnings_DoneLastWeekdayInfo = new Translation("Inportations that are done the last weekday (probably yesterday). When an inportation is done correctly, it will be set as Archived automatically.", "", "Inportasjoner som gjøres siste ukedag (sannsynligvis i går). Når en inportering er utført på riktig måte, vil den bli satt til Arkivert automatisk.", "Inporteringar som görs sista vardagen (troligen igår). När en inportering görs korrekt kommer den att ställas in som Arkiverad automatiskt.");

export const StatusAndWarnings_Inportations = new Translation("Inportations", "", "Inportasjoner", "Inporteringar");

export const StatusAndWarnings_Invoicing_Value = new Translation("Invoicing", "", "Fakturering", "Fakturering");

export const StatusAndWarnings_Invoicing_AddressMissing = new Translation("Address is missing", "", "Adresse mangler", "Adress saknas");

export const StatusAndWarnings_Invoicing_AddressMissingInfo = new Translation("An address to a customer cannot be empty, otherwise the invoice batch will crash.", "", "En adresse til en kunde kan ikke være tom, ellers krasjer faktura-batchen.", "En adress till en kund kan inte vara tom, annars kraschar faktura-batchen.");

export const StatusAndWarnings_Invoicing_CustomerNoNextInvoice = new Translation("Invoicees set as \"No next invoice\"", "", "Kunder er satt til «Ikke fakturert»", "Kunder satta som \"Faktureras ej\"");

export const StatusAndWarnings_Invoicing_CustomerNoNextInvoiceInfo = new Translation("The customer is set as \"No Invoice\". You should make sure that this is correct, otherwise the customer will not get invoiced.", "", "Kunden settes som \"Ikke fakturert\". Du bør sørge for at dette er riktig, ellers vil ikke kunden motta noen fakturaer.", "Kunden är satt som \"Fakturera ej\". Du bör se till att detta är korrekt, annars kommer kunden inte att få några fakturor.");

export const StatusAndWarnings_Invoicing_EmailDistributionNoEmail = new Translation("Invoicees without email", "", "Kunder uten e-post", "Kunder utan e-post");

export const StatusAndWarnings_Invoicing_EmailDistributionNoEmailInfo = new Translation("This will make the invoice process manual and the customer will get an invoice via paper and UG will pay a distribution cost. Best solution is to change to paper invoice.", "", "Dette vil gjøre fakturaprosessen manuelt og kunden vil få en faktura på papir og UG betaler en distribusjonskostnad. Beste løsningen er å bytte til papirfaktura.", "Detta kommer att göra fakturaprocessen manuell och kunden får en faktura via papper och UG betalar en distributionskostnad. Bästa lösningen är att byta till pappersfaktura.");

export const StatusAndWarnings_Invoicing_GDPRCustomers = new Translation("Customers terminated more than 2 years ago", "", "Kunder sluttet for mer enn 2 år siden", "Kunder avslutade för mer än 2 år sedan");

export const StatusAndWarnings_Invoicing_GDPRCustomersInfo = new Translation("Customers who terminated at least two years ago and have no unpaid invoices or active numbers. Or they were created in Fenix more than two years ago and never had a contract.", "", "Kunder som sa opp for minst to år siden og ikke har ubetalte fakturaer eller aktive numre. Eller de ble opprettet i Fenix ​​for mer enn to år siden og hadde aldri en kontrakt.", "Kunder som är avslutade för minst två år sedan och har inga obetalda fakturor eller aktiva nummer.  Eller så är de skapade i Fenix för mer än två år sedan och har aldrig haft ett kontrakt.");

export const StatusAndWarnings_Invoicing_ReturnEAWithMissingAddress = new Translation("Return EA with missing address", "", "Returner EA med manglende adresse", "Retur EA med saknad adress");

export const StatusAndWarnings_Invoicing_ReturnEAWithMissingAddressInfo = new Translation("This only applies in Norway. Since there has been an error generated from EA that cannot be handled automatically.", "", "Dette gjelder kun i Norge. Siden det har vært en feil generert fra EA som ikke kan håndteres automatisk.", "Detta gäller endast i Norge. Då det blivit ett fel genererat från EA som inte kan hanteras automatiskt.");

export const StatusAndWarnings_Invoicing_SubscriptionNoNextInvoice = new Translation("Subscription set as \"No next invoice\"", "", "Abonnementer er satt som \"Ikke fakturer\"", "Abonnemang satta som \"Fakturera ej\"");

export const StatusAndWarnings_Invoicing_SubscriptionNoNextInvoiceInfo = new Translation("Subscriptions are set as \"No Next Invoice\". You should make sure that this is correct, otherwise the customer will not get invoiced.", "", "Abonnement er satt til \"Ikke fakturer\". Du bør sørge for at dette er riktig, ellers vil ikke kunden bli fakturert.", "Abonnemang är satt som \"Fakturera ej\". Du bör se till att detta är korrekt, annars kommer kunden inte att faktureras.");

export const StatusAndWarnings_Invoicing_WrongCountryAddress = new Translation("Wrong country address on customer", "", "Feil landadresse på kunden", "Fel landsadress på kunden");

export const StatusAndWarnings_Invoicing_WrongCountryAddressInfo = new Translation("The address \"O1\" is not valid as a mailing address for a customer. It must be changed, otherwise the invoice batch will crash.", "", "Adressen \"O1\" er ikke gyldig som postadresse for en kunde. Det må endres, ellers krasjer faktura-batchen.", "Adressen \"O1\" är inte giltig som postadress på en kund. Det måste ändras, annars kraschar faktura-batchen.");

export const StatusAndWarnings_MortgageStatus_Value = new Translation("Mortgage", "", "Belåning", "Belåning");

export const StatusAndWarnings_MortgageStatus_KK2_MortgageBlocked = new Translation("KK2 mortgage stop", "", "KK2 belåningstopp", "KK2 belåningsstopp");

export const StatusAndWarnings_MortgageStatus_KK2_MortgageBlockedInfo = new Translation("Customers whose credit is stopped (requirement code 2), but have now paid the last three invoices on time. For these customers, lending can be turned on again. This is done by the administrator at AFS.", "", "Kunder som har stanset kreditt (kravkode 2), men som nå har betalt de tre siste fakturaene i tide. For disse kundene kan utlån slås på igjen. Dette gjøres av administrator ved AFS.", "Kunder som är belåningsstoppade (kravkod 2), men nu har betalat de senaste tre fakturorna i tid. För dessa kunder kan belåning slås på igen. Detta görs av handläggaren på AFS.");

export const StatusAndWarnings_Outportations = new Translation("Outportations", "", "Utportasjoner", "Utporteringar");

export const StatusAndWarnings_PaymentDemandChain_Value = new Translation("Demand chain", "", "Kravkedja", "Kravkedja");

export const StatusAndWarnings_PaymentDemandChain_ActiveInvoiceesWithDebtCollection = new Translation("Active customers on debt collection proposals", "", "Aktive kunder på inkassoforslag", "Aktiva kunder på förslag till inkasso");

export const StatusAndWarnings_PaymentDemandChain_ActiveInvoiceesWithReminders = new Translation("Active customers who have received a reminder", "", "Aktive kunder som har fått en påminnelse", "Aktiva kunder som har fått en påminnelse");

export const StatusAndWarnings_PaymentDemandChain_ActiveStoppedClaimsWithUnpaidInvoices = new Translation("Active customers who are suspended and have unpaid invoices", "", "Aktive kunder som er suspendert og har ubetalte fakturaer", "Aktiva kunder som är kravstoppade och har obetalda fakturor");

export const StatusAndWarnings_PaymentDemandChain_ActiveWith1InvoiceDebtsHasPayed = new Translation("Active customers with one invoice at debt collection - has paid before", "", "Aktive kunder med én faktura med inkasso - har betalt før", "Aktiva kunder med en faktura hos inkasso - har betalt tidigare");

export const StatusAndWarnings_PaymentDemandChain_ActiveWith1InvoiceDebtsHasPayedInfo = new Translation("Shows customers who have an invoice in debt collection. The customer has paid at least one previous invoice. Only invoices from the last year.", "", "Viser kunder som har en faktura i inkasso. Kunden har betalt minst én tidligere faktura. Kun fakturaer fra siste år.", "Visar kunder som har en faktura på inkasso. Kunden har betalt minst en tidigare faktura. Endast fakturor från det senaste året.");

export const StatusAndWarnings_PaymentDemandChain_ActiveWith1InvoiceDebtsNotPayed = new Translation("Active customers with one invoice at debt collection - none payed", "", "Aktive kunder med én faktura med inkasso - ingen betalt", "Aktiva kunder med en faktura hos inkasso - ingen betald");

export const StatusAndWarnings_PaymentDemandChain_ActiveWith1InvoiceDebtsNotPayedInfo = new Translation("Shows customers who have an invoice in debt collection. The customer has not paid any previous invoices, i.e. all invoices are unpaid. Only invoices from the last year.", "", "Viser kunder som har en faktura i inkasso. Kunden har ikke betalt noen tidligere fakturaer, det vil si at alle fakturaer er ubetalte. Kun fakturaer fra siste år.", "Visar kunder som har en faktura på inkasso. Kunden har inte betalt någon tidigare faktura, dvs alla fakturor är obetalda. Endast fakturor från det senaste året.");

export const StatusAndWarnings_PaymentDemandChain_ActiveWith2InvoiceDebtsHasPayed = new Translation("Active customers with two invoices at debt collection - has paid before", "", "Aktive kunder med to fakturaer fra inkasso - har betalt før", "Aktiva kunder med två fakturor hos inkasso - har betalt tidigare");

export const StatusAndWarnings_PaymentDemandChain_ActiveWith2InvoiceDebtsHasPayedInfo = new Translation("Shows customers who have two invoices with debt collection. The customer has paid at least one previous invoice. Only invoices from the last year.", "", "Viser kunder som har to fakturaer med inkasso. Kunden har betalt minst én tidligere faktura. Kun fakturaer fra siste år.", "Visar kunder som har två fakturor hos inkasso. Kunden har betalt minst en tidigare faktura. Endast fakturor från det senaste året.");

export const StatusAndWarnings_PaymentDemandChain_ActiveWith2InvoiceDebtsNotPayed = new Translation("Active customers with two invoices at debt collection - none paid", "", "Aktive kunder med to fakturaer ved inkasso - ingen betalt", "Aktiva kunder med två fakturor hos inkasso - ingen betald");

export const StatusAndWarnings_PaymentDemandChain_ActiveWith2InvoiceDebtsNotPayedInfo = new Translation("Shows customers who have two invoices in collection. The customer has not paid any previous invoices, i.e. all invoices are unpaid. Only invoices from the last year.", "", "Viser kunder som har to fakturaer i inkasso. Kunden har ikke betalt noen tidligere fakturaer, det vil si at alle fakturaer er ubetalte. Kun fakturaer fra siste år.", "Visar kunder som har två fakturor på inkasso. Kunden har inte betalt någon tidigare faktura, dvs alla fakturor är obetalda. Endast fakturor från det senaste året.");

export const StatusAndWarnings_PaymentDemandChain_ActiveWithManyInvoiceDebts = new Translation("Active customers with three or more invoices in debt collection", "", "Aktive kunder med tre eller flere fakturaer i inkasso", "Aktiva kunder med tre eller fler fakturor hos inkasso");

export const StatusAndWarnings_PaymentDemandChain_AllInvoiceeWithTwoOrMoreDebtcollection = new Translation("All customers with two or more invoices in debt collection", "", "Alle kunder med to eller flere fakturaer i inkasso", "Alla kunder med två eller fler fakturor hos inkasso");

export const StatusAndWarnings_PaymentDemandChain_CancelledStoppedClaimsWithUnpaidInvoices = new Translation("Inactive customers who are suspended and have unpaid invoices", "", "Oppsagte kunder som er suspendert og har ubetalte fakturaer", "Avslutade kunder som är kravstoppade och har obetalda fakturor");

export const StatusAndWarnings_PaymentDemandChain_Info = new Translation("Only invoices from the last year.", "", "Kun fakturaer fra siste år.", "Endast fakturor från det senaste året.");

export const StatusAndWarnings_PaymentDemandChain_InvoiceesNonMonthlyWith1MoreDebts = new Translation("Active customers who pay for 3, 6 or 12 months with one or more invoices from debt collection", "", "Aktive kunder som betaler i 3, 6 eller 12 måneder med en eller flere fakturaer fra inkasso", "Aktiva kunder som betalar 3,6 eller 12 månader med en eller flera fakturor hos inkasso");

export const StatusAndWarnings_PaymentDemandChain_InvoiceesWithEnddate = new Translation("Customers with an end date with one or more invoices at debt collection", "", "Kunder med sluttdato med en eller flere fakturaer ved inkasso", "Kunder med avslutdatum med en eller fler fakturor hos inkasso");

export const StatusAndWarnings_Portations = new Translation("Portations", "", "Portasjoner", "Porteringar");

export const StatusAndWarnings_StatusAndWarnings = new Translation("Status and warnings", "", "Status og advarsler", "Status och varningar");

export const StatusAndWarnings_SubscriptionsAndFees_Value = new Translation("Subscriptions and Fees", "", "Abonnementer og avgifter", "Abonnemang och avgifter");

export const StatusAndWarnings_SubscriptionsAndFees_ActiveWithNoFees = new Translation("Active subscriptions without fees", "", "Aktive abonnementer uten avgifter", "Aktiva abonnemang utan avgifter");

export const StatusAndWarnings_SubscriptionsAndFees_ManyNegativeFees = new Translation("Many negative fees", "", "Mange negative avgifter", "Många negativa avgifter");

export const StatusAndWarnings_SubscriptionsAndFees_OnlyNegativeFees = new Translation("Only negative fees", "", "Kun negative avgifter", "Endast negativa avgifter");

export const StatusAndWarnings_SubscriptionsAndFees_PendingNoFeesNoStartDate = new Translation("Pending subscription without fees and without a start date", "", "Avventende abonnement uten gebyrer og uten startdato", "Väntande abonnemang utan avgifter och utan startdatum");

export const StatusAndWarnings_SubscriptionsAndFees_PendingNoFeesWithStartDate = new Translation("Pending subscription without fees with start date", "", "Avventende abonnement uten gebyrer med startdato", "Väntande abonnemang utan avgifter men med startdatum");

export const StatusAndWarnings_Telecom_Value = new Translation("Telecom", "", "Telecom", "Telekom");

export const StatusAndWarnings_Telecom_ActiveMobileNoFees = new Translation("Active mobile mobile subscriptions without fees", "", "Aktive mobilabonnement uten avgifter", "Aktiva mobila mobilabonnemang utan avgifter");

export const StatusAndWarnings_Telecom_ActiveMobileNoFeesInfo = new Translation("Show active numbers in Fenix and the net that doesnt have any active subscription.", "", "Vis aktive numre i Fenix og nettet som ikke har noe aktivt abonnement.", "Visa aktiva nummer i Fenix och nätet som inte har något aktivt abonnemang.");

export const StatusAndWarnings_Telecom_ActiveTabIpNoFees = new Translation("Active tab and IP numbers without fees", "", "Aktiva tab- og ipnummer uten avgifter", "Aktiva tab- och ipnummer utan avgifter");

export const StatusAndWarnings_Telecom_ActiveTabIpNoFeesInfo = new Translation("Shows active tab and ip numbers in the network that do not have active fees.", "", "Viser aktive fane- og ip-numre i nettverket som ikke har aktive avgifter", "Visar aktiva tab- och ip-nummer i nätet som inte har aktiva avgifter.");

export const StatusAndWarnings_Telecom_ActiveTrafficRedirectsNoActiveNumber = new Translation("Active Traffic Redirects without an active number", "", "Aktive trafikkomdirigeringer uten et aktivt nummer", "Aktiva Traffic Redirects utan aktivt nummer");

export const StatusAndWarnings_Telecom_ActiveTrafficRedirectsNoActiveNumberInfo = new Translation("Shows active traffic redirects that don\u0027t have an active number. They should be removed.", "", "Viser aktive trafikkomdirigeringer som ikke har et aktivt nummer. De bør fjernes.", "Visar aktiva Traffic Redirects som inte har ett aktivt nummer. De bör tas bort.");

export const StatusAndWarnings_Telecom_MissingSnpacPortations = new Translation("Missing portations", "", "Manglende porter", "Saknade porteringar");

export const StatusAndWarnings_Telecom_MissingSnpacPortationsInfo = new Translation("If there are portations that are not registered in Fenix, they need to be handled. Only applies to SNPAC.", "", "Hvis det er portasjoner som ikke er registrert i Fenix, må de håndteres. Gjelder kun SNPAC.", "Finns det porteringar som inte är registrerade i Fenix behöver de hanteras. Gäller endast SNPAC.");

export const StatusAndWarnings_Waiting = new Translation("Waiting", "", "Venter", "Väntande");

export const StatusAndWarnings_WaitingInfo = new Translation("All waiting inportations.", "", "Alle ventende inportasjoner.", "Alla väntande inporteringar.");

export const StatusAndWarnings_WaitingNextWeekday = new Translation("Waiting for next weekday", "", "Venter på neste ukedag", "Väntande till nästa veckodag");

export const StatusAndWarnings_WaitingNextWeekdayInfo = new Translation("All portations that will come the next weekday/porting day.", "", "Alle porteringer som kommer neste ukedag/porteringsdag.", "Alla porteringar som kommer nästa vardag/porteringsdag.");

export const StopMortgage = new Translation("Stop mortgage", "", "Stopp belåning", "Stoppa belåning för kund");

export const SubscriptionCreated = new Translation("Created", "", "Abonnement utformet", "Abonnemang skapat...");

export const Subscriptions = new Translation("Subscriptions", "", "Abonnement", "Abonnemang");

export const SubscriptionType = new Translation("Type", "", "Abonnement", "Abonnemangstyp");

export const Suspense_ActionTaken = new Translation("Action taken", "", "Handlingen er nå utført", "Åtgärd utförd");

export const Suspense_ActivePeriodWillChange = new Translation("The Active Period will be changed for contract", "", "Den Aktiva Perioden vil endres for kontrakt", "Den Aktiva Perioden kommer att ändras för kontrakt");

export const Suspense_ChangeActivePeriod = new Translation("Do you want to change the Active Period for contract", "", "Ønsker du å endre aktiv periode for kontrakt", "Vill du ändra den Aktiva Perioden för kontrakt");

export const Suspense_Consequences = new Translation("This means that the traffic will be tied to contract", "", "Det betyr at trafikken blir bundet til kontrakt", "Detta innebär att trafiken kommer att knytas till kontrakt");

export const Suspense_CouldNotFindData = new Translation("Could not find suspense for the selected date/filter.", "", "Kunne ikke finne suspense for valgt dato/filter.", "Kunde inte hitta suspens för det valda datumet/filtret.");

export const Suspense_DownloadToExcel = new Translation("Download full report to Excel for the selected period", "", "Hent full rapport til Excel for valgt periode", "Hämta full rapport till Excel för vald period");

export const Suspense_Fix = new Translation("Fix", "", "Rett opp", "Åtgärda");

export const Suspense_Heading = new Translation("Suspense", "", "Suspens", "Suspens");

export const Suspense_Heading2 = new Translation("The cost is indicative and is based on CDR data", "", "Kostnaden er veiledende og er basert på CDR-data", "Kostnaden är indikativ och baseras på CDR data");

export const Suspense_ImsiContracted1 = new Translation("This IMSI", "", "Denne IMSI", "Detta IMSI");

export const Suspense_ImsiContracted2 = new Translation("was contracted during the following Active Period", "", "ble inngått i løpet av den følgende aktive perioden", "var kontrakterad under följande Aktiva Period");

export const Suspense_MissingInformation = new Translation("Information about this contract is missing from our systems. Contact support-sbs@svea.com and we may be able to help you.", "", "Informasjon om denne kontrakten mangler i våre systemer. Ta kontakt med support-sbs@svea.com så kan vi kanskje hjelpe deg.", "Information om detta kontrakt saknas i våra system. Kontakta support-sbs@svea.com så kanske vi kan hjälpa er.");

export const Suspense_NoCorrection1 = new Translation("No possible fix found.", "", "Finner ingen mulig løsning.", "Hittade ingen möjlig korrigering.");

export const Suspense_NoCorrection2 = new Translation("This may be because you have already corrected this line.", "", "Dette kan være fordi du allerede har rettet denne linjen.", "Detta kan bero på att du redan har korrigerat denna rad.");

export const Suspense_NoCorrection3 = new Translation("Synchronization takes place once per day", "", "Synkronisering skjer én gang per dag", "Synkronisering sker dygnsvis");

export const Suspense_Search = new Translation("Search phone number/IMSI/date", "", "Søk etter telefonnummer/IMSI/dato", "Sök telefonnummer/IMSI/datum");

export const Suspense_TableHeading_From = new Translation("From", "", "Fra", "Tidigaste trafik");

export const Suspense_TableHeading_NoPosts = new Translation("Number of posts", "", "Antall poster", "Antal poster");

export const Suspense_TableHeading_Phonenumber = new Translation("Phonenumber", "", "Telefonnummer", "Telefonnummer");

export const Suspense_TableHeading_Port = new Translation("Port/Contract", "", "Port/avtale", "Port/avtal");

export const Suspense_TableHeading_To = new Translation("To", "", "Til", "Senaste trafik");

export const Suspense_TableHeading_TotalAmount = new Translation("Total amount", "", "Total kostnad", "Total kostnad");

export const Suspense_TrafficHappened1 = new Translation("But traffic has taken place", "", "Men trafikken har skjedd", "Men trafik har skett");

export const Suspense_TrafficHappened2 = new Translation("the end date of the contract. Specifically", "", "sluttdatoen for kontrakten. Nærmere bestemt", "kontraktets sludatum. Specifikt");

export const TelephonyProduct = new Translation("Telephony Produkt", "", "Telefonprodukt", "Telefonprodukt");

export const TermsOfPayment = new Translation("Payment terms ", "", "Betalingsvilkår", "Betalningsvillkor");

export const ThisFieldIsRequired = new Translation("Required field", "", "Feltet er obligatorisk", "Det här fältet är obligatoriskt");

export const Time = new Translation("Time", "", "Tid", "Tid");

export const To = new Translation("To", "", "Til", "Till");

export const ToggleTrafficSpecification = new Translation("Show/hide history", "", "Vis forbrukshistorikk/samtalespesifikasjon", "Visa/dölj samtalsspecifikation");

export const Total = new Translation("Total", "", "Total", "Totalt");

export const TrafficSpecification = new Translation("Telephone specification", "", "Samtalespesifikasjon", "Samtalsspecifikation");

export const TransferContract = new Translation("Transfer contract", "", "Overfør kontrakt", "Överför kontrakt");

export const Translations_Add = new Translation("Add", "", "Legge...", "Lägg till...");

export const Translations_Id = new Translation("Id", "", "Ressurs id", "ResursId");

export const Type = new Translation("Type", "", "Type", "Typ");

export const UnitAmount = new Translation("Amount", "", "Mengde", "Mängd");

export const Units = new Translation("Units", "", "Enheter", "Enheter");

export const UntilFutherNotice = new Translation("Until further notice", "", "Inntil videre", "Tills vidare");

export const Validation_Character = new Translation("character", "", "tegn", "tecken");

export const Validation_Characters = new Translation("characters", "", "tegn", "tecken");

export const Validation_DisallowedCharacters = new Translation("The field contains disallowed characters", "", "Feltet inneholder ulovlige tegn", "Fältet innehåller otillåtna tecken");

export const Validation_Empty = new Translation("This field cannot be empty.", "", "Dette feltet må ikke stå tomt.", "Detta fält får inte vara tomt.");

export const Validation_EmptyOrRange1To31 = new Translation("The field can be empty or only contain integers range of 1 to 31", "", "Feltet kan være tomt eller bare inneholde heltall fra 1 til 31", "Fältet kan vara tomt eller bara innehålla heltal från 1 till 31");

export const Validation_FieldAtLeast = new Translation("The field must contain at least", "", "Feltet må inneholde minst", "Fältet måste innehålla minst");

export const Validation_FieldEqual = new Translation("The field must contain exactly", "", "Feltet må inneholde nøyaktig", "Fältet måste innehålla exakt");

export const Validation_FieldLimitMax = new Translation("The field is limited to max", "", "Feltet er begrenset til et maksimum", "Fältet är begränsat till högst");

export const Validation_Letter = new Translation("letter", "", "bokstav", "bokstav");

export const Validation_Letters = new Translation("letters", "", "bokstaver", "bokstäver");

export const Validation_LongDateFormat = new Translation("The field must be in the following format: \u00272022-10-24 21:10:45\u0027", "", "Feltet må ha følgende format: \u00272022-10-24 21:10:45\u0027", "Fältet måste vara på följande format: \u00272022-10-24 21:10:45\u0027");

export const Validation_MustBeEmpty = new Translation("This field must be empty", "", "Dette feltet må være tomt", "Detta fält måste vara tomt");

export const Validation_Number = new Translation("number", "", "tall", "siffra");

export const Validation_Numbers = new Translation("numbers", "", "tall", "siffror");

export const Validation_One = new Translation("one", "", "en", "en");

export const Validation_OneAlt = new Translation("one", "", "en", "ett");

export const Validation_OnlyIntegers = new Translation("The field can only contain integers", "", "Feltet kan bare inneholde heltall", "Fältet får bara innehålla heltal");

export const Validation_OnlyLettersSpaces = new Translation("The field can only contain letters and spaces.", "", "Feltet kan bare inneholde bokstaver og mellomrom.", "Fältet får bara innehålla bokstäver och mellanslag.");

export const Validation_OnlyNumbers = new Translation("The field can only contain numbers.", "", "Feltet kan bare inneholde tall.", "Fältet får bara innehålla siffror.");

export const Validation_PlainText = new Translation("Text contains unsupported character: ", "", "Teksten inneholder tegn som ikke støttes: ", "Texten innehåller tecken som inte stöds: ");

export const Validation_ShortDateFormat = new Translation("The field must be in the following format: \u00272022-10-24\u0027", "", "Feltet må ha følgende format: \u00272022-10-24\u0027", "Fältet måste vara på följande format: \u00272022-10-24\u0027");

export const Validation_SQLBoolean = new Translation("The field must have the value \u00270\u0027 (false) or \u00271\u0027 (true)", "", "Feltet må ha verdien \u00270\u0027 (false) eller \u00271\u0027 (true)", "Fältet måste ha värdet \u00270\u0027 (falskt) eller \u00271\u0027 (sant)");

export const Validation_UnsupportedNumberFormat = new Translation("Could not validate against expected format", "", "Kunne ikke validere mot forventet format", "Kunde inte validera mot förväntat format");

export const Validation_ValidEmail = new Translation("The field must contain a valid e-mail address", "", "Feltet må inneholde en gyldig e-postadresse", "Fältet måste innehålla en giltig e-postadress");

export const Validation_ValidPeppol = new Translation("The field must contain a valid Peppol ID", "", "Feltet må inneholde en gyldig Peppol ID", "Fältet måste innehålla ett giltigt Peppol ID");

export const Value = new Translation("Value", "", "Verdi", "Värde");

export const VAT = new Translation("VAT ", "", "MVA", "Moms");

export const WantedPassword_Value = new Translation("Wanted Password", "", "Ønsket passord", "Önskat Lösenord");

export const WantedPassword_PlaceHolder = new Translation("Add your password (min 5 characters)", "", "Oppgi ønsket passord (minst 5 tegn)", "Ange önskat lösenord (minst 5 tecken)");

export const WantedUsername_Value = new Translation("Wanted  username", "", "Ønsket brukernavn", "Önskat användarnamn");

export const WantedUsername_PlaceHolder = new Translation("Add your username (min 4 characters)", "", "Oppgi ønsket brukernavn (minst 4 tegn)", "Ange önskat användarnamn (minst 4 tecken)");

export const WasActiveFrom = new Translation("Active since", "", "Aktiv fra", "Var aktivt från");

export const Yes = new Translation("Yes", "", "Ja", "Ja");

